
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("2mPLm", function(module, exports) {
$parcel$export(module.exports, "getObjectIconUrl", () => $3468a1770df5637e$export$bcf275804417edda);
const $3468a1770df5637e$export$bcf275804417edda = (details)=>{
    if (details !== null && details !== void 0 && details.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};

});

parcelRegister("4B3E4", function(module, exports) {
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $979d3530cd2611c4$export$6c837641a9ab03cb);
const $979d3530cd2611c4$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';

});

parcelRegister("6n63z", function(module, exports) {
$parcel$export(module.exports, "default", () => $91dc38a6de867be4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4B3E4 = parcelRequire("4B3E4");
// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $91dc38a6de867be4$var$ROOT_MARGIN_VERTICAL = '360px';
const $91dc38a6de867be4$var$useIntersectionObserver = ({ onIntersecting: onIntersectingCallback, onIntersection: onIntersectionCallback })=>{
    const ref = (0, $bSJIT.useRef)(null);
    const onIntersectingCallbackRef = (0, $bSJIT.useRef)(onIntersectingCallback);
    const onIntersectionCallbackRef = (0, $bSJIT.useRef)(onIntersectionCallback);
    (0, $bSJIT.useEffect)(()=>{
        onIntersectingCallbackRef.current = onIntersectingCallback;
        onIntersectionCallbackRef.current = onIntersectionCallback;
    }, [
        onIntersectingCallback,
        onIntersectionCallback
    ]);
    const onIntersection = (0, $bSJIT.useCallback)((entries, observer)=>{
        var _onIntersectionCallba;
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        (_onIntersectionCallba = onIntersectionCallbackRef.current) === null || _onIntersectionCallba === void 0 || _onIntersectionCallba.call(onIntersectionCallbackRef, isIntersecting);
        if (isIntersecting) {
            var _onIntersectingCallba;
            (_onIntersectingCallba = onIntersectingCallbackRef.current) === null || _onIntersectingCallba === void 0 || _onIntersectingCallba.call(onIntersectingCallbackRef);
            observer.disconnect();
        }
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        if (!(0, $4B3E4.isIntersectionObserverSupported)() || !ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$91dc38a6de867be4$var$ROOT_MARGIN_VERTICAL} 0px ${$91dc38a6de867be4$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    return ref;
};
var $91dc38a6de867be4$export$2e2bcd8739ae039 = $91dc38a6de867be4$var$useIntersectionObserver;

});

parcelRegister("9J111", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkSeenEvent", () => $d59d7cd6e215c242$export$c721b83ca330cb86);

var $bSJIT = parcelRequire("bSJIT");

var $2fwRK = parcelRequire("2fwRK");

var $1DuNk = parcelRequire("1DuNk");

var $83rwn = parcelRequire("83rwn");
function $d59d7cd6e215c242$export$c721b83ca330cb86({ appearance: appearance, children: children, id: id, ui: ui, url: url = '' }) {
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const { getByUrl: getByUrl } = (0, $1DuNk.useSmartLinkAnalyticsUtils)();
    const getAnalyticsProps = (0, $bSJIT.useCallback)(()=>{
        const isFlexibleUi = (0, $83rwn.isFlexibleUiCard)(children, ui);
        const display = isFlexibleUi ? 'flexible' : appearance;
        return {
            display: display,
            id: id
        };
    }, [
        appearance,
        children,
        id,
        ui
    ]);
    const statusRef = (0, $bSJIT.useRef)();
    const analyticsPropsRef = (0, $bSJIT.useRef)(null);
    const hasIntersectedRef = (0, $bSJIT.useRef)(false);
    const hasFiredSeenRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        analyticsPropsRef.current = getAnalyticsProps();
    }, [
        getAnalyticsProps
    ]);
    const maybeFireSeenEvent = (0, $bSJIT.useCallback)(()=>{
        if (!hasFiredSeenRef.current && hasIntersectedRef.current && statusRef.current === 'unauthorized') {
            const payload = getByUrl(url, analyticsPropsRef.current);
            fireEvent('ui.smartLink.seen', payload === null || payload === void 0 ? void 0 : payload.attributes);
            hasFiredSeenRef.current = true;
        }
    }, [
        fireEvent,
        getByUrl,
        url
    ]);
    const onIntersecting = (0, $bSJIT.useCallback)(()=>{
        if (hasIntersectedRef.current) return;
        hasIntersectedRef.current = true;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    const onStatusSettled = (0, $bSJIT.useCallback)((status)=>{
        statusRef.current = status;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            onIntersecting: onIntersecting,
            onStatusSettled: onStatusSettled
        }), [
        onIntersecting,
        onStatusSettled
    ]);
}

});
parcelRegister("1DuNk", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsUtils", () => $50c2873e997fdfce$export$853798cf89e90693);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");

var $bLV8M = parcelRequire("bLV8M");

var $8AAWw = parcelRequire("8AAWw");
const $50c2873e997fdfce$export$853798cf89e90693 = ()=>{
    const { store: store } = (0, $6bOBo.useSmartLinkContext)();
    const getByUrl = (0, $bSJIT.useCallback)((url, props)=>{
        const state = store ? (0, $bLV8M.getUrl)(store, url) : undefined;
        return (0, $8AAWw.getSmartLinkAnalyticsContext)({
            display: props === null || props === void 0 ? void 0 : props.display,
            id: props === null || props === void 0 ? void 0 : props.id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: props === null || props === void 0 ? void 0 : props.source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        store
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            getByUrl: getByUrl
        }), [
        getByUrl
    ]);
};

});


parcelRegister("3Vl0U", function(module, exports) {
$parcel$export(module.exports, "default", () => $a30ae7dabb9af7f5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $a30ae7dabb9af7f5$var$CardLoaderWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ appearance: appearance, children: children }, ref)=>{
    const Component = appearance === 'inline' ? 'span' : 'div';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
        className: "loader-wrapper",
        ref: ref
    }, children));
});
var $a30ae7dabb9af7f5$export$2e2bcd8739ae039 = $a30ae7dabb9af7f5$var$CardLoaderWrapper;

});

parcelRegister("8l4nR", function(module, exports) {
$parcel$export(module.exports, "CardWithUrlContent", () => $6f7a3d3e26fb2500$export$7598f5d7c597dd32);
$parcel$export(module.exports, "CardWithUrl", () => $6f7a3d3e26fb2500$export$d4ee8167ac732647);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $dWNt9 = parcelRequire("dWNt9");

var $6bOBo = parcelRequire("6bOBo");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $dXrim = parcelRequire("dXrim");

var $6Wkby = parcelRequire("6Wkby");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $5BiUr = parcelRequire("5BiUr");

var $aihc7 = parcelRequire("aihc7");

var $2mPLm = parcelRequire("2mPLm");

var $6FJC6 = parcelRequire("6FJC6");

var $2lrWO = parcelRequire("2lrWO");

var $bIXTN = parcelRequire("bIXTN");

var $9Ttmg = parcelRequire("9Ttmg");

var $7jLk8 = parcelRequire("7jLk8");

var $bL9UM = parcelRequire("bL9UM");

var $fsR84 = parcelRequire("fsR84");

var $iTFEF = parcelRequire("iTFEF");

var $jI45q = parcelRequire("jI45q");

var $4X9VT = parcelRequire("4X9VT");

var $jnYkh = parcelRequire("jnYkh");

var $b7ugw = parcelRequire("b7ugw");

var $aiGES = parcelRequire("aiGES");

var $s9hBp = parcelRequire("s9hBp");

var $2x5KE = parcelRequire("2x5KE");

var $83rwn = parcelRequire("83rwn");

var $qHDjo = parcelRequire("qHDjo");

var $hNqc2 = parcelRequire("hNqc2");

var $lRg5h = parcelRequire("lRg5h");

var $k27DD = parcelRequire("k27DD");

var $4zpBM = parcelRequire("4zpBM");

var $b9JE8 = parcelRequire("b9JE8");

var $2HRtR = parcelRequire("2HRtR");

var $dkOB1 = parcelRequire("dkOB1");

var $5hBRh = parcelRequire("5hBRh");

var $g3zfH = parcelRequire("g3zfH");

var $42OOk = parcelRequire("42OOk");

var $l4Eiq = parcelRequire("l4Eiq");
const $6f7a3d3e26fb2500$var$thirdPartyARIPrefix = 'ari:third-party';
function $6f7a3d3e26fb2500$var$Component({ id: id, url: url, title: title, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    let isFlexibleUi = (0, $bSJIT.useMemo)(()=>(0, $83rwn.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    // appearance is pre-resolved by the caller (loader.tsx for Card, ssr.tsx for CardSSR):
    // FlexibleCards are always passed appearance='block' when FG is on, so component.tsx
    // simply consumes whatever appearance it receives.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $bL9UM.useSmartLink)(id, url, appearance);
    const { linkNavigation: linkNavigation } = (0, $6bOBo.useSmartLinkContext)();
    const resolveNavigation = (0, $gdUUy.fg)('confluence_ep_shim_macro_links_v2') && isFlexibleUi ? linkNavigation : undefined;
    const ari = (0, $aihc7.getObjectAri)(state.details);
    const name = (0, $6FJC6.getObjectName)(state.details);
    const definitionId = (0, $3p1gi.getDefinitionId)(state.details);
    const extensionKey = (0, $gy3md.getExtensionKey)(state.details);
    const resourceType = (0, $2lrWO.getResourceType)(state.details);
    const services = (0, $bIXTN.getServices)(state.details);
    const thirdPartyARI = (0, $9Ttmg.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $5BiUr.getFirstPartyIdentifier)();
    const appendCrossProductAnalyticsParams = (0, $7jLk8.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const actionOptions = (0, $jI45q.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // TODO: [ZS] Add new experiment flag to determine if the Rovo Actions CTA should be shown
    const rovoActionsCtaShown = false;
    const fire3PClickEvent = (0, $g3zfH.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI);
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = thirdPartyARI && thirdPartyARI.startsWith($6f7a3d3e26fb2500$var$thirdPartyARIPrefix) && (0, $6Wkby.getClickUrl)(url, state.details) === url && fire3PClickEvent;
    const getDestinationUrl = (0, $bSJIT.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $6Wkby.getClickUrl)(url, state.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        state.details,
        url
    ]);
    const navigation = (0, $bSJIT.useMemo)(()=>resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()), [
        getDestinationUrl,
        resolveNavigation
    ]);
    // Setup UI handlers.
    const handleClickWrapper = (0, $bSJIT.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $lRg5h.isSpecialKey)(event) || (0, $qHDjo.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5kJPq.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (shouldFire3PClickEvent) // For questions or concerns about this event,
        // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
        fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent();
        // FIXME: InlineCard, BlockCard and EmbedCard call event.preventDefault() internally
        // before the event bubbles up to this handler. This forces us to snapshot
        // event.defaultPrevented before calling onClick to detect whether the consumer
        // specifically prevented navigation. Ideally those components should not call
        // preventDefault so this workaround can be removed.
        const isEventDefaultPrevented = event.defaultPrevented;
        const canOpenPreviewPanel = !isModifierKeyPressed && ari && name && openPreviewPanel && (isPreviewPanelAvailable === null || isPreviewPanelAvailable === void 0 ? void 0 : isPreviewPanelAvailable({
            ari: ari
        })) && !disablePreviewPanel;
        // Preview panel takes priority over link navigation when available.
        if (canOpenPreviewPanel) {
            var _extractSmartLinkEmbe;
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $2mPLm.getObjectIconUrl)(state.details),
                panelData: {
                    embedUrl: (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (_extractSmartLinkEmbe = (0, $dWNt9.extractSmartLinkEmbed)(state.details)) === null || _extractSmartLinkEmbe === void 0 ? void 0 : _extractSmartLinkEmbe.src : undefined
                }
            });
            (0, $4X9VT.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        }
        const destinationUrl = (resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()).url) ?? getDestinationUrl();
        (0, $4zpBM.updateAnchorHref)(event, destinationUrl);
        // For FlexibleCard, read target from the clicked anchor element (e.g. _blank for links
        // rendered with explicit target). For classic cards, default to _self
        const { target: anchorTarget } = (0, $aiGES.getAnchorAttributesFromEvent)(event);
        const openInNewTab = resolveNavigation ? event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1 : (0, $hNqc2.isSpecialEvent)(event);
        const target = openInNewTab ? '_blank' : isFlexibleUi ? anchorTarget : '_self';
        onClick === null || onClick === void 0 || onClick(event, {
            url: url,
            destinationUrl: destinationUrl
        });
        // Check if the event is prevented via onClick callback
        const consumerPreventedNavigation = event.defaultPrevented && !isEventDefaultPrevented;
        // Classic cards (InlineCard, BlockCard, EmbedCard) rely on their own anchor navigation
        // when onClick is provided, so this handler should not open the link for them.
        // FlexibleCard's anchor is prevented from native navigation, so this handler always
        // opens the link for FlexibleCard unless the consumer's onClick called preventDefault.
        const shouldOpenLink = isFlexibleUi || !onClick;
        const doOpenLink = shouldOpenLink && !consumerPreventedNavigation;
        if (doOpenLink) {
            event.preventDefault();
            window.open(destinationUrl, target);
        }
        // Only set clickOutcome when this handler actually opened the link.
        // If a parent onClick handled navigation, fire a generic click event instead.
        (0, $4X9VT.fireLinkClickedEvent)(createAnalyticsEvent)(event, doOpenLink ? {
            attributes: {
                clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
            }
        } : undefined);
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        getDestinationUrl,
        resolveNavigation,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        shouldFire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        disablePreviewPanel
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameAuxClick = (0, $bSJIT.useCallback)((event)=>{
        const destinationUrl = (resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()).url) ?? getDestinationUrl();
        (0, $4zpBM.updateAnchorHref)(event, destinationUrl);
        // isAuxClick filters Windows right-clicks (button === 2) that also fire onAuxClick.
        if ((0, $2x5KE.isAuxClick)(event) && shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent,
        resolveNavigation
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameContextMenu = (0, $bSJIT.useCallback)((event)=>{
        const destinationUrl = (resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()).url) ?? getDestinationUrl();
        (0, $4zpBM.updateAnchorHref)(event, destinationUrl);
        if (shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent,
        resolveNavigation
    ]);
    const { reload: reload } = actions;
    const handleAuthorize = (0, $bSJIT.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $bSJIT.useCallback)(()=>{
        reload();
    }, [
        reload
    ]);
    const hasMounted = (0, $bSJIT.useRef)(false);
    const prevAppearance = (0, $bSJIT.useRef)(appearance);
    // When appearance changes from inline to non-inline on a mounted card
    // (e.g. direct consumer changes inline → block/embed), reload with the new appearance
    // so ORS can return the appropriate full data. We intentionally do NOT reload on
    // block → embed or embed → block transitions since both already have full ORS data.
    (0, $bSJIT.useEffect)(()=>{
        if (!hasMounted.current) {
            hasMounted.current = true;
            prevAppearance.current = appearance;
            return;
        }
        if (prevAppearance.current === 'inline' && appearance !== 'inline' && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization')) reload(appearance);
        prevAppearance.current = appearance;
    }, [
        appearance,
        reload
    ]);
    const handleInvoke = (0, $bSJIT.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    const experimentMetaEventAttributes = (0, $l4Eiq.default)({
        actionOptions: actionOptions,
        appearance: appearance,
        state: state
    });
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $bSJIT.useEffect)(()=>{
        (0, $k27DD.mark)(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            (0, $b7ugw.create)(id, state.status);
            if (state.status === 'resolved') {
                var _getMeasure;
                fireEvent('operational.smartLink.resolved', {
                    definitionId: definitionId ?? null,
                    duration: ((_getMeasure = (0, $s9hBp.getMeasure)(id, state.status)) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) ?? null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $fsR84.isFinalState)(state.status)) {
            (0, $dXrim.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $dXrim.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance,
                ...appearance === 'inline' && {
                    rovoActionsCtaShown: rovoActionsCtaShown
                },
                ...experimentMetaEventAttributes && {
                    experimentMeta: experimentMetaEventAttributes
                }
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        rovoActionsCtaShown,
        state.status,
        experimentMetaEventAttributes
    ]);
    const onIframeDwell = (0, $bSJIT.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $bSJIT.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'focus'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseEnter = (0, $bSJIT.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseenter'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseLeave = (0, $bSJIT.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseleave'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if ((error === null || error === void 0 ? void 0 : error.name) === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dkOB1.default), {
            id: id,
            cardState: cardState,
            navigation: navigation,
            placeholderData: placeholderData,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            onAuxClick: handleFrameAuxClick,
            onContextMenu: handleFrameContextMenu,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            title: title,
            testId: testId,
            onResolve: onResolve,
            onError: onError
        }, children);
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5hBRh.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b9JE8.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2HRtR.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $6f7a3d3e26fb2500$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $83rwn.isFlexibleUiCard)(props.children, props === null || props === void 0 ? void 0 : props.ui) ? (0, $5kJPq.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iTFEF.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnYkh.SmartLinkAnalyticsContext), {
        url: props.url,
        id: props.id,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6f7a3d3e26fb2500$var$Component, props)));
};
const $6f7a3d3e26fb2500$export$d4ee8167ac732647 = (0, $42OOk.default)($6f7a3d3e26fb2500$export$7598f5d7c597dd32);

});
parcelRegister("aihc7", function(module, exports) {
$parcel$export(module.exports, "getObjectAri", () => $5c171a76444ffd16$export$81164c1570bcd038);
const $5c171a76444ffd16$export$81164c1570bcd038 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;

});

parcelRegister("6FJC6", function(module, exports) {
$parcel$export(module.exports, "getObjectName", () => $42238ffba3eb5357$export$5615361d76a8be5);
const $42238ffba3eb5357$export$5615361d76a8be5 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'name' in details.data && details.data.name || undefined;

});

parcelRegister("bL9UM", function(module, exports) {
$parcel$export(module.exports, "useSmartLink", () => $19e307d9d78ad6b8$export$9f4e486b1dc3e700);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");

var $gdUUy = parcelRequire("gdUUy");

var $2JDIg = parcelRequire("2JDIg");

var $f4k7l = parcelRequire("f4k7l");

var $4zQGY = parcelRequire("4zQGY");

var $2TtjQ = parcelRequire("2TtjQ");
function $19e307d9d78ad6b8$export$9f4e486b1dc3e700(id, url, appearance) {
    const state = (0, $2TtjQ.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $6bOBo.useSmartLinkContext)();
    const actions = (0, $2JDIg.useSmartCardActions)(id, url);
    const config = (0, $f4k7l.useSmartLinkConfig)();
    const renderers = (0, $4zQGY.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $bSJIT.useState)(null);
    // Register the current card with appearance hint for optimized ORS response.
    const register = ()=>{
        actions.register((0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization') ? appearance : undefined).catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $bSJIT.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        isPreviewRestricted: (0, $gdUUy.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("f4k7l", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkConfig", () => $382434988a679882$export$5d10838c1e539409);

var $6bOBo = parcelRequire("6bOBo");
const $382434988a679882$export$5d10838c1e539409 = ()=>{
    const context = (0, $6bOBo.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("fsR84", function(module, exports) {
$parcel$export(module.exports, "isFinalState", () => $f25491b05f88a74d$export$d590d08942abc17a);
const $f25491b05f88a74d$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};

});

parcelRegister("jI45q", function(module, exports) {
$parcel$export(module.exports, "combineActionOptions", () => $1335dd1545b4f17a$export$2ae4cf79c720146a);
const $1335dd1545b4f17a$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("b9JE8", function(module, exports) {
$parcel$export(module.exports, "BlockCard", () => $c7b8397618bf9e08$export$d18ccd25c0d2c6b0);

var $bSJIT = parcelRequire("bSJIT");

var $1qPbZ = parcelRequire("1qPbZ");

var $itDUP = parcelRequire("itDUP");

var $jPT4k = parcelRequire("jPT4k");

var $9Nf0e = parcelRequire("9Nf0e");

var $j33qf = parcelRequire("j33qf");

var $9IiOQ = parcelRequire("9IiOQ");

var $jNKc2 = parcelRequire("jNKc2");

var $cJnp7 = parcelRequire("cJnp7");

var $bHb8x = parcelRequire("bHb8x");

var $k8BC0 = parcelRequire("k8BC0");
const $c7b8397618bf9e08$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "smart-card-block-card"
    }), children);
const $c7b8397618bf9e08$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $9Nf0e.handleClickCommon)(event, handleFrameClick),
        onAuxClick: handleFrameAuxClick,
        onContextMenu: handleFrameContextMenu,
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $itDUP.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c7b8397618bf9e08$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bHb8x.default), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            }));
        case 'resolved':
            if ((0, $jPT4k.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k8BC0.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bHb8x.default), blockCardProps);
        case 'unauthorized':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k8BC0.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNKc2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJnp7.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j33qf.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9IiOQ.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("itDUP", function(module, exports) {
$parcel$export(module.exports, "useControlDataExportConfig", () => $8a478080cc25001e$export$f93c47f1b2b3f55b);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");
const $8a478080cc25001e$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $6bOBo.useSmartLinkContext)();
    return (0, $bSJIT.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("jPT4k", function(module, exports) {
$parcel$export(module.exports, "getIsDataExportEnabled", () => $8ce7136cf5213260$export$a019611f39785186);
const $8ce7136cf5213260$export$a019611f39785186 = (shouldControlDataExport = false, response)=>{
    var _response$meta;
    return Boolean(shouldControlDataExport && (response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.supportedFeature) === null || _response$meta === void 0 ? void 0 : _response$meta.includes('ExportBlocked')));
};

});

parcelRegister("9Nf0e", function(module, exports) {
$parcel$export(module.exports, "handleClickCommon", () => $1da400b24dde73c2$export$9759a67e215c4598);
const $1da400b24dde73c2$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("9IiOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f4ae4b77cd27d44$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dsw4B = parcelRequire("dsw4B");

var $7wYyA = parcelRequire("7wYyA");

var $7pUjV = parcelRequire("7pUjV");

var $kUdg9 = parcelRequire("kUdg9");

var $eK9F3 = parcelRequire("eK9F3");

var $kFvsz = parcelRequire("kFvsz");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $8f4ae4b77cd27d44$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $bSJIT.useMemo)(()=>props.onAuthorize ? [
            (0, $kUdg9.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eK9F3.default), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        label: "errored-warning-icon",
        color: "var(--ds-icon-warning, #E06C00)",
        testId: `${testId}-warning-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $7wYyA.messages).could_not_load_link
        }
    }));
};
const $8f4ae4b77cd27d44$var$_default_1 = (0, $kFvsz.withFlexibleUIBlockCardStyle)($8f4ae4b77cd27d44$var$ErroredView);
var $8f4ae4b77cd27d44$export$2e2bcd8739ae039 = $8f4ae4b77cd27d44$var$_default_1;

});
parcelRegister("kUdg9", function(module, exports) {
$parcel$export(module.exports, "RetryAction", () => $021523269cd2bc9c$export$c527d977b53f7537);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");
const $021523269cd2bc9c$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5kJPq.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).try_again),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("eK9F3", function(module, exports) {
$parcel$export(module.exports, "default", () => $73b9d84358c55c60$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $faVqX = parcelRequire("faVqX");

var $dkOB1 = parcelRequire("dkOB1");

var $8dLhi = parcelRequire("8dLhi");

var $fdcVg = parcelRequire("fdcVg");

var $3Qn1E = parcelRequire("3Qn1E");

var $iD4XW = parcelRequire("iD4XW");

var $Q5s06 = parcelRequire("Q5s06");
const $73b9d84358c55c60$var$customBlockStyles = null;
const $73b9d84358c55c60$var$titleBlockCss = null;
const $73b9d84358c55c60$var$footerBlockCss = null;
const $73b9d84358c55c60$var$footerBlockSafariStyles = null;
const $73b9d84358c55c60$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $bSJIT.useMemo)(()=>(0, $faVqX.browser)(), []);
    return /*#__PURE__*/ $bSJIT.createElement((0, $dkOB1.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $Q5s06.FlexibleCardUiOptions),
        url: url
    }, /*#__PURE__*/ $bSJIT.createElement((0, $iD4XW.default), {
        ...(0, $Q5s06.titleBlockOptions),
        hideIcon: !!title,
        text: title,
        CompetitorPrompt: CompetitorPrompt,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _13mh1pd9 _2yhz13af"
        ])
    }), /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        className: (0, $9fU1q.default)([
            "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc0i7uo"
        ])
    }, children), showPreview && /*#__PURE__*/ $bSJIT.createElement((0, $3Qn1E.default), (0, $Q5s06.PreviewBlockOptions)), /*#__PURE__*/ $bSJIT.createElement((0, $fdcVg.default), {
        actions: actions,
        testId: "smart-block-card-footer",
        className: (0, $9fU1q.default)([
            "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
            safari && "_4t3i1osq"
        ])
    }));
};
var $73b9d84358c55c60$export$2e2bcd8739ae039 = $73b9d84358c55c60$var$UnresolvedView;

});
parcelRegister("Q5s06", function(module, exports) {
$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $6cee9bc497ca7bda$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $6cee9bc497ca7bda$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $6cee9bc497ca7bda$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $6cee9bc497ca7bda$export$9671929f11bd4ad8);

var $5kJPq = parcelRequire("5kJPq");

var $b5RkV = parcelRequire("b5RkV");

var $gy3md = parcelRequire("gy3md");
const $6cee9bc497ca7bda$var$baseTopMetadata = [
    {
        name: (0, $5kJPq.ElementName).ModifiedOn
    },
    {
        name: (0, $5kJPq.ElementName).AttachmentCount
    },
    {
        name: (0, $5kJPq.ElementName).SubscriberCount
    },
    {
        name: (0, $5kJPq.ElementName).VoteCount
    },
    {
        name: (0, $5kJPq.ElementName).DueOn
    },
    {
        name: (0, $5kJPq.ElementName).ReadTime
    }
];
const $6cee9bc497ca7bda$var$baseBottomMetaData = [
    {
        name: (0, $5kJPq.ElementName).ReactCount
    },
    {
        name: (0, $5kJPq.ElementName).CommentCount
    },
    {
        name: (0, $5kJPq.ElementName).ViewCount
    },
    {
        name: (0, $5kJPq.ElementName).Priority
    },
    {
        name: (0, $5kJPq.ElementName).SubTasksProgress
    },
    {
        name: (0, $5kJPq.ElementName).ChecklistProgress
    }
];
const $6cee9bc497ca7bda$export$f87d357259b3b7c8 = (cardDetails)=>{
    var _data$Type;
    const extensionKey = (0, $gy3md.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5kJPq.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5kJPq.ElementName).AuthorGroup
        },
        {
            name: (0, $5kJPq.ElementName).CreatedBy
        },
        ...$6cee9bc497ca7bda$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $6cee9bc497ca7bda$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5kJPq.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5kJPq.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5kJPq.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $b5RkV.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5kJPq.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5kJPq.ElementName).OwnedBy
                    },
                    ...$6cee9bc497ca7bda$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).AppliedToComponentsCount
                    },
                    ...$6cee9bc497ca7bda$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
        case 'mercury-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $b5RkV.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5kJPq.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5kJPq.ElementName).OwnedBy
                    },
                    ...$6cee9bc497ca7bda$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).AppliedToComponentsCount
                    },
                    ...$6cee9bc497ca7bda$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $b5RkV.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5kJPq.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5kJPq.ElementName).OwnedBy
                    },
                    ...$6cee9bc497ca7bda$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = ((_data$Type = data['@type']) === null || _data$Type === void 0 ? void 0 : _data$Type.includes('atlassian:Task')) ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5kJPq.ElementName).AuthorGroup
                },
                {
                    name: (0, $5kJPq.ElementName).CreatedBy
                },
                {
                    name: (0, $5kJPq.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5kJPq.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5kJPq.ElementName).AssignedTo
                },
                {
                    name: (0, $5kJPq.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5kJPq.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5kJPq.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5kJPq.ElementName).Priority
                    },
                    {
                        name: (0, $5kJPq.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5kJPq.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).ReactCount
                    },
                    {
                        name: (0, $5kJPq.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).CollaboratorGroup
                    },
                    ...$6cee9bc497ca7bda$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5kJPq.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5kJPq.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5kJPq.ElementName).UserAttributes
                    },
                    ...$6cee9bc497ca7bda$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $6cee9bc497ca7bda$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $6cee9bc497ca7bda$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5kJPq.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5kJPq.SmartLinkSize).Large
};
const $6cee9bc497ca7bda$export$9671929f11bd4ad8 = {
    placement: (0, $5kJPq.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("kFvsz", function(module, exports) {
$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $17b3348f144114c1$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $17b3348f144114c1$var$flexibleBlockCardStyle = null;
const $17b3348f144114c1$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_1g961mok _1qo3ia51"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement(FlexibleBlockCardView, props));
    };

});


parcelRegister("jNKc2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bafe21c6169ac160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $5FomD = parcelRequire("5FomD");

var $gxIo9 = parcelRequire("gxIo9");

var $fqW9V = parcelRequire("fqW9V");

var $dFiwI = parcelRequire("dFiwI");

var $7wYyA = parcelRequire("7wYyA");

var $hdeqO = parcelRequire("hdeqO");

var $b2pmc = parcelRequire("b2pmc");

var $7pUjV = parcelRequire("7pUjV");

var $8JIkL = parcelRequire("8JIkL");

var $eK9F3 = parcelRequire("eK9F3");

var $kFvsz = parcelRequire("kFvsz");
const $bafe21c6169ac160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $bafe21c6169ac160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const intl = (0, $4vLTk.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState === null || cardState === void 0 ? void 0 : cardState.details;
    const cardMetadata = (details === null || details === void 0 ? void 0 : details.meta) ?? (0, $hdeqO.getForbiddenJsonLd)().meta;
    const provider = (0, $gxIo9.extractSmartLinkProvider)(details);
    const providerName = (provider === null || provider === void 0 ? void 0 : provider.text) || '';
    const messageContext = (0, $bSJIT.useMemo)(()=>{
        const hostname = /*#__PURE__*/ $bSJIT.createElement("b", null, (0, $dFiwI.default)(url));
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $bSJIT.useMemo)(()=>{
        return (0, $fqW9V.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $bSJIT.useMemo)(()=>{
        const descriptor = (0, $b2pmc.toMessage)((0, $7wYyA.messages).invalid_permissions, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.titleMessageKey
    ]);
    const actions = (0, $bSJIT.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $8JIkL.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $8JIkL.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $eK9F3.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FomD))), {
        label: "forbidden-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $bSJIT.createElement((0, $7pUjV.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $b2pmc.toMessage)((0, $7wYyA.messages).invalid_permissions_description, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.descriptiveMessageKey),
            values: messageContext
        },
        className: (0, $9fU1q.default)([
            "_syazi7uo"
        ])
    }));
};
const $bafe21c6169ac160$var$_default_1 = (0, $kFvsz.withFlexibleUIBlockCardStyle)($bafe21c6169ac160$var$ForbiddenView);
var $bafe21c6169ac160$export$2e2bcd8739ae039 = $bafe21c6169ac160$var$_default_1;

});
parcelRegister("b2pmc", function(module, exports) {
$parcel$export(module.exports, "toMessage", () => $d843593380097f0f$export$d14c2a6dee946f52);

var $7wYyA = parcelRequire("7wYyA");
const $d843593380097f0f$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $7wYyA.messages)) return (0, $7wYyA.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("8JIkL", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $04d338b0e13101ff$export$59f8830fb5467e35);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");
const $04d338b0e13101ff$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5kJPq.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $7wYyA.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("cJnp7", function(module, exports) {
$parcel$export(module.exports, "default", () => $184a710d3e988443$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $5FomD = parcelRequire("5FomD");

var $gxIo9 = parcelRequire("gxIo9");

var $7wYyA = parcelRequire("7wYyA");

var $7pUjV = parcelRequire("7pUjV");

var $eK9F3 = parcelRequire("eK9F3");

var $kFvsz = parcelRequire("kFvsz");
const $184a710d3e988443$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $184a710d3e988443$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $4vLTk.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $bSJIT.useMemo)(()=>{
        const provider = (0, $gxIo9.extractSmartLinkProvider)(details);
        return (provider === null || provider === void 0 ? void 0 : provider.text) ?? '';
    }, [
        details
    ]);
    const title = (0, $bSJIT.useMemo)(()=>intl.formatMessage((0, $7wYyA.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $bSJIT.useMemo)(()=>({
            descriptor: (0, $7wYyA.messages).not_found_description
        }), []);
    return /*#__PURE__*/ $bSJIT.createElement((0, $eK9F3.default), {
        ...props,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FomD))), {
        label: "not-found-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $bSJIT.createElement((0, $7pUjV.default), {
        message: description,
        testId: `${testId}-message`,
        maxLines: 3,
        className: (0, $9fU1q.default)([
            "_syazi7uo"
        ])
    }));
};
const $184a710d3e988443$var$_default_1 = (0, $kFvsz.withFlexibleUIBlockCardStyle)($184a710d3e988443$var$NotFoundView);
var $184a710d3e988443$export$2e2bcd8739ae039 = $184a710d3e988443$var$_default_1;

});

parcelRegister("bHb8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $694205465b0d6b13$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $faVqX = parcelRequire("faVqX");

var $5kJPq = parcelRequire("5kJPq");

var $abuKh = parcelRequire("abuKh");

var $gy3md = parcelRequire("gy3md");

var $8aHT3 = parcelRequire("8aHT3");

var $cUXyD = parcelRequire("cUXyD");

var $4xVXc = parcelRequire("4xVXc");

var $dkOB1 = parcelRequire("dkOB1");

var $iJgrE = parcelRequire("iJgrE");

var $igIuZ = parcelRequire("igIuZ");

var $3Qn1E = parcelRequire("3Qn1E");

var $8WdDM = parcelRequire("8WdDM");

var $iD4XW = parcelRequire("iD4XW");

var $Q5s06 = parcelRequire("Q5s06");

var $kFvsz = parcelRequire("kFvsz");
const $694205465b0d6b13$var$titleBlockCss = null;
const $694205465b0d6b13$var$footerBlockCss = null;
const $694205465b0d6b13$var$footerSpacingCss = null;
const $694205465b0d6b13$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $694205465b0d6b13$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    var _cardState$details2;
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $bSJIT.useState)(false);
    const extensionKey = (0, $gy3md.getExtensionKey)(cardState.details);
    const is3PRovoBlockRovoActionEnabled = (0, $8aHT3.default)(url, actionOptions);
    const rovoConfig = (0, $cUXyD.default)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $bSJIT.useMemo)(()=>(0, $faVqX.browser)(), []);
    (0, $bSJIT.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $Q5s06.getSimulatedBetterMetadata)(cardState.details);
    const prompts = (0, $bSJIT.useMemo)(()=>{
        if (is3PRovoBlockRovoActionEnabled) {
            var _cardState$details;
            const defaultPrompts = [
                (0, $4xVXc.RovoChatPromptKey).KEY_HIGHLIGHTS
            ];
            const linkType = (_cardState$details = cardState.details) === null || _cardState$details === void 0 || (_cardState$details = _cardState$details.data) === null || _cardState$details === void 0 ? void 0 : _cardState$details['@type'];
            if (extensionKey === 'slack-object-provider') return [
                (0, $4xVXc.RovoChatPromptKey).FIND_OPEN_QUESTIONS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType !== null && linkType !== void 0 && linkType.includes('schema:PresentationDigitalDocument')) return [
                (0, $4xVXc.RovoChatPromptKey).IDENTIFY_KEY_POINTS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType !== null && linkType !== void 0 && linkType.includes('schema:SpreadsheetDigitalDocument')) return [
                (0, $4xVXc.RovoChatPromptKey).IDENTIFY_KEY_TRENDS,
                ...defaultPrompts
            ];
            return [
                (0, $4xVXc.RovoChatPromptKey).SUMMARIZE_LINK,
                ...defaultPrompts
            ];
        }
        return [];
    }, [
        cardState === null || cardState === void 0 || (_cardState$details2 = cardState.details) === null || _cardState$details2 === void 0 ? void 0 : _cardState$details2.data,
        extensionKey,
        is3PRovoBlockRovoActionEnabled
    ]);
    const footerActions = (0, $bSJIT.useMemo)(()=>{
        const showRovoResolvedView = (cardState === null || cardState === void 0 ? void 0 : cardState.status) === 'resolved' && cardState.details && (0, $abuKh.default)({
            response: cardState.details,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions
        }) !== undefined;
        return showRovoResolvedView && is3PRovoBlockRovoActionEnabled ? [
            {
                name: (0, $5kJPq.ActionName).RovoChatAction,
                prompts: prompts,
                iconSize: 'small',
                cardAppearance: (0, $5kJPq.CardDisplay).Block
            },
            {
                name: (0, $5kJPq.ActionName).FollowAction,
                iconSize: 'small'
            },
            {
                name: (0, $5kJPq.ActionName).DownloadAction,
                iconSize: 'small'
            }
        ] : [
            {
                name: (0, $5kJPq.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5kJPq.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5kJPq.ActionName).DownloadAction,
                hideIcon: true
            }
        ];
    }, [
        prompts,
        is3PRovoBlockRovoActionEnabled,
        cardState,
        rovoConfig,
        actionOptions
    ]);
    const uiOptions = (0, $Q5s06.FlexibleCardUiOptions);
    uiOptions.enableSnippetRenderer = true;
    uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ $bSJIT.createElement((0, $dkOB1.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url
    }, /*#__PURE__*/ $bSJIT.createElement((0, $iD4XW.default), {
        ...(0, $Q5s06.titleBlockOptions),
        metadata: titleMetadata,
        subtitle: [
            {
                name: (0, $5kJPq.ElementName).Location
            }
        ],
        metadataPosition: (0, $5kJPq.SmartLinkPosition).Top,
        CompetitorPrompt: CompetitorPrompt,
        url: url,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _13mh1pd9 _2yhz13af"
        ])
    }), /*#__PURE__*/ $bSJIT.createElement((0, $igIuZ.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ $bSJIT.createElement((0, $8WdDM.default), null), /*#__PURE__*/ $bSJIT.createElement((0, $igIuZ.default), {
        primary: bottomMetadata,
        maxLines: 1
    }), !isPreviewBlockErrored ? /*#__PURE__*/ $bSJIT.createElement((0, $3Qn1E.default), {
        ...(0, $Q5s06.PreviewBlockOptions),
        onError: ()=>{
            setIsPreviewBlockErrored(true);
        }
    }) : null, /*#__PURE__*/ $bSJIT.createElement((0, $iJgrE.default), {
        actions: footerActions,
        isPreviewBlockErrored: isPreviewBlockErrored,
        className: (0, $9fU1q.default)([
            "_4t3i10yn _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
            safari && "_4t3i1osq",
            "_19pku2gc"
        ])
    }));
};
const $694205465b0d6b13$var$_default_1 = (0, $kFvsz.withFlexibleUIBlockCardStyle)($694205465b0d6b13$var$ResolvedView);
var $694205465b0d6b13$export$2e2bcd8739ae039 = $694205465b0d6b13$var$_default_1;

});
parcelRegister("8aHT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7429f41ecd62627$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1R1LG = parcelRequire("1R1LG");

var $gy3md = parcelRequire("gy3md");

var $2TtjQ = parcelRequire("2TtjQ");

var $cUXyD = parcelRequire("cUXyD");
const $d7429f41ecd62627$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
/**
 * Returns whether the rovo actions are enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $d7429f41ecd62627$var$useBlockCardRovoAction = (url, actionOptions)=>{
    var _actionOptions$rovoCh;
    const { rovoOptions: rovoConfig, product: product } = (0, $cUXyD.default)();
    const isRovoChatEnabled = (0, $1R1LG.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $2TtjQ.useSmartCardState)(url ?? '');
    const extensionKey = (0, $gy3md.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false;
    return (0, $bSJIT.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn) return false;
        if (extensionKey && !$d7429f41ecd62627$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return false;
        return !!product && product === 'CONFLUENCE';
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $d7429f41ecd62627$export$2e2bcd8739ae039 = $d7429f41ecd62627$var$useBlockCardRovoAction;

});


parcelRegister("k8BC0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7d4767f7251f940$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $dwOcU = parcelRequire("dwOcU");

var $gxIo9 = parcelRequire("gxIo9");

var $6bOBo = parcelRequire("6bOBo");

var $f7uwJ = parcelRequire("f7uwJ");

var $9PwDt = parcelRequire("9PwDt");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $eAoOt = parcelRequire("eAoOt");

var $6sagi = parcelRequire("6sagi");

var $4SD6o = parcelRequire("4SD6o");

var $j33oH = parcelRequire("j33oH");

var $50jzR = parcelRequire("50jzR");

var $dkOB1 = parcelRequire("dkOB1");

var $goesr = parcelRequire("goesr");

var $8dLhi = parcelRequire("8dLhi");

var $94O41 = parcelRequire("94O41");

var $TSDzJ = parcelRequire("TSDzJ");

var $lgzQp = parcelRequire("lgzQp");

var $7XNox = parcelRequire("7XNox");

var $esP8S = parcelRequire("esP8S");

var $gK32L = parcelRequire("gK32L");

var $b9ajl = parcelRequire("b9ajl");

var $Q5s06 = parcelRequire("Q5s06");

var $kFvsz = parcelRequire("kFvsz");
const $e7d4767f7251f940$var$contentStyles = null;
const $e7d4767f7251f940$var$contentAdditionalStyles = null;
const $e7d4767f7251f940$var$newTitleBlockStyles = null;
const $e7d4767f7251f940$var$intermediumGapStyles = null;
const $e7d4767f7251f940$var$titleBlockStyles = null;
const $e7d4767f7251f940$var$previewBlockStyle = null;
const $e7d4767f7251f940$var$previewBlockStyleWithOverlap = null;
const $e7d4767f7251f940$var$linkIconStyles = null;
const $e7d4767f7251f940$var$containerStyles = null;
const $e7d4767f7251f940$var$previewBlockImageStyle = null;
const $e7d4767f7251f940$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
const $e7d4767f7251f940$var$getBetterTitle = (url)=>{
    // List of regexps to extract human-readable titles from URLs
    // Each regex should have a capture group for the title at index 1
    const titleExtractors = [
        // Dropbox: https://www.dropbox.com/scl/fi/scebraopvx4bni0sechq9/Atlas23_D1_A_0014.jpg?rlkey=... -> Atlas23_D1_A_0014.jpg
        /^https:\/\/www\.dropbox\.com\/scl\/fi\/[^\/]+\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home/Teamwork%20Ecosystem?preview=xsociety00.dat -> Teamwork Ecosystem
        /^https:\/\/www\.dropbox\.com\/home\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home?preview=Insomnia-All_2019-03-14.json -> Insomnia-All_2019-03-14.json
        /^https:\/\/www\.dropbox\.com\/home\?(?:.*?&)?preview=([^&#]+)/,
        // Dropbox: https://www.dropbox.com/preview/AI%20Contest -> AI Contest
        /^https:\/\/www\.dropbox\.com\/preview\/([^&?]+)/,
        // Dropbox: https://www.dropbox.com/s/votiehk00g4opif/xsociety00.dat?dl=0 -> xsociety00.dat
        /^https:\/\/www\.dropbox\.com\/(?:s|sh|sc|t)\/[^\/]+\/([^\/\?]+)/,
        // Figma: https://www.figma.com/slides/vW47To0dYPnT7jlrJdUd7h/Universal-Create-in-TwC?node-id=... -> Universal-Create-in-TwC
        // Also supports: /file/, /design/, /board/, /proto/
        /^https:\/\/(?:[\w.-]+\.)?figma\.com\/(?:design|board|file|proto|slides)\/[0-9a-zA-Z]{22,128}\/([^\/\?]+)/,
        // OneDrive: https://1drv.ms/w/s!ABC123DEF456/Project_Plan.docx?e=abcdEF -> Project_Plan.docx
        /^https:\/\/1drv\.ms\/[a-z]+\/s![^\/]+\/([^\/\?]+)/,
        // Miro: https://miro.com/app/board/uXjVOPnT123=/my-board-name/ -> my-board-name
        /^https:\/\/miro\.com\/app\/board\/[^\/]+\/([^\/\?]+)\/?/
    ];
    // Try each extractor pattern
    for (const pattern of titleExtractors){
        const match = url.match(pattern);
        if (match) {
            const extracted = decodeURIComponent(match[1]);
            if (extracted) return extracted;
        }
    }
    try {
        const { pathname: pathname, search: search } = new URL(url);
        if (pathname.length > 1) return pathname.substring(1);
        if (search) return search;
        // Fall back to the full URL when there is no useful path/search to display,
        // so the title (and the underlying link) always has accessible text.
        return url;
    } catch  {
        return url;
    }
};
const $e7d4767f7251f940$var$UnauthorisedBlock = ({ actions: actions, children: children, url: url, CompetitorPrompt: CompetitorPrompt, testId: testId })=>{
    var _data$preview;
    const { ui: ui, data: data } = (0, $eAoOt.useFlexibleCardContext)() ?? {
        ui: undefined,
        data: undefined
    };
    const hasActions = actions && actions.length > 0;
    const actionGroup = hasActions ? /*#__PURE__*/ $bSJIT.createElement((0, $goesr.default), {
        size: (0, $5kJPq.SmartLinkSize).Large,
        items: actions
    }) : null;
    const competitorPrompt = CompetitorPrompt && data !== null && data !== void 0 && data.url ? /*#__PURE__*/ $bSJIT.createElement(CompetitorPrompt, {
        sourceUrl: data === null || data === void 0 ? void 0 : data.url,
        linkType: 'card'
    }) : null;
    const title = /*#__PURE__*/ $bSJIT.createElement((0, $7XNox.default), {
        hideTooltip: false,
        maxLines: 1,
        theme: ui === null || ui === void 0 ? void 0 : ui.theme,
        text: $e7d4767f7251f940$var$getBetterTitle(url),
        className: (0, $9fU1q.default)([
            "_k48p1pd9 _syaz13af"
        ])
    });
    const { position: position } = (0, $Q5s06.titleBlockOptions);
    let overrideUrl = (data === null || data === void 0 || (_data$preview = data.preview) === null || _data$preview === void 0 ? void 0 : _data$preview.url) ?? (0, (/*@__PURE__*/$parcel$interopDefault($gK32L)));
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...(0, $Q5s06.titleBlockOptions),
        testId: `${testId}-errored-view`,
        className: (0, $9fU1q.default)([
            "_7cca15wb _1f3816vg"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        direction: (0, $5kJPq.SmartLinkDirection).Vertical,
        width: (0, $5kJPq.SmartLinkWidth).Flexible,
        size: (0, $5kJPq.SmartLinkSize).Medium,
        className: (0, $9fU1q.default)([
            "_zulputpp"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $lgzQp.default), {
        position: position,
        size: (0, $5kJPq.SmartLinkSize).Medium,
        isTiledIcon: true,
        className: (0, $9fU1q.default)([
            "_vsqgglyw"
        ])
    }), /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        direction: (0, $5kJPq.SmartLinkDirection).Vertical,
        width: (0, $5kJPq.SmartLinkWidth).Flexible,
        size: (0, $5kJPq.SmartLinkSize).Large,
        className: (0, $9fU1q.default)([
            "_zulpidpf"
        ])
    }, competitorPrompt ? /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $e7d4767f7251f940$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        size: (0, $5kJPq.SmartLinkSize).Medium,
        direction: (0, $5kJPq.SmartLinkDirection).Horizontal
    }, (0, $TSDzJ.renderElementItems)([
        {
            name: (0, $5kJPq.ElementName).HostName
        }
    ])))), children, actionGroup), hasActions ? /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bsb1o87 _1wpz1fhb _1dptglyw",
            "_1bsbo60d"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        style: {
            backgroundImage: `url(${overrideUrl})`
        },
        className: (0, $9fU1q.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _4t3i1osq _1bsb1o87 _1lrw1f51 _ouxl1ssb _12vemgnk"
        ])
    })) : null);
};
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $e7d4767f7251f940$var$UnauthorisedViewFrame = ({ content: content, providerName: providerName, testId: testId, ...props })=>{
    const { onAuthorize: onAuthorize } = props;
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleAuthorize = (0, $bSJIT.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const actions = (0, $bSJIT.useMemo)(()=>onAuthorize ? [
            (0, $esP8S.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $dkOB1.default), {
        appearance: "block",
        onAuthorize: onAuthorize,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $Q5s06.FlexibleCardUiOptions),
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement($e7d4767f7251f940$var$UnauthorisedBlock, {
        actions: actions,
        cardState: props.cardState,
        CompetitorPrompt: props.CompetitorPrompt,
        testId: testId,
        url: props.url
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": `${testId}-content`,
        className: (0, $9fU1q.default)([
            "_11c8fhey _syazi7uo _19pku2gc",
            actions.length > 0 && "_1reo15vq _18m915vq _otyrpxbi _p12f1osq _o5721q9c _1bto1l2s"
        ])
    }, content)));
};
const $e7d4767f7251f940$var$UnauthorisedViewBase = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    var _extractSmartLinkProv;
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (_extractSmartLinkProv = (0, $gxIo9.extractSmartLinkProvider)(cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text;
    const isProductIntegrationSupported = (0, $6sagi.hasAuthScopeOverrides)(cardState.details);
    const content = (0, $bSJIT.useMemo)(()=>onAuthorize ? /*#__PURE__*/ $bSJIT.createElement((0, $50jzR.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
            ...(0, $7wYyA.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($e7d4767f7251f940$var$UnauthorisedViewFrame, {
        ...props,
        content: content,
        providerName: providerName,
        testId: testId
    });
};
/**
 * Experiment wrapper: fires social proof exposure and renders social proof UI when FG is on.
 * TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
 */ const $e7d4767f7251f940$var$UnauthorisedViewWithExperiment = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    var _props$cardState, _extractSmartLinkProv2;
    const extensionKey = (_props$cardState = props.cardState) === null || _props$cardState === void 0 || (_props$cardState = _props$cardState.details) === null || _props$cardState === void 0 || (_props$cardState = _props$cardState.meta) === null || _props$cardState === void 0 ? void 0 : _props$cardState.key;
    const providerName = (_extractSmartLinkProv2 = (0, $gxIo9.extractSmartLinkProvider)(props.cardState.details)) === null || _extractSmartLinkProv2 === void 0 ? void 0 : _extractSmartLinkProv2.text;
    const { connections: connections } = (0, $6bOBo.useSmartLinkContext)();
    const { isTreatment: isTreatment, tier: tier, connectedPct: connectedPct } = (0, $j33oH.default)(providerName ? extensionKey : undefined, connections.client.baseUrlOverride);
    const socialProofExperimentMeta = (0, $4SD6o.getSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: connections.client.baseUrlOverride
    });
    const analyticsContextData = {
        attributes: {
            experiment: 'social_proof_3p_unauth_block_exp',
            cohort: isTreatment ? 'treatment' : 'control',
            tier: tier,
            experimentMeta: socialProofExperimentMeta
        }
    };
    if (!isTreatment || !providerName) {
        const fallbackView = /*#__PURE__*/ $bSJIT.createElement($e7d4767f7251f940$var$UnauthorisedViewBase, {
            ...props,
            testId: testId
        });
        return connectedPct !== undefined ? /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: analyticsContextData
        }, fallbackView) : fallbackView;
    }
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ $bSJIT.createElement($e7d4767f7251f940$var$UnauthorisedViewFrame, {
        ...props,
        content: /*#__PURE__*/ $bSJIT.createElement((0, $b9ajl.default), {
            tier: tier,
            connectedPct: connectedPct,
            providerName: providerName
        }),
        providerName: providerName,
        testId: testId
    }));
};
const $e7d4767f7251f940$var$UnauthorisedViewWithoutExperiment = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement($e7d4767f7251f940$var$UnauthorisedViewBase, props);
};
const $e7d4767f7251f940$var$UnauthorisedView = (0, $f7uwJ.componentWithFG)('social-proof-3p-unauth-block-fg', $e7d4767f7251f940$var$UnauthorisedViewWithExperiment, $e7d4767f7251f940$var$UnauthorisedViewWithoutExperiment);
const $e7d4767f7251f940$var$_default_1 = (0, $kFvsz.withFlexibleUIBlockCardStyle)($e7d4767f7251f940$var$UnauthorisedView);
var $e7d4767f7251f940$export$2e2bcd8739ae039 = $e7d4767f7251f940$var$_default_1;

});
parcelRegister("4SD6o", function(module, exports) {
$parcel$export(module.exports, "getSocialProofExperimentMeta", () => $b05f7de4dee57dfb$export$49fab64ef7e3aab7);

var $7xj9u = parcelRequire("7xj9u");

var $j33oH = parcelRequire("j33oH");
const $b05f7de4dee57dfb$export$49fab64ef7e3aab7 = (params)=>({
        [(0, $j33oH.SOCIAL_PROOF_3P_UNAUTH_BLOCK_EXPERIMENT_KEY)]: (0, $7xj9u.getSocialProofExperimentMetadata)(params)
    });

});
parcelRegister("7xj9u", function(module, exports) {
$parcel$export(module.exports, "getSocialProofExperimentMetadata", () => $6c2ebc2084d55397$export$128de1ead1745dc0);

var $g3xfg = parcelRequire("g3xfg");

var $iOHO4 = parcelRequire("iOHO4");

var $8MFqk = parcelRequire("8MFqk");

var $6dveU = parcelRequire("6dveU");
const $6c2ebc2084d55397$export$128de1ead1745dc0 = ({ extensionKey: extensionKey, baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash = '' })=>{
    if (!extensionKey) return {
        isEligible: false
    };
    const cloudId = (0, $g3xfg.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
    const providerPctMap = (0, $8MFqk.getProviderPctMapSync)(cloudId, (0, $iOHO4.personalizationConstants).SOCIAL_PROOF_TRAIT_NAME);
    const tier = (0, $6dveU.getSocialProofTier)(providerPctMap === null || providerPctMap === void 0 ? void 0 : providerPctMap[extensionKey]);
    return {
        isEligible: tier !== undefined,
        ...tier ? {
            tier: tier
        } : {}
    };
};

});
parcelRegister("g3xfg", function(module, exports) {
$parcel$export(module.exports, "getCurrentSiteCloudIdSync", () => $d0a1981efc57cf53$export$763646cf0dfa675c);

var $cSlyz = parcelRequire("cSlyz");
function $d0a1981efc57cf53$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return (0, $cSlyz.currentSiteCloudIdService).getStoredCloudId(baseUriWithNoTrailingSlash);
}

});

parcelRegister("iOHO4", function(module, exports) {
$parcel$export(module.exports, "personalizationConstants", () => $718c987e14d694fc$export$e00ede90ba65156);
const $718c987e14d694fc$export$e00ede90ba65156 = {
    BASE_URL: '/gateway/api/tap-delivery/api/v3/personalization',
    PERSONALIZATION_STORAGE_SCOPE: 'smart-card-social-proof',
    PERSONALIZATION_STORAGE_ITEM_KEY_PREFIX: 'pct-map:v1:',
    PERSONALIZATION_PROVIDER_PCT_TTL_MS: 86400000,
    SOCIAL_PROOF_TRAIT_NAME: 'sl_3p_connected_providers_site_pct'
};

});

parcelRegister("8MFqk", function(module, exports) {
$parcel$export(module.exports, "getProviderPctMapSync", () => $ac652e3909fe7b03$export$70435023d0d90129);

var $ceYfk = parcelRequire("ceYfk");
function $ac652e3909fe7b03$export$70435023d0d90129(cloudId, traitName) {
    return (0, $ceYfk.personalizationService).getProviderPctMapSync(cloudId, traitName);
}

});
parcelRegister("ceYfk", function(module, exports) {
$parcel$export(module.exports, "personalizationService", () => $555992bac55394fa$export$356056318a4fd636);

var $TaF9H = parcelRequire("TaF9H");
const $555992bac55394fa$export$356056318a4fd636 = new (0, $TaF9H.PersonalizationService)();

});
parcelRegister("TaF9H", function(module, exports) {
$parcel$export(module.exports, "PersonalizationService", () => $676319538d44a945$export$d653d8abac1e12ce);

var $hYVMR = parcelRequire("hYVMR");

var $iOHO4 = parcelRequire("iOHO4");
const $676319538d44a945$var$smartCardStorage = new (0, $hYVMR.StorageClient)((0, $iOHO4.personalizationConstants).PERSONALIZATION_STORAGE_SCOPE);
/** Keys written by this service in localStorage when using {@link smartCardStorage}. */ const $676319538d44a945$var$LOCAL_STORAGE_ROW_KEY_PREFIX = `${(0, $iOHO4.personalizationConstants).PERSONALIZATION_STORAGE_SCOPE}_${(0, $iOHO4.personalizationConstants).PERSONALIZATION_STORAGE_ITEM_KEY_PREFIX}`;
function $676319538d44a945$var$scopedCacheKey(cloudId, traitName) {
    return `${cloudId}:${traitName}`;
}
function $676319538d44a945$var$pctMapStorageItemKey(cloudId, traitName) {
    return `${(0, $iOHO4.personalizationConstants).PERSONALIZATION_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent(cloudId)}:${encodeURIComponent(traitName)}`;
}
async function $676319538d44a945$var$fetchSiteTraits(cloudId) {
    const response = await fetch(`${(0, $iOHO4.personalizationConstants).BASE_URL}/site/${cloudId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) return [];
    const data = await response.json();
    return (data === null || data === void 0 ? void 0 : data.attributes) ?? [];
}
class $676319538d44a945$export$d653d8abac1e12ce {
    /** Pure synchronous read for an explicit cloud id / trait pair. */ getProviderPctMapSync(cloudId, traitName) {
        if (!cloudId) return null;
        return this.readStoredProviderPctMap(cloudId, traitName);
    }
    async getProviderPctMap(cloudId, traitName) {
        if (!cloudId) return undefined;
        const cacheKey = $676319538d44a945$var$scopedCacheKey(cloudId, traitName);
        const cachedPromise = this.cache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                const traits = await $676319538d44a945$var$fetchSiteTraits(cloudId);
                const trait = traits.find((t)=>t.name === traitName);
                const mapped = this.parseTraitValue(trait === null || trait === void 0 ? void 0 : trait.value);
                if (mapped !== undefined) this.writeStoredProviderPctMap(cloudId, traitName, mapped);
                return mapped;
            } catch  {
                return undefined;
            }
        })();
        const retryablePromise = promise.finally(()=>{
            this.cache.delete(cacheKey);
        });
        this.cache.set(cacheKey, retryablePromise);
        return retryablePromise;
    }
    readStoredProviderPctMap(cloudId, traitName) {
        try {
            const stored = $676319538d44a945$var$smartCardStorage.getItem($676319538d44a945$var$pctMapStorageItemKey(cloudId, traitName));
            if (stored === undefined || stored === null) return null;
            return this.normalizeProviderPctMap(stored);
        } catch  {
            return null;
        }
    }
    writeStoredProviderPctMap(cloudId, traitName, map) {
        try {
            $676319538d44a945$var$smartCardStorage.setItemWithExpiry($676319538d44a945$var$pctMapStorageItemKey(cloudId, traitName), map, (0, $iOHO4.personalizationConstants).PERSONALIZATION_PROVIDER_PCT_TTL_MS);
        } catch  {
        // Quota, private-mode, etc.
        }
    }
    normalizeProviderPctMap(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
        const map = {};
        const entries = Object.entries(value);
        for (const [providerKey, percentageRaw] of entries){
            if (typeof percentageRaw !== 'number' || !Number.isFinite(percentageRaw)) return null;
            map[providerKey] = percentageRaw;
        }
        return map;
    }
    parseTraitValue(raw) {
        if (typeof raw !== 'string') return undefined;
        try {
            const parsed = JSON.parse(raw);
            const normalized = this.normalizeProviderPctMap(parsed);
            return normalized === null ? undefined : normalized;
        } catch  {
            return undefined;
        }
    }
    clearCache() {
        this.cache.clear();
        this.clearStoredProviderPctMaps();
    }
    clearStoredProviderPctMaps() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        if (typeof globalThis.localStorage === 'undefined' || globalThis.localStorage === null) return;
        const keysToRemove = [];
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let index = 0; index < globalThis.localStorage.length; index += 1){
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = globalThis.localStorage.key(index);
            if (key !== null && key.startsWith($676319538d44a945$var$LOCAL_STORAGE_ROW_KEY_PREFIX)) keysToRemove.push(key);
        }
        for (const key of keysToRemove)try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            globalThis.localStorage.removeItem(key);
        } catch  {
        /* ignore */ }
    }
    constructor(){
        this.cache = new Map();
    }
}

});



parcelRegister("6dveU", function(module, exports) {
$parcel$export(module.exports, "getSocialProofTier", () => $c277b859af3ac6dc$export$adbe2edcab243434);

var $j33oH = parcelRequire("j33oH");
const $c277b859af3ac6dc$export$adbe2edcab243434 = (connectedPct)=>{
    if (connectedPct === undefined) return undefined;
    return connectedPct >= (0, $j33oH.SOCIAL_PROOF_TIER_THRESHOLD) ? 'not-low' : 'low';
};

});
parcelRegister("j33oH", function(module, exports) {
$parcel$export(module.exports, "SOCIAL_PROOF_3P_UNAUTH_BLOCK_EXPERIMENT_KEY", () => $af2643b1c9b2b6e6$export$4d1c9f059e1da2cc);
$parcel$export(module.exports, "SOCIAL_PROOF_TIER_THRESHOLD", () => $af2643b1c9b2b6e6$export$e85fe820223563f3);
$parcel$export(module.exports, "default", () => $af2643b1c9b2b6e6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5N1Y4 = parcelRequire("5N1Y4");

var $2BU5G = parcelRequire("2BU5G");

var $6dveU = parcelRequire("6dveU");
const $af2643b1c9b2b6e6$export$4d1c9f059e1da2cc = 'social_proof_3p_unauth_block_exp';
const $af2643b1c9b2b6e6$export$e85fe820223563f3 = 30;
/**
 * Returns enrollment and treatment state for the social proof unauth block card experiment.
 *
 * Delegates data-fetching to `useSocialProof` (Sasha's shared service layer),
 * which handles cloudId resolution, TAP trait fetch, localStorage caching,
 * request deduping, and sync reads.
 *
 * This hook adds the experiment/cohort layer on top:
 * - Only fires exposure (via editorExperiment) when data has loaded.
 * - Derives `tier` and `isTreatment` for rendering decisions.
 *
 * Expected to be called only inside the fg-enabled branch (via componentWithFG).
 *
 * @param extensionKey - The extensionKey of the current 3P provider (e.g. 'google-object-provider').
 */ const $af2643b1c9b2b6e6$var$useSocialProofExperiment = (extensionKey, baseUriWithNoTrailingSlash = '')=>{
    const { connectedPct: connectedPct, isEnabled: isEnabled, isLoading: isLoading } = (0, $2BU5G.default)(extensionKey, true, baseUriWithNoTrailingSlash);
    return (0, $bSJIT.useMemo)(()=>{
        const hasSocialProofData = connectedPct !== undefined;
        // Only fire exposure when data has loaded (prevents exposure inflation)
        const isTreatment = isEnabled && !isLoading && hasSocialProofData ? (0, $5N1Y4.expValEquals)($af2643b1c9b2b6e6$export$4d1c9f059e1da2cc, 'isEnabled', true) : false;
        const tier = (0, $6dveU.getSocialProofTier)(connectedPct) ?? 'low';
        return {
            isTreatment: isTreatment,
            tier: tier,
            connectedPct: connectedPct,
            isLoading: isLoading
        };
    }, [
        isEnabled,
        isLoading,
        connectedPct
    ]);
};
var $af2643b1c9b2b6e6$export$2e2bcd8739ae039 = $af2643b1c9b2b6e6$var$useSocialProofExperiment;

});
parcelRegister("2BU5G", function(module, exports) {
$parcel$export(module.exports, "default", () => $903cab464b2cebcb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $ifdjD = parcelRequire("ifdjD");

var $g3xfg = parcelRequire("g3xfg");

var $iOHO4 = parcelRequire("iOHO4");

var $fHq2q = parcelRequire("fHq2q");

var $8MFqk = parcelRequire("8MFqk");
const $903cab464b2cebcb$var$NOT_ENABLED_RESULT = {
    connectedPct: undefined,
    isEnabled: false,
    isLoading: false
};
/**
 * Cache-first social proof hook.
 *
 * On mount:
 * 1. Reads localStorage synchronously via `getProviderPctMapSync`.
 *    - If data exists (warm cache): sets `providerPctMap` immediately, `isLoading = false`.
 *    - If no data (cold cache): leaves `providerPctMap` undefined, `isLoading = false`.
 * 2. Always kicks off an async fetch (fire-and-forget) via `getProviderPctMap` to populate
 *    localStorage for next page load. Does NOT update state with the async result.
 *
 * This means:
 * - First page visit (cold): no social proof rendered, no experiment exposure fired.
 *   Background fetch populates localStorage for next time.
 * - Second page visit (warm): social proof renders immediately from localStorage.
 *   Background refresh keeps localStorage fresh.
 *
 * Callers decide separately (e.g. via Statsig experiment) whether to surface the data.
 */ const $903cab464b2cebcb$var$useSocialProof = (extensionKey, isKillswitchOn = false, baseUriWithNoTrailingSlash = '')=>{
    const isEnabled = isKillswitchOn;
    const [snapshot] = (0, $bSJIT.useState)(()=>{
        if (!isEnabled) return {
            cloudId: undefined,
            providerPctMap: null
        };
        const cloudId = (0, $g3xfg.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
        return {
            cloudId: cloudId,
            providerPctMap: (0, $8MFqk.getProviderPctMapSync)(cloudId, (0, $iOHO4.personalizationConstants).SOCIAL_PROOF_TRAIT_NAME)
        };
    });
    // Fire-and-forget: warm caches for future mounts only. Never update this mount's treatment UI.
    (0, $bSJIT.useEffect)(()=>{
        if (!isEnabled) return;
        (0, $ifdjD.getCurrentSiteCloudId)(baseUriWithNoTrailingSlash).then((cloudId)=>{
            (0, $fHq2q.getProviderPctMap)(cloudId, (0, $iOHO4.personalizationConstants).SOCIAL_PROOF_TRAIT_NAME);
        });
    }, [
        baseUriWithNoTrailingSlash,
        isEnabled
    ]);
    return (0, $bSJIT.useMemo)(()=>{
        if (!isEnabled) return $903cab464b2cebcb$var$NOT_ENABLED_RESULT;
        return {
            connectedPct: extensionKey && snapshot.providerPctMap ? snapshot.providerPctMap[extensionKey] : undefined,
            isEnabled: Boolean(snapshot.cloudId && snapshot.providerPctMap),
            isLoading: false // sync read is instant; never in "loading" state
        };
    }, [
        extensionKey,
        isEnabled,
        snapshot
    ]);
};
var $903cab464b2cebcb$export$2e2bcd8739ae039 = $903cab464b2cebcb$var$useSocialProof;

});
parcelRegister("fHq2q", function(module, exports) {
$parcel$export(module.exports, "getProviderPctMap", () => $c88998baacca958f$export$fed0d3ced5218947);

var $ceYfk = parcelRequire("ceYfk");
const $c88998baacca958f$export$fed0d3ced5218947 = (cloudId, traitName)=>(0, $ceYfk.personalizationService).getProviderPctMap(cloudId, traitName);

});






parcelRegister("esP8S", function(module, exports) {
$parcel$export(module.exports, "AuthorizeAction", () => $3848ad8d2db790df$export$34cef2b72294bd84);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");
const $3848ad8d2db790df$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5kJPq.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $7wYyA.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).connect_link_account_card),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});

parcelRegister("gK32L", function(module, exports) {
module.exports = new URL("../images/general@2x.8b524499.png", import.meta.url).toString();

});

parcelRegister("b9ajl", function(module, exports) {
$parcel$export(module.exports, "default", () => $32843afcf4765252$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $9PwDt = parcelRequire("9PwDt");
var $8aT4G = parcelRequire("8aT4G");

var $7wYyA = parcelRequire("7wYyA");
// TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
const $32843afcf4765252$var$SocialProofMessage = ({ tier: tier, connectedPct: connectedPct, providerName: providerName, testId: testId = 'smart-block-social-proof-message' })=>{
    const message = tier === 'not-low' ? (0, $7wYyA.messages).pre_auth_block_social_proof_not_low : (0, $7wYyA.messages).pre_auth_block_social_proof_low;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...message,
        values: {
            percentage: connectedPct ?? 0,
            provider: providerName,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                    as: "strong",
                    weight: "bold"
                }, chunks)
        }
    }));
};
var $32843afcf4765252$export$2e2bcd8739ae039 = $32843afcf4765252$var$SocialProofMessage;

});



parcelRegister("2HRtR", function(module, exports) {
$parcel$export(module.exports, "EmbedCard", () => $5188bc308fd8a19d$export$6789d7ecdc77631b);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $1qPbZ = parcelRequire("1qPbZ");

var $fqW9V = parcelRequire("fqW9V");

var $7slw0 = parcelRequire("7slw0");

var $5DqMY = parcelRequire("5DqMY");

var $gy3md = parcelRequire("gy3md");

var $6sagi = parcelRequire("6sagi");

var $itDUP = parcelRequire("itDUP");

var $hdeqO = parcelRequire("hdeqO");

var $jPT4k = parcelRequire("jPT4k");

var $bHb8x = parcelRequire("bHb8x");

var $jZOah = parcelRequire("jZOah");

var $jVp8W = parcelRequire("jVp8W");

var $c7HxA = parcelRequire("c7HxA");

var $59VaZ = parcelRequire("59VaZ");

var $8JRlG = parcelRequire("8JRlG");

var $1FGB3 = parcelRequire("1FGB3");
const $5188bc308fd8a19d$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "smart-card-embed-card"
    }), children);
const $5188bc308fd8a19d$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    var _forbiddenViewProps$c, _notFoundViewProps$co;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $gy3md.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $6sagi.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $itDUP.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5188bc308fd8a19d$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bHb8x.default), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            }));
        case 'resolved':
            const resolvedViewProps = (0, $7slw0.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) {
                var _resolvedViewProps$pr, _details$meta;
                onResolve({
                    title: resolvedViewProps.title,
                    url: url,
                    aspectRatio: (_resolvedViewProps$pr = resolvedViewProps.preview) === null || _resolvedViewProps$pr === void 0 ? void 0 : _resolvedViewProps$pr.aspectRatio,
                    extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
                });
            }
            if ((0, $jPT4k.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7slw0.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1FGB3.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8JRlG.EmbedCardResolvedView), {
                ...resolvedViewProps,
                actionOptions: actionOptions,
                details: details,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $5DqMY.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jZOah.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bHb8x.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                    // Other states (e.g. "resolving") could be added later for completeness.
                    onAuxClick: handleFrameAuxClick,
                    onContextMenu: handleFrameContextMenu,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7slw0.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1FGB3.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7slw0.extractEmbedProps)(details, platform);
            const cardMetadata = (details === null || details === void 0 ? void 0 : details.meta) ?? (0, $hdeqO.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8JRlG.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $fqW9V.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: ((_forbiddenViewProps$c = forbiddenViewProps.context) === null || _forbiddenViewProps$c === void 0 ? void 0 : _forbiddenViewProps$c.text) ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c7HxA.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7slw0.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details !== null && details !== void 0 && details.meta ? (0, $fqW9V.extractRequestAccessContextImproved)({
                jsonLd: details === null || details === void 0 ? void 0 : details.meta,
                url: url,
                product: ((_notFoundViewProps$co = notFoundViewProps.context) === null || _notFoundViewProps$co === void 0 ? void 0 : _notFoundViewProps$co.text) ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $59VaZ.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jVp8W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7slw0", function(module, exports) {
$parcel$export(module.exports, "extractEmbedProps", () => $d872b5de805ab064$export$d6cf81ca6e68bcc3);

var $dWNt9 = parcelRequire("dWNt9");

var $fUOZn = parcelRequire("fUOZn");

var $del70 = parcelRequire("del70");

var $fZvKv = parcelRequire("fZvKv");

var $yHkac = parcelRequire("yHkac");

var $kEn6C = parcelRequire("kEn6C");

var $2dCzp = parcelRequire("2dCzp");

var $hEEr6 = parcelRequire("hEEr6");

var $30ww9 = parcelRequire("30ww9");
const $d872b5de805ab064$export$d6cf81ca6e68bcc3 = (response, _platform, iframeUrlType)=>{
    const meta = response === null || response === void 0 ? void 0 : response.meta;
    const jsonLd = (response === null || response === void 0 ? void 0 : response.data) || (0, $yHkac.getEmptyJsonLd)();
    return {
        link: (0, $del70.extractSmartLinkUrl)(response) || '',
        title: (0, $fUOZn.extractSmartLinkTitle)(response),
        context: (0, $30ww9.extractSmartLinkContext)(response),
        preview: (0, $dWNt9.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $hEEr6.extractIsTrusted)(meta),
        isSupportProductContext: (0, $kEn6C.extractIsSupportProductContext)(meta),
        isSupportTheming: (0, $2dCzp.extractIsSupportTheming)(meta),
        type: (0, $fZvKv.extractType)(jsonLd)
    };
};

});
parcelRegister("yHkac", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $12af82f26a608235$export$2796a804c6e44f63);

var $kr2in = parcelRequire("kr2in");
const $12af82f26a608235$export$2796a804c6e44f63 = ()=>(0, $kr2in.emptyData);

});

parcelRegister("kEn6C", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportProductContext", () => $6814137945e70ed7$export$f7118f5dc6fab21a);

var $68DJM = parcelRequire("68DJM");
const $6814137945e70ed7$export$f7118f5dc6fab21a = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && (0, $68DJM.PROVIDER_KEYS_WITH_HOSTPRODUCT_CONTEXT).includes(meta.key));
};

});

parcelRegister("30ww9", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkContext", () => $eb1e9862329831aa$export$6ec4b6b24dec9156);

var $5NFld = parcelRequire("5NFld");

var $6N0jd = parcelRequire("6N0jd");

var $4gDvk = parcelRequire("4gDvk");

var $gdUUy = parcelRequire("gdUUy");

var $yHkac = parcelRequire("yHkac");

var $bV7U3 = parcelRequire("bV7U3");
function $eb1e9862329831aa$export$6ec4b6b24dec9156(response) {
    if ((0, $4gDvk.isEntityPresent)(response)) {
        if ((0, $gdUUy.fg)('platform_lp_use_generator_icon_for_provider')) {
            const entityProvider = (0, $6N0jd.extractEntityProvider)(response);
            if (!entityProvider) return undefined;
            const entityIcon = (0, $5NFld.extractEntityIcon)(response);
            return {
                ...entityProvider,
                icon: (entityIcon === null || entityIcon === void 0 ? void 0 : entityIcon.url) ?? entityProvider.icon,
                iconLabel: (entityIcon === null || entityIcon === void 0 ? void 0 : entityIcon.label) ?? entityProvider.iconLabel,
                providerIcon: entityProvider.icon,
                providerIconLabel: entityProvider.iconLabel
            };
        }
        return (0, $6N0jd.extractEntityProvider)(response);
    }
    return (0, $bV7U3.generateContext)((response === null || response === void 0 ? void 0 : response.data) || (0, $yHkac.getEmptyJsonLd)());
}

});
parcelRegister("bV7U3", function(module, exports) {
$parcel$export(module.exports, "generateContext", () => $3c86289de1fa376e$export$8dcb07487061d3c1);

var $fxoio = parcelRequire("fxoio");

var $egRBG = parcelRequire("egRBG");

var $cdeW6 = parcelRequire("cdeW6");

var $b2NV8 = parcelRequire("b2NV8");
function $3c86289de1fa376e$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $fxoio.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $b2NV8.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $cdeW6.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $egRBG.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}

});



parcelRegister("5DqMY", function(module, exports) {
$parcel$export(module.exports, "extractInlineProps", () => $a91502d491ff803f$export$68e1703c529dc7e0);

var $5NFld = parcelRequire("5NFld");

var $6N0jd = parcelRequire("6N0jd");

var $fxoio = parcelRequire("fxoio");

var $lDm12 = parcelRequire("lDm12");

var $fUOZn = parcelRequire("fUOZn");

var $del70 = parcelRequire("del70");

var $fZvKv = parcelRequire("fZvKv");

var $4gDvk = parcelRequire("4gDvk");

var $3y2s4 = parcelRequire("3y2s4");

var $yHkac = parcelRequire("yHkac");

var $2bnIB = parcelRequire("2bnIB");

var $hTsyk = parcelRequire("hTsyk");

var $gpxtq = parcelRequire("gpxtq");

var $7mdxF = parcelRequire("7mdxF");

var $4eFvv = parcelRequire("4eFvv");

var $68DJM = parcelRequire("68DJM");
const $a91502d491ff803f$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $fxoio.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $68DJM.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $68DJM.JIRA_GENERATOR_ID)) {
            const icon = (0, $2bnIB.extractIcon)(jsonLd, 'type', showIconLabel);
            if (provider.id === (0, $68DJM.JIRA_GENERATOR_ID) && typeof icon === 'string') {
                var _extractTaskType;
                const taskTypeLabel = (_extractTaskType = (0, $gpxtq.extractTaskType)(jsonLd)) === null || _extractTaskType === void 0 || (_extractTaskType = _extractTaskType.name) === null || _extractTaskType === void 0 ? void 0 : _extractTaskType.trim();
                if (taskTypeLabel) return [
                    icon,
                    taskTypeLabel
                ];
            }
            return icon;
        }
    }
    return (0, $2bnIB.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $a91502d491ff803f$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        const entityIcon = (0, $5NFld.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $6N0jd.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $a91502d491ff803f$var$extractInlineIcon((response === null || response === void 0 ? void 0 : response.data) || (0, $yHkac.getEmptyJsonLd)(), showLabel);
};
const $a91502d491ff803f$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = (response === null || response === void 0 ? void 0 : response.data) || (0, $yHkac.getEmptyJsonLd)();
    return {
        link: (0, $del70.extractSmartLinkUrl)(response),
        title: (0, $fUOZn.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: (0, $3y2s4.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') ? (0, $lDm12.extractSmartLinkInlineIcon)(response, showLabel) : $a91502d491ff803f$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $hTsyk.extractLozenge)(jsonLd),
        titleTextColor: (0, $7mdxF.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $4eFvv.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $fZvKv.extractType)(jsonLd)
    };
};

});
parcelRegister("lDm12", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkInlineIcon", () => $af6f04d1c1c51be1$export$643db2ee2409e635);

var $bSJIT = parcelRequire("bSJIT");

var $lwuFt = parcelRequire("lwuFt");

var $3lVND = parcelRequire("3lVND");

var $96QwL = parcelRequire("96QwL");

var $5GXrT = parcelRequire("5GXrT");

var $fmxSi = parcelRequire("fmxSi");

var $5XnaM = parcelRequire("5XnaM");

var $8Qale = parcelRequire("8Qale");

var $k0n7D = parcelRequire("k0n7D");

var $lQdGj = parcelRequire("lQdGj");

var $bF3dv = parcelRequire("bF3dv");

var $2Lzug = parcelRequire("2Lzug");

var $f4EgE = parcelRequire("f4EgE");

var $fbMo8 = parcelRequire("fbMo8");

var $iLUhj = parcelRequire("iLUhj");

var $24J67 = parcelRequire("24J67");

var $lnxPF = parcelRequire("lnxPF");

var $5NFld = parcelRequire("5NFld");

var $6N0jd = parcelRequire("6N0jd");

var $fxoio = parcelRequire("fxoio");

var $cdeW6 = parcelRequire("cdeW6");

var $jGEpB = parcelRequire("jGEpB");

var $jhgZE = parcelRequire("jhgZE");

var $4gDvk = parcelRequire("4gDvk");
const $af6f04d1c1c51be1$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $af6f04d1c1c51be1$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af6f04d1c1c51be1$var$getEmptyJsonLd = ()=>$af6f04d1c1c51be1$var$emptyData;
const $af6f04d1c1c51be1$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $af6f04d1c1c51be1$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $af6f04d1c1c51be1$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];

const $af6f04d1c1c51be1$var$getBlogIconWrapped = ()=>(parcelRequire("2ptPs")).default;

const $af6f04d1c1c51be1$var$getDocumentIcon = ()=>(parcelRequire("5GEAu")).default;

const $af6f04d1c1c51be1$var$getFileIcon = ()=>(parcelRequire("7k5ae")).default;

const $af6f04d1c1c51be1$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("QN4yr")).default;

const $af6f04d1c1c51be1$var$getPresentationIcon = ()=>(parcelRequire("eufSb")).default;

const $af6f04d1c1c51be1$var$getSpreadsheetIcon = ()=>(parcelRequire("bwRtJ")).default;
const $af6f04d1c1c51be1$var$digitalDocumentToIcon = (opts)=>{
    var _opts$provider;
    if ((_opts$provider = opts.provider) !== null && _opts$provider !== void 0 && _opts$provider.id && (0, $jhgZE.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $af6f04d1c1c51be1$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(LiveDocumentIconWrapped, {
            label: opts.showIconLabel ? 'live document' : '',
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $af6f04d1c1c51be1$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FileIcon, {
        label: opts.showIconLabel ? 'file' : '',
        testId: "file-icon"
    });
};
const $af6f04d1c1c51be1$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $af6f04d1c1c51be1$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(BlogIconWrapped, {
                    label: opts.showIconLabel ? 'blog' : '',
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $af6f04d1c1c51be1$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $af6f04d1c1c51be1$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $af6f04d1c1c51be1$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(PresentationIcon, {
                    label: opts.showIconLabel ? 'presentation' : '',
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $af6f04d1c1c51be1$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(SpreadsheetIcon, {
                    label: opts.showIconLabel ? 'spreadsheet' : '',
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), {
                color: "currentColor",
                label: opts.showIconLabel ? 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $af6f04d1c1c51be1$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
    }
};
const $af6f04d1c1c51be1$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $af6f04d1c1c51be1$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jGEpB.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $af6f04d1c1c51be1$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $af6f04d1c1c51be1$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iLUhj.default), {
        label: "Task",
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $lnxPF.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $lnxPF.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iLUhj.default), {
                    label: "Task",
                    testId: "jira-task-icon"
                });
            case 0, $lnxPF.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fbMo8.default), {
                    label: "Sub-task",
                    testId: "jira-subtask-icon"
                });
            case 0, $lnxPF.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f4EgE.default), {
                    label: "Story",
                    testId: "jira-story-icon"
                });
            case 0, $lnxPF.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5GXrT.default), {
                    label: "Bug",
                    testId: "jira-bug-icon"
                });
            case 0, $lnxPF.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k0n7D.default), {
                    label: "Epic",
                    testId: "jira-epic-icon"
                });
            case 0, $lnxPF.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lQdGj.default), {
                    label: "Incident",
                    testId: "jira-incident-icon"
                });
            case 0, $lnxPF.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $24J67.default), {
                    label: "Service request",
                    testId: "jira-service-request-icon"
                });
            case 0, $lnxPF.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fmxSi.default), {
                    label: "Change",
                    testId: "jira-change-icon"
                });
            case 0, $lnxPF.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bF3dv.default), {
                    label: "Problem",
                    testId: "jira-problem-icon"
                });
            case 0, $lnxPF.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $af6f04d1c1c51be1$var$typeToIcon = (type, opts)=>{
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Qale.default), {
                label: "commit",
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3lVND))), {
                label: "project",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2Lzug.default), {
                label: "pull request",
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $96QwL.default), {
                label: "reference",
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5XnaM.default), {
                label: "repository",
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iLUhj.default), {
                label: "goal",
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $af6f04d1c1c51be1$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $af6f04d1c1c51be1$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $af6f04d1c1c51be1$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jGEpB.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $af6f04d1c1c51be1$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $af6f04d1c1c51be1$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $af6f04d1c1c51be1$var$extractIconFromDocument(type, opts);
        default:
            return type ? $af6f04d1c1c51be1$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $af6f04d1c1c51be1$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        provider: (0, $fxoio.extractProvider)(jsonLd),
        fileFormat: $af6f04d1c1c51be1$var$extractFileFormat(jsonLd),
        taskType: $af6f04d1c1c51be1$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$af6f04d1c1c51be1$var$extractorPriorityMap[b] - $af6f04d1c1c51be1$var$extractorPriorityMap[a])[0];
        return $af6f04d1c1c51be1$var$extractIconByType(highestPriorityType, opts);
    } else return $af6f04d1c1c51be1$var$extractIconByType(type, opts);
};
const $af6f04d1c1c51be1$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $fxoio.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $lnxPF.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $lnxPF.JIRA_GENERATOR_ID)) return $af6f04d1c1c51be1$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $af6f04d1c1c51be1$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $af6f04d1c1c51be1$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        const entityIcon = (0, $5NFld.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $6N0jd.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $af6f04d1c1c51be1$var$extractInlineIcon((response === null || response === void 0 ? void 0 : response.data) || $af6f04d1c1c51be1$var$getEmptyJsonLd(), showLabel);
};

});
parcelRegister("jGEpB", function(module, exports) {
$parcel$export(module.exports, "getIconForFileType", () => $be56c1bb97a3b356$export$4d685c85ebc7a1e3);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $lnxPF = parcelRequire("lnxPF");

var $ljmGM = parcelRequire("ljmGM");






















const $be56c1bb97a3b356$var$getLazyIcons = ()=>({
        [(0, $lnxPF.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("5GEAu")))
        },
        [(0, $lnxPF.IconType).Audio]: {
            default: ()=>(parcelRequire("llGrD"))
        },
        [(0, $lnxPF.IconType).Code]: {
            default: ()=>(parcelRequire("2PbEg"))
        },
        [(0, $lnxPF.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("7k5ae")))
        },
        [(0, $lnxPF.IconType).Folder]: {
            default: ()=>(parcelRequire("4d8We"))
        },
        [(0, $lnxPF.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("7k5ae")))
        },
        [(0, $lnxPF.IconType).Image]: {
            default: ()=>(parcelRequire("9zsoq"))
        },
        [(0, $lnxPF.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("eufSb")))
        },
        [(0, $lnxPF.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("bwRtJ")))
        },
        [(0, $lnxPF.IconType).Video]: {
            default: ()=>(parcelRequire("gPMyb"))
        },
        [(0, $lnxPF.IconType).Archive]: {
            default: ()=>(parcelRequire("lr34Q"))
        },
        [(0, $lnxPF.IconType).Executable]: {
            default: ()=>(parcelRequire("8Q3Zb"))
        },
        [(0, $lnxPF.IconType).GIF]: {
            default: ()=>(parcelRequire("1sXoB"))
        },
        [(0, $lnxPF.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("gWAQI"))
        },
        [(0, $lnxPF.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("fKE91"))
        },
        [(0, $lnxPF.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("eV8W8"))
        },
        [(0, $lnxPF.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("bPHYn"))
        },
        [(0, $lnxPF.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5U2K5"))
        },
        [(0, $lnxPF.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("lTyH8"))
        },
        [(0, $lnxPF.IconType).MSWord]: {
            default: ()=>(parcelRequire("4Ny40"))
        },
        [(0, $lnxPF.IconType).PDF]: {
            default: ()=>(parcelRequire("6xIrD"))
        },
        [(0, $lnxPF.IconType).Sketch]: {
            default: ()=>(parcelRequire("63DD2"))
        }
    });
const $be56c1bb97a3b356$var$getTypeToIconMap = (fileFormat)=>{
    var _lazyIcons$iconDescri;
    const iconDescriptor = (0, $ljmGM.default)(fileFormat);
    if (!(iconDescriptor !== null && iconDescriptor !== void 0 && iconDescriptor.icon)) return null;
    const lazyIcons = $be56c1bb97a3b356$var$getLazyIcons();
    return [
        (_lazyIcons$iconDescri = lazyIcons[iconDescriptor.icon]) === null || _lazyIcons$iconDescri === void 0 ? void 0 : _lazyIcons$iconDescri.default,
        iconDescriptor.label ?? ''
    ];
};
const $be56c1bb97a3b356$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $be56c1bb97a3b356$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    const descriptorLabel = icon[1] || '';
    const label = showIconLabel ?? true ? descriptorLabel : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Icon, {
        testId: "document-file-format-icon",
        label: label
    });
};

});
parcelRegister("ljmGM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4a23fc03359a164$export$2e2bcd8739ae039);

var $lnxPF = parcelRequire("lnxPF");
const $e4a23fc03359a164$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $lnxPF.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $lnxPF.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $lnxPF.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $lnxPF.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $lnxPF.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $lnxPF.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $lnxPF.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $lnxPF.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $lnxPF.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $lnxPF.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $lnxPF.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $lnxPF.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $lnxPF.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $lnxPF.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $lnxPF.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $lnxPF.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $lnxPF.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $lnxPF.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $lnxPF.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $lnxPF.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $lnxPF.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $e4a23fc03359a164$export$2e2bcd8739ae039 = $e4a23fc03359a164$var$extractFileFormatIcon;

});

parcelRegister("5GEAu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4d1962526b7d909d$export$2e2bcd8739ae039);

var $emsU2 = parcelRequire("emsU2");

var $UEe0q = parcelRequire("UEe0q");
const $4d1962526b7d909d$var$PageIconWithColor = (0, $UEe0q.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), 'blueBold');
$4d1962526b7d909d$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $4d1962526b7d909d$export$2e2bcd8739ae039 = $4d1962526b7d909d$var$PageIconWithColor;

});
parcelRegister("UEe0q", function(module, exports) {
$parcel$export(module.exports, "renderIconTile", () => $8f84e32a1b3b5deb$export$87c3646d0e299cfe);

var $bSJIT = parcelRequire("bSJIT");

var $67YKA = parcelRequire("67YKA");

var $gF8CL = parcelRequire("gF8CL");
const $8f84e32a1b3b5deb$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $8f84e32a1b3b5deb$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $gF8CL.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Icon, {
                color: $8f84e32a1b3b5deb$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};

});
parcelRegister("gF8CL", function(module, exports) {
$parcel$export(module.exports, "transformSmartLinkSizeToIconTileSize", () => $284fea0e4e4d019b$export$3acc3fb10995f020);

var $lnxPF = parcelRequire("lnxPF");
const $284fea0e4e4d019b$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $lnxPF.SmartLinkSize).Small:
        case (0, $lnxPF.SmartLinkSize).Medium:
            return undefined;
        case (0, $lnxPF.SmartLinkSize).XLarge:
        case (0, $lnxPF.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};

});



parcelRegister("llGrD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("f9NDZ").then(()=>parcelRequire('4GSZX'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("2PbEg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aqXkS").then(()=>parcelRequire('j15rB'));

});

parcelRegister("7k5ae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a9ad65dce76d15e1$export$2e2bcd8739ae039);

var $lwuFt = parcelRequire("lwuFt");

var $UEe0q = parcelRequire("UEe0q");
const $a9ad65dce76d15e1$var$FileIconWithColor = (0, $UEe0q.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), 'grayBold');
$a9ad65dce76d15e1$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $a9ad65dce76d15e1$export$2e2bcd8739ae039 = $a9ad65dce76d15e1$var$FileIconWithColor;

});

parcelRegister("4d8We", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hm2uR").then(()=>parcelRequire('cDkwb'));

});

parcelRegister("9zsoq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1ffOp").then(()=>parcelRequire('iYBXi'));

});

parcelRegister("eufSb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $35d4fde9269cdf94$export$2e2bcd8739ae039);

var $fTN3Z = parcelRequire("fTN3Z");

var $UEe0q = parcelRequire("UEe0q");
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $35d4fde9269cdf94$var$ChartBarIconWithColor = (0, $UEe0q.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($fTN3Z))), 'purpleBold');
$35d4fde9269cdf94$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $35d4fde9269cdf94$export$2e2bcd8739ae039 = $35d4fde9269cdf94$var$ChartBarIconWithColor;

});

parcelRegister("bwRtJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $20f765c2296cda62$export$2e2bcd8739ae039);

var $kUZ0E = parcelRequire("kUZ0E");

var $UEe0q = parcelRequire("UEe0q");
const $20f765c2296cda62$var$ListBulletedIconWithColor = (0, $UEe0q.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), 'greenBold');
$20f765c2296cda62$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $20f765c2296cda62$export$2e2bcd8739ae039 = $20f765c2296cda62$var$ListBulletedIconWithColor;

});

parcelRegister("gPMyb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6hYTh").then(()=>parcelRequire('4Ab6z'));

});

parcelRegister("lr34Q", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5Q6Lv").then(()=>parcelRequire('2Cf0j'));

});

parcelRegister("8Q3Zb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("im3Gq").then(()=>parcelRequire('cc6dr'));

});

parcelRegister("1sXoB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hb6aq").then(()=>parcelRequire('5zGdM'));

});

parcelRegister("gWAQI", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hsqqr").then(()=>parcelRequire('9Qi0v'));

});

parcelRegister("fKE91", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2gnAV").then(()=>parcelRequire('kU9Gp'));

});

parcelRegister("eV8W8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cguoO").then(()=>parcelRequire('6YBWf'));

});

parcelRegister("bPHYn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4mnZC").then(()=>parcelRequire('lXZwO'));

});

parcelRegister("5U2K5", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ePlp8").then(()=>parcelRequire('lQDdk'));

});

parcelRegister("lTyH8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cLKjG").then(()=>parcelRequire('cRwRL'));

});

parcelRegister("4Ny40", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gyNWY").then(()=>parcelRequire('jx64G'));

});

parcelRegister("6xIrD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8g32G").then(()=>parcelRequire('jTZ17'));

});

parcelRegister("63DD2", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7whKl").then(()=>parcelRequire('6hOsT'));

});


parcelRegister("2ptPs", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd77349b8b7eed45$export$2e2bcd8739ae039);

var $5L1nf = parcelRequire("5L1nf");

var $7nxoy = parcelRequire("7nxoy");

var $7HKxJ = parcelRequire("7HKxJ");
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $bd77349b8b7eed45$var$BlogIconWithColor = (0, $7HKxJ.renderIconPerSize)((0, $5L1nf.default), (0, $7nxoy.default));
$bd77349b8b7eed45$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $bd77349b8b7eed45$export$2e2bcd8739ae039 = $bd77349b8b7eed45$var$BlogIconWithColor;

});
parcelRegister("7HKxJ", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $6c396fb0856f6425$export$28dd5ad82647c000);

var $bSJIT = parcelRequire("bSJIT");

var $lnxPF = parcelRequire("lnxPF");
const $6c396fb0856f6425$var$isIconSizeLarge = (size)=>size && [
        (0, $lnxPF.SmartLinkSize).Large,
        (0, $lnxPF.SmartLinkSize).XLarge
    ].includes(size);
const $6c396fb0856f6425$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($6c396fb0856f6425$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ObjectIcon, props);
    };
};

});


parcelRegister("QN4yr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e83004d9f5706c0c$export$2e2bcd8739ae039);

var $58h91 = parcelRequire("58h91");

var $dPoiI = parcelRequire("dPoiI");

var $7HKxJ = parcelRequire("7HKxJ");
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $e83004d9f5706c0c$var$LiveDocumentIconWithColor = (0, $7HKxJ.renderIconPerSize)((0, $58h91.default), (0, $dPoiI.default));
$e83004d9f5706c0c$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $e83004d9f5706c0c$export$2e2bcd8739ae039 = $e83004d9f5706c0c$var$LiveDocumentIconWithColor;

});


parcelRegister("2bnIB", function(module, exports) {
$parcel$export(module.exports, "extractIcon", () => $4dc1c107507e613e$export$64bdf1f5e49e8626);

var $bSJIT = parcelRequire("bSJIT");

var $3lVND = parcelRequire("3lVND");

var $fxoio = parcelRequire("fxoio");

var $cdeW6 = parcelRequire("cdeW6");

var $96QwL = parcelRequire("96QwL");

var $5XnaM = parcelRequire("5XnaM");

var $8Qale = parcelRequire("8Qale");

var $2Lzug = parcelRequire("2Lzug");

var $iLUhj = parcelRequire("iLUhj");

var $bCwy7 = parcelRequire("bCwy7");

var $gpxtq = parcelRequire("gpxtq");

var $hkq7j = parcelRequire("hkq7j");

var $2lnue = parcelRequire("2lnue");

var $apkT4 = parcelRequire("apkT4");

var $b2NV8 = parcelRequire("b2NV8");

var $cPP74 = parcelRequire("cPP74");
const $4dc1c107507e613e$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        provider: (0, $fxoio.extractProvider)(jsonLd),
        fileFormat: (0, $hkq7j.extractFileFormat)(jsonLd),
        taskType: (0, $gpxtq.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $cPP74.extractorPriorityMap)[b] - (0, $cPP74.extractorPriorityMap)[a])[0];
        return $4dc1c107507e613e$var$extractIconByType(highestPriorityType, opts);
    } else return $4dc1c107507e613e$var$extractIconByType(type, opts);
};
function $4dc1c107507e613e$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Qale.default), {
                label: "commit",
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3lVND))), {
                label: "project",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2Lzug.default), {
                label: "pull request",
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $96QwL.default), {
                label: "reference",
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5XnaM.default), {
                label: "repository",
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iLUhj.default), {
                label: "goal",
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $apkT4.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $4dc1c107507e613e$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $4dc1c107507e613e$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $bCwy7.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $b2NV8.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $4dc1c107507e613e$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $2lnue.extractIconFromDocument)(type, opts);
        default:
            return $4dc1c107507e613e$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("bCwy7", function(module, exports) {
$parcel$export(module.exports, "getIconForFileType", () => $20204a178f65eb98$export$4d685c85ebc7a1e3);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $jchxU = parcelRequire("jchxU");

var $8qanF = parcelRequire("8qanF");
const $20204a178f65eb98$var$getTypeToIconMap = (fileFormat)=>{
    var _lazyIcons$iconDescri;
    const iconDescriptor = (0, $jchxU.default)(fileFormat);
    if (!(iconDescriptor !== null && iconDescriptor !== void 0 && iconDescriptor.icon)) return null;
    const lazyIcons = (0, $8qanF.getLazyIcons)();
    return [
        (_lazyIcons$iconDescri = lazyIcons[iconDescriptor.icon]) === null || _lazyIcons$iconDescri === void 0 ? void 0 : _lazyIcons$iconDescri.default,
        iconDescriptor.label ?? ''
    ];
};
const $20204a178f65eb98$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    let icon = $20204a178f65eb98$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    const label = showIconLabel ?? true ? icon[1] || '' : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Icon, {
        testId: "document-file-format-icon",
        label: label
    });
};

});

parcelRegister("hkq7j", function(module, exports) {
$parcel$export(module.exports, "extractFileFormat", () => $861b301e5b0d9b4d$export$f2d65f02f6888b60);
const $861b301e5b0d9b4d$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("2lnue", function(module, exports) {
$parcel$export(module.exports, "extractIconFromDocument", () => $7b5692e41a916875$export$25c24c7f577936d3);

var $bSJIT = parcelRequire("bSJIT");

var $lwuFt = parcelRequire("lwuFt");

var $jhgZE = parcelRequire("jhgZE");

var $bCwy7 = parcelRequire("bCwy7");

var $b2NV8 = parcelRequire("b2NV8");

const $7b5692e41a916875$var$getBlogIconWrapped = ()=>(parcelRequire("8BZ9Q")).default;

const $7b5692e41a916875$var$getDocumentIcon = ()=>(parcelRequire("iZe2v")).default;

const $7b5692e41a916875$var$getFileIcon = ()=>(parcelRequire("fEGwx")).default;

const $7b5692e41a916875$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("5YS12")).default;

const $7b5692e41a916875$var$getPresentationIcon = ()=>(parcelRequire("fnYUT")).default;

const $7b5692e41a916875$var$getSpreadsheetIcon = ()=>(parcelRequire("70tZA")).default;
const $7b5692e41a916875$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $7b5692e41a916875$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $7b5692e41a916875$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $b2NV8.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $7b5692e41a916875$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $bCwy7.getIconForFileType)(opts.fileFormat, opts.showIconLabel);
};
const $7b5692e41a916875$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return label;
};
const $7b5692e41a916875$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                // Intentionally keep this icon on a synchronous require()-based path.
                // This icon must be present in SSR markup so hydration does not cause a
                // visible empty-state-then-pop-in transition for Smart Links.
                const BlogIconWrapped = $7b5692e41a916875$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(BlogIconWrapped, {
                    label: $7b5692e41a916875$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $7b5692e41a916875$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $7b5692e41a916875$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DocumentIcon, {
                    label: $7b5692e41a916875$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $7b5692e41a916875$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(PresentationIcon, {
                    label: $7b5692e41a916875$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $7b5692e41a916875$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(SpreadsheetIcon, {
                    label: $7b5692e41a916875$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), {
                color: "currentColor",
                label: $7b5692e41a916875$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $7b5692e41a916875$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DocumentIcon, {
                    label: $7b5692e41a916875$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $7b5692e41a916875$var$digitalDocumentToIcon = (opts)=>{
    var _opts$provider;
    if ((_opts$provider = opts.provider) !== null && _opts$provider !== void 0 && _opts$provider.id && (0, $jhgZE.isConfluenceGenerator)(opts.provider.id)) {
        // Intentionally keep this icon on a synchronous require()-based path.
        // This icon must be present in SSR markup so hydration does not cause a
        // visible empty-state-then-pop-in transition for Smart Links.
        const LiveDocumentIconWrapped = $7b5692e41a916875$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(LiveDocumentIconWrapped, {
            label: $7b5692e41a916875$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    } else {
        const FileIcon = $7b5692e41a916875$var$getFileIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FileIcon, {
            label: $7b5692e41a916875$var$documentLabel(opts, 'file'),
            testId: "file-icon"
        });
    }
};

});

parcelRegister("apkT4", function(module, exports) {
$parcel$export(module.exports, "extractIconFromTask", () => $80233ae7cc55e712$export$321256ed044e3100);

var $bSJIT = parcelRequire("bSJIT");

var $5GXrT = parcelRequire("5GXrT");

var $fmxSi = parcelRequire("fmxSi");

var $k0n7D = parcelRequire("k0n7D");

var $lQdGj = parcelRequire("lQdGj");

var $bF3dv = parcelRequire("bF3dv");

var $f4EgE = parcelRequire("f4EgE");

var $fbMo8 = parcelRequire("fbMo8");

var $iLUhj = parcelRequire("iLUhj");

var $24J67 = parcelRequire("24J67");

var $68DJM = parcelRequire("68DJM");
const $80233ae7cc55e712$var$TaskIcon = (0, $iLUhj.default);
const $80233ae7cc55e712$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($80233ae7cc55e712$var$TaskIcon, {
        label: "Task",
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $68DJM.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $68DJM.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iLUhj.default), {
                    label: "Task",
                    testId: "jira-task-icon"
                });
            case 0, $68DJM.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fbMo8.default), {
                    label: "Sub-task",
                    testId: "jira-subtask-icon"
                });
            case 0, $68DJM.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f4EgE.default), {
                    label: "Story",
                    testId: "jira-story-icon"
                });
            case 0, $68DJM.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5GXrT.default), {
                    label: "Bug",
                    testId: "jira-bug-icon"
                });
            case 0, $68DJM.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k0n7D.default), {
                    label: "Epic",
                    testId: "jira-epic-icon"
                });
            case 0, $68DJM.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lQdGj.default), {
                    label: "Incident",
                    testId: "jira-incident-icon"
                });
            case 0, $68DJM.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $24J67.default), {
                    label: "Service request",
                    testId: "jira-service-request-icon"
                });
            case 0, $68DJM.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fmxSi.default), {
                    label: "Change",
                    testId: "jira-change-icon"
                });
            case 0, $68DJM.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bF3dv.default), {
                    label: "Problem",
                    testId: "jira-problem-icon"
                });
            case 0, $68DJM.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});


parcelRegister("7mdxF", function(module, exports) {
$parcel$export(module.exports, "extractTitleTextColor", () => $28771a341680b875$export$a2afc198e9dada1);

var $cPP74 = parcelRequire("cPP74");
const $28771a341680b875$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $cPP74.extractorPriorityMap)[b] - (0, $cPP74.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return "var(--ds-text-danger, #AE2E24)";
            default:
                return undefined;
        }
    }
};

});

parcelRegister("4eFvv", function(module, exports) {
$parcel$export(module.exports, "extractTitlePrefix", () => $6b293abb2d1247bf$export$58d9bc37318dfb32);
parcelRequire("bSJIT");
const $6b293abb2d1247bf$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $6b293abb2d1247bf$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $6b293abb2d1247bf$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("jZOah", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedView", () => $0f485524e8de3b99$export$6d5912cb4b56390e);

var $bSJIT = parcelRequire("bSJIT");

var $f7uwJ = parcelRequire("f7uwJ");

var $gdUUy = parcelRequire("gdUUy");

var $10h0y = parcelRequire("10h0y");

var $3r14S = parcelRequire("3r14S");

var $gd4UU = parcelRequire("gd4UU");

var $jNvPl = parcelRequire("jNvPl");

var $7tKPN = parcelRequire("7tKPN");
class $0f485524e8de3b99$var$InlineCardResolvedViewClass extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    renderLozenge() {
        var _lozenge$style3, _lozenge$style4;
        const { lozenge: lozenge } = this.props;
        if (!lozenge || !(lozenge !== null && lozenge !== void 0 && lozenge.text)) return null;
        if ((0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
            if (stateMetricMatch) {
                var _lozenge$style, _lozenge$style2;
                const [, label, metric] = stateMetricMatch;
                const appearance = lozenge.appearance || 'neutral';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3r14S.default), {
                    testId: "inline-card-resolved-view-lozenge",
                    appearance: appearance,
                    style: {
                        backgroundColor: lozenge === null || lozenge === void 0 || (_lozenge$style = lozenge.style) === null || _lozenge$style === void 0 ? void 0 : _lozenge$style.backgroundColor,
                        color: lozenge === null || lozenge === void 0 || (_lozenge$style2 = lozenge.style) === null || _lozenge$style2 === void 0 ? void 0 : _lozenge$style2.color
                    },
                    trailingMetric: metric
                }, label);
            }
        }
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3r14S.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge === null || lozenge === void 0 || (_lozenge$style3 = lozenge.style) === null || _lozenge$style3 === void 0 ? void 0 : _lozenge$style3.backgroundColor,
                color: lozenge === null || lozenge === void 0 || (_lozenge$style4 = lozenge.style) === null || _lozenge$style4 === void 0 ? void 0 : _lozenge$style4.color
            },
            isBold: lozenge.isBold !== false
        }, lozenge.text);
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            truncateInline: truncateInline
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconAndTitleLayout), {
            emoji: titlePrefix,
            icon: icon,
            title: title,
            titleTextColor: titleTextColor,
            type: type,
            hideIconLoadingSkeleton: hideIconLoadingSkeleton
        }), this.renderLozenge());
        if (showHoverPreview && link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10h0y.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions
        }, inlineCardResolvedView);
        return inlineCardResolvedView;
    }
}
const $0f485524e8de3b99$export$6d5912cb4b56390e = (0, $f7uwJ.componentWithFG)('smart-card-inline-resolved-view-refactor', (0, $7tKPN.InlineCardResolvedViewFunctional), $0f485524e8de3b99$var$InlineCardResolvedViewClass);

});
parcelRegister("3r14S", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9fb94e01beb2c38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $cExzV = parcelRequire("cExzV");

var $gdUUy = parcelRequire("gdUUy");
const $c9fb94e01beb2c38$var$wrapperStylesOld = null;
const $c9fb94e01beb2c38$var$wrapperStylesNew = null;
const $c9fb94e01beb2c38$var$wrapperStylesNewLozenge = null;
const $c9fb94e01beb2c38$var$InlineLozenge = (props)=>{
    if ((0, $gdUUy.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _154i1n1a _kqswh2mm _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq",
            (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_2hwxt94y"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cExzV.default), props));
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq",
            (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_2hwxt94y"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cExzV.default), props));
};
var $c9fb94e01beb2c38$export$2e2bcd8739ae039 = $c9fb94e01beb2c38$var$InlineLozenge;

});

parcelRegister("jNvPl", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $f2678e3b5b1a2b73$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $f2678e3b5b1a2b73$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports share Compiled style value(s) [LinkAppearance, iconImageStyle, iconWrapperStyle, styles] which cannot be exported across files (UI Styling Standard: no-exported-css) */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $ktg9Z = parcelRequire("ktg9Z");

var $gRfjb = parcelRequire("gRfjb");

var $9PwDt = parcelRequire("9PwDt");

var $k5Giz = parcelRequire("k5Giz");

var $eHs0P = parcelRequire("eHs0P");
const $f2678e3b5b1a2b73$var$iconWrapperStyle = null;
const $f2678e3b5b1a2b73$var$iconImageStyle = null;
const $f2678e3b5b1a2b73$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz1rpy _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $f2678e3b5b1a2b73$var$LinkAppearance = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_syaz13af _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $f2678e3b5b1a2b73$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $bSJIT.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string' || Array.isArray(icon)) return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $k5Giz.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((errored, testId)=>{
        if (!icon) return null;
        let iconUrl;
        let iconLabel = '';
        if (Array.isArray(icon)) {
            const [tupleIconUrl, tupleIconLabel] = icon;
            if (typeof tupleIconUrl !== 'string') return null;
            iconUrl = tupleIconUrl;
            iconLabel = typeof tupleIconLabel === 'string' ? tupleIconLabel : '';
        } else if (typeof icon === 'string') iconUrl = icon;
        else return null;
        if (hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
                src: iconUrl,
                "data-testid": `${testId}-image`,
                alt: iconLabel,
                onError: ()=>setHasImageErrored(true),
                className: (0, $9fU1q.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $f2678e3b5b1a2b73$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ktg9Z))), {
            src: iconUrl,
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
                src: iconUrl,
                "data-testid": `${testId}-image`,
                alt: iconLabel,
                className: (0, $9fU1q.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $f2678e3b5b1a2b73$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eHs0P.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
            label: "link",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
        // We cannot set the fix font because inline is taking the parent container font size into account.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        style: {
            lineHeight: `1`
        },
        xcss: $f2678e3b5b1a2b73$var$styles.iconOuterWrapperStyle,
        testId: "icon-position-wrapper"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $f2678e3b5b1a2b73$var$styles.iconEmptyStyle,
        testId: "icon-empty-wrapper"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-testid": "icon-wrapper",
        className: (0, $9fU1q.default)([
            "_11c8wadc _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
        ])
    }, renderIcon(testId)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        style: {
            color: titleTextColor
        }
    }, title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f2678e3b5b1a2b73$export$c73a53738ef9e3f, {
        style: {
            color: titleColor
        },
        testId: testId
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f2678e3b5b1a2b73$var$LinkAppearance, {
        href: link,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        className: (0, $9fU1q.default)([
            $f2678e3b5b1a2b73$var$styles.linkStyle
        ])
    }, titlePart) : titlePart, rightSide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $f2678e3b5b1a2b73$var$styles.noLinkAppearanceStyle
    }, rightSide) : null));
};
const $f2678e3b5b1a2b73$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $f2678e3b5b1a2b73$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("eHs0P", function(module, exports) {
$parcel$export(module.exports, "Shimmer", () => $e39a4fcc68cf0141$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ /* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $iJaFb = parcelRequire("iJaFb");
const $e39a4fcc68cf0141$export$f04a61298a47a40f = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $e39a4fcc68cf0141$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iJaFb.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("iJaFb", function(module, exports) {
$parcel$export(module.exports, "SpanSkeleton", () => $a9d2132e36c9abbe$export$85d5658002cae6ce);
/* span-skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $a9d2132e36c9abbe$var$placeholderShimmer = null;
const $a9d2132e36c9abbe$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $a9d2132e36c9abbe$var$spanSkeletonStyles = null;
const $a9d2132e36c9abbe$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $a9d2132e36c9abbe$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a9d2132e36c9abbe$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $9fU1q.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a9d2132e36c9abbe$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};

});



parcelRegister("7tKPN", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedViewFunctional", () => $2d8336e749fcf289$export$4dcde1a6b9223e2e);

var $bSJIT = parcelRequire("bSJIT");

var $bGXb3 = parcelRequire("bGXb3");

var $10h0y = parcelRequire("10h0y");

var $iXlmA = parcelRequire("iXlmA");

var $gd4UU = parcelRequire("gd4UU");

var $jNvPl = parcelRequire("jNvPl");

var $5jDhG = parcelRequire("5jDhG");
function $2d8336e749fcf289$export$4dcde1a6b9223e2e({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const { isEnabled: isInlineTailoredRovoActionEnabled } = (0, $bGXb3.default)(link, showHoverPreview, actionOptions);
    // TODO https://hello.jira.atlassian.cloud/browse/NAVX-4436: fire analytics with cohort
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $5jDhG.renderLozenge)(lozenge), isInlineTailoredRovoActionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iXlmA.InlineRovoActionButton), {
        testId: `${testId}-rovo-actions-cta`,
        url: link,
        actionOptions: actionOptions
    }));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10h0y.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}

});
parcelRegister("bGXb3", function(module, exports) {
$parcel$export(module.exports, "default", () => $baca2059a2a3da41$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1R1LG = parcelRequire("1R1LG");

var $gy3md = parcelRequire("gy3md");

var $2TtjQ = parcelRequire("2TtjQ");

var $cUXyD = parcelRequire("cUXyD");
const $baca2059a2a3da41$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $baca2059a2a3da41$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
/**
 * Returns whether the tailored inline actions
 * are enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $baca2059a2a3da41$var$useInlineTailoredAction = (url, showHoverPreview, actionOptions)=>{
    var _actionOptions$rovoCh;
    const { rovoOptions: rovoConfig } = (0, $cUXyD.default)();
    const isRovoChatEnabled = (0, $1R1LG.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $2TtjQ.useSmartCardState)(url ?? '');
    const extensionKey = (0, $gy3md.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false;
    return (0, $bSJIT.useMemo)(()=>{
        if (!isRovoChatEnabled || !showHoverPreview || !url || !isRovoChatActionOptedIn) return $baca2059a2a3da41$var$NOT_ENABLED_RESULT;
        if (!extensionKey || !$baca2059a2a3da41$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return $baca2059a2a3da41$var$NOT_ENABLED_RESULT;
        return {
            isEnabled: true
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        showHoverPreview,
        url,
        isRovoChatActionOptedIn
    ]);
};
var $baca2059a2a3da41$export$2e2bcd8739ae039 = $baca2059a2a3da41$var$useInlineTailoredAction;

});

parcelRegister("iXlmA", function(module, exports) {
$parcel$export(module.exports, "InlineRovoActionButton", () => $4f94085a771f1ab2$export$47ac6a4b603479b6);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gxIo9 = parcelRequire("gxIo9");

var $9PwDt = parcelRequire("9PwDt");
var $8aT4G = parcelRequire("8aT4G");

var $abuKh = parcelRequire("abuKh");

var $gy3md = parcelRequire("gy3md");

var $2AqEC = parcelRequire("2AqEC");

var $1A0Oh = parcelRequire("1A0Oh");

var $cUXyD = parcelRequire("cUXyD");

var $2TtjQ = parcelRequire("2TtjQ");

var $4xVXc = parcelRequire("4xVXc");

var $gmFrz = parcelRequire("gmFrz");
const $4f94085a771f1ab2$var$styles = {
    text: "_19bv12x7 _1e0c116y _4cvr1h6o _s7n4nkob _19pk1i6y"
};
const $4f94085a771f1ab2$export$47ac6a4b603479b6 = ({ testId: testId, url: url, actionOptions: actionOptions })=>{
    const { sendPromptMessage: sendPromptMessage, isRovoChatEnabled: isRovoChatEnabled } = (0, $1A0Oh.default)();
    const intl = (0, $4vLTk.default)();
    const cardState = (0, $2TtjQ.useSmartCardState)(url ?? '');
    const extensionKey = (0, $gy3md.getExtensionKey)(cardState.details);
    const rovoConfig = (0, $cUXyD.default)();
    const rovoChatAction = (0, $bSJIT.useMemo)(()=>{
        return cardState.details && (0, $abuKh.default)({
            response: cardState.details,
            actionOptions: actionOptions,
            rovoConfig: rovoConfig
        });
    }, [
        cardState.details,
        rovoConfig,
        actionOptions
    ]);
    const provider = (0, $bSJIT.useMemo)(()=>{
        return cardState.details && (0, $gxIo9.extractSmartLinkProvider)(cardState.details);
    }, [
        cardState.details
    ]);
    const invoke = (0, $2AqEC.default)({});
    const promptKey = (0, $bSJIT.useMemo)(()=>{
        var _cardState$details, _cardState$details2;
        if (extensionKey === 'google-object-provider' && (_cardState$details = cardState.details) !== null && _cardState$details !== void 0 && (_cardState$details = _cardState$details.data) !== null && _cardState$details !== void 0 && (_cardState$details = _cardState$details['@type']) !== null && _cardState$details !== void 0 && _cardState$details.includes('schema:SpreadsheetDigitalDocument')) return;
        switch(extensionKey){
            case 'google-object-provider':
                if ((_cardState$details2 = cardState.details) !== null && _cardState$details2 !== void 0 && (_cardState$details2 = _cardState$details2.data) !== null && _cardState$details2 !== void 0 && (_cardState$details2 = _cardState$details2['@type']) !== null && _cardState$details2 !== void 0 && _cardState$details2.includes('schema:PresentationDigitalDocument')) return (0, $4xVXc.RovoChatPromptKey).SUMMARIZE_PRESENTATION;
                return (0, $4xVXc.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'onedrive-object-provider':
                return (0, $4xVXc.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'github-object-provider':
            case 'gitlab-object-provider':
                return (0, $4xVXc.RovoChatPromptKey).EXPLAIN_CODE;
            case 'slack-object-provider':
            case 'ms-teams-object-provider':
                return (0, $4xVXc.RovoChatPromptKey).CATCH_UP;
            case 'salesforce-object-provider':
                return (0, $4xVXc.RovoChatPromptKey).SALESFORCE_PREP;
        }
    }, [
        extensionKey,
        cardState
    ]);
    const { data: promptData, content: content, icon: icon } = promptKey ? (0, $4xVXc.getPromptAction)({
        promptKey: promptKey,
        intl: intl,
        url: url,
        iconSize: 'small',
        provider: provider === null || provider === void 0 ? void 0 : provider.text
    }) || {} : {};
    const handleClick = (0, $bSJIT.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (isRovoChatEnabled && promptData && rovoChatAction !== null && rovoChatAction !== void 0 && rovoChatAction.invokeAction) invoke({
            ...rovoChatAction === null || rovoChatAction === void 0 ? void 0 : rovoChatAction.invokeAction,
            actionFn: async ()=>sendPromptMessage(promptData),
            prompt: promptKey
        });
    }, [
        sendPromptMessage,
        isRovoChatEnabled,
        promptData,
        rovoChatAction,
        promptKey,
        invoke
    ]);
    return promptData && content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gmFrz.ActionButton), {
        onClick: handleClick,
        testId: testId
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $4f94085a771f1ab2$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small"
    }, content))) : null;
};

});
parcelRegister("gmFrz", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $728d9828a882a9bf$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9PwDt = parcelRequire("9PwDt");
var $gXqq0 = parcelRequire("gXqq0");
const $728d9828a882a9bf$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    innerContainerSocialProofConnect: "_2rko12b0 _syaz15cr _80omtlke _bfhkjmqp _2hwxv77o _1e0c1nu9 _4cvr1h6o _1wybtjj4 _1y1m1u8q _16d9qvcn _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _s7n4t94y _o5721btx _1nmz9jpi _irr31q28 _1di612kk",
    innerContainerNoWrap: "_o5721q9c _1nmz4jg8",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhk187o",
    unauthorised: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk"
};
const $728d9828a882a9bf$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', isSlimDesign: isSlimDesign = false, ...props }, ref)=>{
    const shouldUseUnauthorisedSlimStyle = viewType === 'unauthorised' && isSlimDesign;
    if (shouldUseUnauthorisedSlimStyle && !isDisabled) {
        const { onClick: onClick, ...boxProps } = props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            ...boxProps,
            ref: ref,
            style: {
                font: `inherit`
            },
            xcss: $728d9828a882a9bf$var$styles.button
        }, /*#__PURE__*/ $bSJIT.createElement("span", {
            className: (0, $9fU1q.default)([
                $728d9828a882a9bf$var$styles.innerContainerSocialProofConnect,
                $728d9828a882a9bf$var$styles.innerContainerNoWrap
            ])
        }, children));
    }
    return /*#__PURE__*/ $bSJIT.createElement((0, $gXqq0.Pressable), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $728d9828a882a9bf$var$styles.button
    }, /*#__PURE__*/ $bSJIT.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $9fU1q.default)([
            $728d9828a882a9bf$var$styles.innerContainer,
            isDisabled ? $728d9828a882a9bf$var$styles.disabled : viewType === 'unauthorised' ? $728d9828a882a9bf$var$styles.unauthorised : $728d9828a882a9bf$var$styles.enabled
        ])
    }, children));
});

});


parcelRegister("5jDhG", function(module, exports) {
$parcel$export(module.exports, "renderLozenge", () => $71fb32649bcd7dcb$export$69cf9880ad713b0e);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $3r14S = parcelRequire("3r14S");
const $71fb32649bcd7dcb$var$LOZENGE_TEST_ID = 'inline-card-resolved-view-lozenge';
function $71fb32649bcd7dcb$export$69cf9880ad713b0e(lozenge) {
    var _lozenge$style3, _lozenge$style4;
    if (!lozenge || !(lozenge !== null && lozenge !== void 0 && lozenge.text)) return null;
    if ((0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
        if (stateMetricMatch) {
            var _lozenge$style, _lozenge$style2;
            const [, label, metric] = stateMetricMatch;
            const appearance = lozenge.appearance || 'neutral';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3r14S.default), {
                testId: $71fb32649bcd7dcb$var$LOZENGE_TEST_ID,
                appearance: appearance,
                style: {
                    backgroundColor: lozenge === null || lozenge === void 0 || (_lozenge$style = lozenge.style) === null || _lozenge$style === void 0 ? void 0 : _lozenge$style.backgroundColor,
                    color: lozenge === null || lozenge === void 0 || (_lozenge$style2 = lozenge.style) === null || _lozenge$style2 === void 0 ? void 0 : _lozenge$style2.color
                },
                trailingMetric: metric
            }, label);
        }
    }
    const appearance = lozenge.appearance || 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3r14S.default), {
        testId: $71fb32649bcd7dcb$var$LOZENGE_TEST_ID,
        appearance: appearance,
        style: {
            backgroundColor: lozenge === null || lozenge === void 0 || (_lozenge$style3 = lozenge.style) === null || _lozenge$style3 === void 0 ? void 0 : _lozenge$style3.backgroundColor,
            color: lozenge === null || lozenge === void 0 || (_lozenge$style4 = lozenge.style) === null || _lozenge$style4 === void 0 ? void 0 : _lozenge$style4.color
        },
        isBold: lozenge.isBold !== false
    }, lozenge.text);
}

});



parcelRegister("jVp8W", function(module, exports) {
$parcel$export(module.exports, "EmbedCardErroredView", () => $f4ceb2bd205a643a$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jNJGJ = parcelRequire("jNJGJ");

var $hkLEY = parcelRequire("hkLEY");

var $9PwDt = parcelRequire("9PwDt");
var $fZ0ZI = parcelRequire("fZ0ZI");

var $7wYyA = parcelRequire("7wYyA");

var $2HLZX = parcelRequire("2HLZX");
const $f4ceb2bd205a643a$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $f4ceb2bd205a643a$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ $bSJIT.createElement((0, $2HLZX.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId
    }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error-icon"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $f4ceb2bd205a643a$var$styles.boxStyles
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).could_not_load_link))), /*#__PURE__*/ $bSJIT.createElement((0, $jNJGJ.default), {
        testId: "err-view-retry",
        spacing: "compact",
        onClick: onRetry
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).try_again)));

});
parcelRegister("2HLZX", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $7e564194a819c0fa$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports share Compiled style value(s) [compactFrameAlignStyles, compactFrameHoverStyles, compactFrameInheritDimensionsFalseStyles, compactFrameInheritDimensionsTrueStyles, compactFrameNotSelectedStyles, compactFrameStyles, expandedFrameFluidHeightFalseStyles, expandedFrameFluidHeightTrueStyles, expandedFrameHoverStyles, expandedFrameNotSelectedStyles, expandedFrameSelectedStyles, expandedFrameStyles, sharedBaseFrameStyles, sharedFrameStyles] which cannot be exported across files (UI Styling Standard: no-exported-css) */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $7e564194a819c0fa$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7e564194a819c0fa$export$f862a410248f4f00, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7e564194a819c0fa$export$7b360cd785b6c366, props);
const $7e564194a819c0fa$var$sharedBaseFrameStyles = null;
const $7e564194a819c0fa$var$sharedFrameStyles = null;
const $7e564194a819c0fa$var$expandedFrameHoverStyles = null;
const $7e564194a819c0fa$var$expandedFrameFluidHeightTrueStyles = null;
const $7e564194a819c0fa$var$expandedFrameFluidHeightFalseStyles = null;
const $7e564194a819c0fa$var$expandedFrameSelectedStyles = null;
const $7e564194a819c0fa$var$expandedFrameNotSelectedStyles = null;
const $7e564194a819c0fa$var$expandedFrameStyles = null;
const $7e564194a819c0fa$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr31dpa _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6dq98m _1dqonqa1 _189e1dm9" : "_2rkolb4i _1h6d1j28 _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qst7xp",
            className
        ]),
        "data-trello-do-not-use-override": testId
    }, children);
};
const $7e564194a819c0fa$var$compactFrameHoverStyles = null;
const $7e564194a819c0fa$var$compactFrameInheritDimensionsTrueStyles = null;
const $7e564194a819c0fa$var$compactFrameInheritDimensionsFalseStyles = null;
const $7e564194a819c0fa$var$compactFrameAlignStyles = null;
const $7e564194a819c0fa$var$compactFrameStyles = null;
const $7e564194a819c0fa$var$compactFrameNotSelectedStyles = null;
const $7e564194a819c0fa$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3plhp",
            isSelected && "_2rkofajl _1h6dq98m _1dqonqa1 _189e1dm9",
            !isSelected && "_2rkolb4i",
            "_1bah1h6o _4cvr1h6o _bfhki8nm",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ])
    }, children);
};

});


parcelRegister("c7HxA", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7320c3eea988046$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jNJGJ = parcelRequire("jNJGJ");

var $7wYyA = parcelRequire("7wYyA");

var $b2pmc = parcelRequire("b2pmc");

var $ic9rK = parcelRequire("ic9rK");

var $ftDez = parcelRequire("ftDez");
const $c7320c3eea988046$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, providerIcon: providerIcon, providerIconLabel: providerIconLabel, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $bSJIT.useMemo)(()=>{
        const product = (context === null || context === void 0 ? void 0 : context.text) ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, hostname)
        };
    }, [
        hostname,
        context === null || context === void 0 ? void 0 : context.text
    ]);
    /**
   * if there is a request access context, but no action to perform, do not show any button.
   * By default, a "Try another account" button shows, but with request access context, we don't
   * want to encourage users to try another account, if their request is already pending, etc.
   */ const button = (0, $bSJIT.useMemo)(()=>{
        const onEmbedCardClick = (action === null || action === void 0 ? void 0 : action.promise) ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
            testId: `button-${(action === null || action === void 0 ? void 0 : action.id) || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $b2pmc.toMessage)((0, $7wYyA.messages).try_another_account, callToActionMessageKey),
            values: values
        }));
    }, [
        accessType,
        action === null || action === void 0 ? void 0 : action.id,
        action === null || action === void 0 ? void 0 : action.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ic9rK.default), {
        ...unresolvedViewProps,
        icon: icon,
        providerIcon: providerIcon,
        providerIconLabel: providerIconLabel,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ftDez.ForbiddenSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $b2pmc.toMessage)((0, $7wYyA.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $b2pmc.toMessage)((0, $7wYyA.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $c7320c3eea988046$export$2e2bcd8739ae039 = $c7320c3eea988046$var$ForbiddenView;

});
parcelRegister("ic9rK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1fd41ea13b3786a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $7WQx2 = parcelRequire("7WQx2");

var $gRfjb = parcelRequire("gRfjb");

var $gdUUy = parcelRequire("gdUUy");

var $8aT4G = parcelRequire("8aT4G");

var $hG27G = parcelRequire("hG27G");

var $20jCm = parcelRequire("20jCm");
const $d1fd41ea13b3786a$var$containerStyles = null;
const $d1fd41ea13b3786a$var$contentStyles = null;
const $d1fd41ea13b3786a$var$imageStyles = null;
const $d1fd41ea13b3786a$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, providerIcon: providerIcon, providerIconLabel: providerIconLabel, testId: testId, text: text, title: title, url: url })=>{
    // Unresolved embeds have no entity title. The frame shows the provider name, so
    // pair it with the provider/generator icon rather than the entity-type icon.
    const shouldUseProviderIcon = providerIcon != null && (0, $gdUUy.fg)('platform_lp_use_generator_icon_for_provider');
    const frameIconUrlOrElement = shouldUseProviderIcon ? providerIcon : iconUrlOrElement;
    const frameIconLabel = shouldUseProviderIcon ? providerIconLabel : undefined;
    const icon = (0, $bSJIT.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(frameIconUrlOrElement)) return frameIconUrlOrElement;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $20jCm.ImageIcon), {
            src: typeof frameIconUrlOrElement === 'string' ? frameIconUrlOrElement : undefined,
            alt: frameIconLabel,
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                label: "icon",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        frameIconLabel,
        frameIconUrlOrElement
    ]);
    const image = (0, $bSJIT.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $9fU1q.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            "data-testid": imageTestId,
            className: (0, $9fU1q.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        }, imageUrlOrElement);
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hG27G.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": `${testId}-unresolved-container`,
        className: (0, $9fU1q.default)([
            "_1e0c11p5 _4t3i1kw7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
        ])
    }, image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "large",
        testId: `${testId}-unresolved-title`
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        align: "center",
        testId: `${testId}-unresolved-description`
    }, description), button)));
};
var $d1fd41ea13b3786a$export$2e2bcd8739ae039 = $d1fd41ea13b3786a$var$UnresolvedView;

});
parcelRegister("hG27G", function(module, exports) {
$parcel$export(module.exports, "ExpandedFrame", () => $cf5a162354bb0ecd$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $lavtv = parcelRequire("lavtv");

var $e6VxI = parcelRequire("e6VxI");

var $9Nf0e = parcelRequire("9Nf0e");

var $j9cT9 = parcelRequire("j9cT9");
const $cf5a162354bb0ecd$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk1j28 _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u1yw3",
    linkWrapperBorderAndBackground: "_1tqzia51 _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvia51 _4tpuhp5a _x148kb7n",
    header: "_11c81qyo _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c81qyo _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik1r31 _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c81qyo _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19itdlqj _2rkoy00x _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1tt7",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};
const $cf5a162354bb0ecd$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt, onContentMouseEnter: onContentMouseEnter, onContentMouseLeave: onContentMouseLeave })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $9Nf0e.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e6VxI.useMouseDownEvent)();
    const CompetitorPromptComponent = CompetitorPrompt && href ? /*#__PURE__*/ $bSJIT.createElement(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                $cf5a162354bb0ecd$var$styles.header,
                "embed-header"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                $cf5a162354bb0ecd$var$styles.leftSection
            ])
        }, /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                $cf5a162354bb0ecd$var$styles.headerIcon
            ])
        }, icon), /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                $cf5a162354bb0ecd$var$styles.tooltipWrapper
            ])
        }, !isPlaceholder && /*#__PURE__*/ $bSJIT.createElement((0, $lavtv.default), {
            content: text,
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ $bSJIT.createElement("a", {
            href: href,
            onClick: handleClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: handleMouseDown,
            className: (0, $9fU1q.default)([
                $cf5a162354bb0ecd$var$styles.headerAnchor
            ])
        }, text)))), CompetitorPromptComponent);
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ $bSJIT.createElement("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            onMouseEnter: onContentMouseEnter,
            onMouseLeave: onContentMouseLeave,
            onFocus: onContentMouseEnter,
            onBlur: onContentMouseLeave,
            className: (0, $9fU1q.default)([
                $cf5a162354bb0ecd$var$styles.contentStyle,
                setOverflow && allowScrollBar && $cf5a162354bb0ecd$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $cf5a162354bb0ecd$var$styles.contentInteractiveActiveBorder
            ])
        }, children);
    };
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            $cf5a162354bb0ecd$var$styles.linkWrapper,
            inheritDimensions && $cf5a162354bb0ecd$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $cf5a162354bb0ecd$var$styles.linkWrapperSelected,
            showBackgroundAlways && $cf5a162354bb0ecd$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $cf5a162354bb0ecd$var$styles.linkWrapperInteractiveNotHidden,
            (0, $j9cT9.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        }
    }, renderHeader(), renderContent());
};

});
parcelRegister("j9cT9", function(module, exports) {
$parcel$export(module.exports, "className", () => $ebedec67c301c328$export$2913c0c0b5623090);
$parcel$export(module.exports, "Image", () => $ebedec67c301c328$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");
const $ebedec67c301c328$export$2913c0c0b5623090 = 'media-card-frame';
const $ebedec67c301c328$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $ebedec67c301c328$export$3e431a229df88919 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $3zY6O.default)($ebedec67c301c328$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $ebedec67c301c328$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $3zY6O.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkizff _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("20jCm", function(module, exports) {
$parcel$export(module.exports, "ImageIcon", () => $16a637d91ef70da1$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $ktg9Z = parcelRequire("ktg9Z");

var $j9cT9 = parcelRequire("j9cT9");
const $16a637d91ef70da1$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $16a637d91ef70da1$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $bSJIT.useState)(false);
    // If url changes, reset state
    (0, $bSJIT.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $bSJIT.useCallback)(()=>{
        setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if (hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j9cT9.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            appearance === 'round' && $16a637d91ef70da1$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton ? {
            onError: handleError
        } : undefined
    });
    if (hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ktg9Z))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("ftDez", function(module, exports) {
$parcel$export(module.exports, "ForbiddenSVG", () => $1f20e906ffebb5fd$export$f51768a4e7ff128);

var $bSJIT = parcelRequire("bSJIT");
const $1f20e906ffebb5fd$export$f51768a4e7ff128 = ()=>{
    const gradientId = (0, $bSJIT.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: gradientId,
        gradientUnits: "userSpaceOnUse",
        x1: "49.4199",
        x2: "122.662",
        y1: "59.7673",
        y2: "59.7673"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0",
        stopColor: "#0065ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: ".2188",
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: ".5999",
        stopColor: "#2780ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
        fill: `url(#${gradientId})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
        fill: "#ff7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
        fill: "#344563"
    }));
};

});


parcelRegister("59VaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $97efb93bb44f0971$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $7wYyA = parcelRequire("7wYyA");

var $b2pmc = parcelRequire("b2pmc");

var $ic9rK = parcelRequire("ic9rK");

var $3wOSe = parcelRequire("3wOSe");
const $97efb93bb44f0971$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, providerIcon: providerIcon, providerIconLabel: providerIconLabel, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $bSJIT.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ic9rK.default), {
        ...unresolvedViewProps,
        icon: icon,
        providerIcon: providerIcon,
        providerIconLabel: providerIconLabel,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3wOSe.NotFoundSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $b2pmc.toMessage)((0, $7wYyA.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $b2pmc.toMessage)((0, $7wYyA.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $97efb93bb44f0971$export$2e2bcd8739ae039 = $97efb93bb44f0971$var$NotFoundView;

});
parcelRegister("3wOSe", function(module, exports) {
$parcel$export(module.exports, "NotFoundSVG", () => $1baf7b75502248b0$export$80542c1714a314c8);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
const $1baf7b75502248b0$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "1316.98",
        y1: "230.66",
        x2: "1396.36",
        y2: "230.66",
        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0",
        stopColor: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#6c798f"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "170.3",
        y1: "897.49",
        x2: "365.15",
        y2: "897.49",
        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0",
        stopColor: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.69",
        stopColor: "#fff",
        stopOpacity: "0.1"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("title", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        defaultMessage: "Search error",
        id: "smart-card.not-found-svg.title"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("g", {
        id: "Objects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "#cfd4db",
        d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        id: "_Path_",
        "data-name": "<Path>",
        fill: "url(#linear-gradient)",
        d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "#091e42",
        opacity: 0.1,
        d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "#344563",
        d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        id: "_Clipping_Path_",
        "data-name": "<Clipping Path>",
        fill: "#deebff",
        d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        id: "_Path_2",
        "data-name": "<Path>",
        fill: "#b2d4ff",
        d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "#cce0ff",
        d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "url(#linear-gradient-2)",
        d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("polygon", {
        id: "_Path_3",
        "data-name": "<Path>",
        fill: "#5e6c84",
        points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "#ffc400",
        d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "#ffc400",
        d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#344563",
        d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
    }))));

});


parcelRegister("8JRlG", function(module, exports) {
$parcel$export(module.exports, "EmbedCardResolvedView", () => $1d02b434a77211b5$export$30f3c6c32b384a8b);
/* ResolvedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $gRfjb = parcelRequire("gRfjb");

var $6bOBo = parcelRequire("6bOBo");

var $f7uwJ = parcelRequire("f7uwJ");

var $gdUUy = parcelRequire("gdUUy");

var $ceb9s = parcelRequire("ceb9s");

var $5kJPq = parcelRequire("5kJPq");

var $abuKh = parcelRequire("abuKh");

var $gy3md = parcelRequire("gy3md");

var $5axXA = parcelRequire("5axXA");

var $cUXyD = parcelRequire("cUXyD");

var $bN9Su = parcelRequire("bN9Su");

var $k5Giz = parcelRequire("k5Giz");

var $2bAcV = parcelRequire("2bAcV");

var $hG27G = parcelRequire("hG27G");

var $2rSR6 = parcelRequire("2rSR6");

var $20jCm = parcelRequire("20jCm");

var $keYQ4 = parcelRequire("keYQ4");

const $1d02b434a77211b5$var$EmbedRovoActionsFooter = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("iyf7t")).then((module)=>module.default),
    loading: ()=>null
});
$1d02b434a77211b5$var$EmbedRovoActionsFooter.displayName = 'lazy(EmbedRovoActionsFooter)';
const $1d02b434a77211b5$var$styles = {
    contentWithFooter: "_1e0c1txw _2lx21bp4 _4t3i1osq _1tkeidpf",
    frameWithFooter: "_16jlkb7n _1tkeidpf",
    footer: "_1e0c1txw _1bah1y6m _85i5u2gc _1q51u2gc _y4tiu2gc _bozgu2gc"
};
const $1d02b434a77211b5$var$EmbedFrameWithRovoFooter = ({ actionOptions: actionOptions, details: details, frame: frame, link: link, testId: testId })=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $cUXyD.default)();
    const { isEnabled: isEmbedRovoActionsFooterEnabled } = (0, $5axXA.default)(link, actionOptions, rovoOptions, product);
    const rovoActionData = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>isEmbedRovoActionsFooterEnabled && details ? (0, $abuKh.default)({
            response: details,
            rovoConfig: {
                rovoOptions: rovoOptions,
                product: product
            },
            product: product,
            actionOptions: actionOptions,
            appearance: (0, $5kJPq.CardDisplay).Embed
        }) : undefined, [
        actionOptions,
        details,
        isEmbedRovoActionsFooterEnabled,
        product,
        rovoOptions
    ]);
    const prompts = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (!isEmbedRovoActionsFooterEnabled) return [];
        return (0, $2bAcV.getRovoPostAuthPromptKeys)({
            extensionKey: (0, $gy3md.getExtensionKey)(details)
        });
    }, [
        details,
        isEmbedRovoActionsFooterEnabled
    ]);
    const footer = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>rovoActionData && prompts.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1d02b434a77211b5$var$EmbedRovoActionsFooter, {
            actionData: rovoActionData,
            prompts: prompts,
            testId: `${testId}-rovo-actions-footer`
        }) : undefined, [
        prompts,
        rovoActionData,
        testId
    ]);
    return footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $1d02b434a77211b5$var$styles.contentWithFooter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $1d02b434a77211b5$var$styles.frameWithFooter
        ])
    }, frame), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $1d02b434a77211b5$var$styles.footer
        ])
    }, footer)) : frame;
};
const $1d02b434a77211b5$var$EmbedFrameWithoutRovoFooter = ({ frame: frame })=>frame;
const $1d02b434a77211b5$var$EmbedFrameWithOptionalRovoFooter = (0, $f7uwJ.componentWithFG)('platform_sl_3p_auth_rovo_embed_footer_kill_switch', $1d02b434a77211b5$var$EmbedFrameWithRovoFooter, $1d02b434a77211b5$var$EmbedFrameWithoutRovoFooter);
const $1d02b434a77211b5$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ actionOptions: actionOptions, link: link, context: context, details: details, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isSupportProductContext: isSupportProductContext, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context === null || context === void 0 ? void 0 : context.icon;
    const iconLabel = context === null || context === void 0 ? void 0 : context.iconLabel;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || (context === null || context === void 0 ? void 0 : context.text);
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
            label: "icon",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $20jCm.ImageIcon), {
            src: src,
            alt: iconLabel,
            default: linkGlyph,
            appearance: (0, $k5Giz.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton,
        iconLabel
    ]);
    (0, $keYQ4.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $ceb9s.useThemeObserver)();
    const { product: product } = (0, $6bOBo.useSmartLinkContext)();
    let previewUrl = preview === null || preview === void 0 ? void 0 : preview.src;
    const hostProduct = (0, $gdUUy.fg)('platform_avp_smartlink_embed_product_context') && isSupportProductContext ? product : undefined;
    if (previewUrl && (isSupportTheming || hostProduct)) previewUrl = (0, $bN9Su.getPreviewUrlWithEmbedContext)(previewUrl, {
        hostProduct: hostProduct,
        themeState: isSupportTheming ? themeState : undefined
    });
    const [isMouseOver, setMouseOver] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2rSR6.Frame), {
        url: previewUrl,
        isTrusted: isTrusted,
        testId: testId,
        ref: embedIframeRef,
        onIframeDwell: onIframeDwell,
        onIframeFocus: onIframeFocus,
        onIframeMouseEnter: onIframeMouseEnter,
        onIframeMouseLeave: onIframeMouseLeave,
        isMouseOver: isMouseOver,
        title: text,
        extensionKey: extensionKey
    });
    const frameWithFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1d02b434a77211b5$var$EmbedFrameWithOptionalRovoFooter, {
        actionOptions: actionOptions,
        details: details,
        frame: frame,
        link: link,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hG27G.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        onContentMouseEnter: ()=>{
            setMouseOver(true);
            onIframeMouseEnter === null || onIframeMouseEnter === void 0 || onIframeMouseEnter();
        },
        onContentMouseLeave: ()=>{
            setMouseOver(false);
            onIframeMouseLeave === null || onIframeMouseLeave === void 0 || onIframeMouseLeave();
        }
    }, frameWithFooter);
});

});
parcelRegister("5axXA", function(module, exports) {
$parcel$export(module.exports, "EMBED_ROVO_ACTIONS_FOOTER_EXPERIMENT_KEY", () => $c0e47ac0b44c8ff3$export$76c8c65be40d033d);
$parcel$export(module.exports, "default", () => $c0e47ac0b44c8ff3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1R1LG = parcelRequire("1R1LG");

var $gy3md = parcelRequire("gy3md");

var $2TtjQ = parcelRequire("2TtjQ");

var $jyaKA = parcelRequire("jyaKA");

var $jGxHF = parcelRequire("jGxHF");
const $c0e47ac0b44c8ff3$export$76c8c65be40d033d = 'platform_sl_3p_auth_rovo_embed_footer_exp';
const $c0e47ac0b44c8ff3$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
const $c0e47ac0b44c8ff3$var$useEmbedRovoActionsFooterExperiment = (url, actionOptions, rovoOptions, product)=>{
    var _actionOptions$rovoCh;
    const isRovoChatEnabled = (0, $1R1LG.getIsRovoChatEnabled)(rovoOptions);
    const cardState = (0, $2TtjQ.useSmartCardState)(url ?? '');
    const extensionKey = (0, $gy3md.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false;
    return (0, $bSJIT.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn || !extensionKey) return $c0e47ac0b44c8ff3$var$NOT_ENABLED_RESULT;
        if (!(0, $jyaKA.isEligibleEmbedRovoActionsFooterExtensionKey)(extensionKey)) return $c0e47ac0b44c8ff3$var$NOT_ENABLED_RESULT;
        return {
            isEnabled: (0, $jGxHF.isEmbedRovoActionsFooterExperimentEnabled)(product)
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $c0e47ac0b44c8ff3$export$2e2bcd8739ae039 = $c0e47ac0b44c8ff3$var$useEmbedRovoActionsFooterExperiment;

});
parcelRegister("jyaKA", function(module, exports) {
$parcel$export(module.exports, "isEligibleEmbedRovoActionsFooterExtensionKey", () => $f13098d2a2038519$export$76997e71dbb58c72);
const $f13098d2a2038519$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS = new Set([
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'gitlab-object-provider'
]);
const $f13098d2a2038519$export$76997e71dbb58c72 = (extensionKey)=>extensionKey !== undefined && $f13098d2a2038519$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS.has(extensionKey);

});

parcelRegister("jGxHF", function(module, exports) {
$parcel$export(module.exports, "isEmbedRovoActionsFooterExperimentEnabled", () => $123fbea6b80ed5b4$export$f52bc2858cff4634);

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $5axXA = parcelRequire("5axXA");
const $123fbea6b80ed5b4$export$f52bc2858cff4634 = (product)=>{
    return product === 'CONFLUENCE' && (0, $gdUUy.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch') && (0, $5N1Y4.expValEquals)((0, $5axXA.EMBED_ROVO_ACTIONS_FOOTER_EXPERIMENT_KEY), 'isEnabled', true);
};

});


parcelRegister("2bAcV", function(module, exports) {
$parcel$export(module.exports, "getRovoPostAuthPromptKeys", () => $3a3c95372fb13f0b$export$126e73c0e270bd5c);

var $4xVXc = parcelRequire("4xVXc");
const $3a3c95372fb13f0b$export$126e73c0e270bd5c = ({ extensionKey: extensionKey })=>{
    const defaultPrompts = [
        (0, $4xVXc.RovoChatPromptKey).KEY_HIGHLIGHTS
    ];
    if (extensionKey === 'github-object-provider' || extensionKey === 'gitlab-object-provider') return [
        (0, $4xVXc.RovoChatPromptKey).EXPLAIN_CODE,
        ...defaultPrompts
    ];
    return [
        (0, $4xVXc.RovoChatPromptKey).SUMMARIZE_DOCUMENT,
        ...defaultPrompts
    ];
};

});

parcelRegister("2rSR6", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $475ba81ae8a619c2$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $c9wRy = parcelRequire("c9wRy");

var $gdUUy = parcelRequire("gdUUy");

var $3H40Y = parcelRequire("3H40Y");

var $akSvW = parcelRequire("akSvW");

var $2J8Ar = parcelRequire("2J8Ar");
function $475ba81ae8a619c2$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $475ba81ae8a619c2$var$iframeStyles = null;
const $475ba81ae8a619c2$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isMouseOver: isMouseOverProp, title: title, extensionKey: extensionKey }, iframeRef)=>{
    const doc = (0, $c9wRy.getDocument)();
    const [isIframeLoaded, setIframeLoaded] = (0, $bSJIT.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $bSJIT.useState)(false);
    // Accessing the document here for SSR where document.hasFocus may be absent breaks SSR
    // when we're trying to load things like Loom frames in SSR
    // We _could_ either throw a guard in here (i.e check for the existence of document)
    // _or_
    // we can default to false, and set this state once the frame ref is available in a useEffect (safer IMO)
    // which already seems to be existing behavior in a useEffect below.
    const [isWindowFocused, setWindowFocused] = (0, $bSJIT.useState)(// The below will be removed as part of FG cleanup
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (0, $gdUUy.fg)('jpx-1074-smart-links-iframe') ? (doc === null || doc === void 0 ? void 0 : doc.hasFocus()) ?? false : document.hasFocus());
    // Use prop if provided (from wrapper), otherwise use local state (for backward compatibility)
    const effectiveMouseOver = isMouseOverProp !== undefined ? isMouseOverProp : isMouseOver;
    const ref = (0, $bSJIT.useRef)();
    const mergedRef = $475ba81ae8a619c2$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $bSJIT.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $bSJIT.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry === null || entry === void 0 ? void 0 : entry.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // Initialize with current focus state
        // The below will be removed as part of FG cleanup
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        setWindowFocused((0, $gdUUy.fg)('jpx-1074-smart-links-iframe') ? (doc === null || doc === void 0 ? void 0 : doc.hasFocus()) ?? false : document.hasFocus());
        const onBlur = ()=>{
            setWindowFocused(false);
            if ((0, $gdUUy.fg)('jpx-1074-smart-links-iframe')) {
                if ((doc === null || doc === void 0 ? void 0 : doc.activeElement) === ref.current) onIframeFocus && onIframeFocus();
            } else // The below will be removed as part of FG cleanup
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus,
        doc
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2J8Ar.IframeDwellTracker), {
        isIframeLoaded: isIframeLoaded,
        isMouseOver: effectiveMouseOver,
        isWindowFocused: isWindowFocused,
        iframePercentVisible: percentVisible,
        onIframeDwell: onIframeDwell
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $akSvW.IFrame), {
        childRef: mergedRef,
        src: url,
        "data-testid": `${testId}-frame`,
        "data-test-iframe-loaded": isIframeLoaded,
        onMouseEnter: ()=>{
            onIframeMouseEnter === null || onIframeMouseEnter === void 0 || onIframeMouseEnter();
            // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(true);
        },
        onMouseLeave: ()=>{
            onIframeMouseLeave === null || onIframeMouseLeave === void 0 || onIframeMouseLeave();
            // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(false);
        },
        allowFullScreen: true,
        scrolling: "yes",
        allow: "autoplay; encrypted-media; clipboard-write",
        onLoad: ()=>{
            setIframeLoaded(true);
        },
        sandbox: (0, $3H40Y.getIframeSandboxAttribute)(isTrusted),
        title: title,
        extensionKey: extensionKey,
        className: (0, $9fU1q.default)([
            "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
        ])
    }));
});

});
parcelRegister("2J8Ar", function(module, exports) {
$parcel$export(module.exports, "IframeDwellTracker", () => $1cd356fe79e95ac4$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $1cd356fe79e95ac4$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $1cd356fe79e95ac4$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $bSJIT.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $bSJIT.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $bSJIT.useEffect)(()=>{
        if (dwell.time > 0 && $1cd356fe79e95ac4$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $bSJIT.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        // Require: iframe loaded, mouse over, and >75% visible.
        // Note: isWindowFocused is intentionally not required - it's unreliable and
        // prevents tracking. The mouse over check is sufficient to indicate user engagement.
        const shouldTrack = isIframeLoaded && isMouseOver && iframePercentVisible > 0.75;
        if (shouldTrack) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        } else if (dwellTimeoutId.current) {
            clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = undefined;
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("keYQ4", function(module, exports) {
$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $8fc7dab0071af36b$export$50ac35a9a8f2ebaa);

var $bSJIT = parcelRequire("bSJIT");

var $1Nceg = parcelRequire("1Nceg");
const $8fc7dab0071af36b$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $1Nceg.default)();
    (0, $bSJIT.useEffect)(()=>{
        const messageCallback = (event)=>{
            var _embedIframeRef$curre;
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === ((_embedIframeRef$curre = embedIframeRef.current) === null || _embedIframeRef$curre === void 0 ? void 0 : _embedIframeRef$curre.contentWindow);
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve({
                url: url,
                isReloading: true
            });
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});

parcelRegister("iyf7t", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("byRdO").then(()=>parcelRequire('h3WGY'));

});


parcelRegister("1FGB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd1c8dca37b4509$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jNJGJ = parcelRequire("jNJGJ");

var $87QgR = parcelRequire("87QgR");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $50jzR = parcelRequire("50jzR");

var $ic9rK = parcelRequire("ic9rK");

var $lhDGM = parcelRequire("lhDGM");

var $3DMnE = parcelRequire("3DMnE");
const $6bd1c8dca37b4509$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $bSJIT.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $bSJIT.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: (context === null || context === void 0 ? void 0 : context.text) ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
                    ...(0, $7wYyA.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $50jzR.default), {
                    providerName: context === null || context === void 0 ? void 0 : context.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
                    ...(0, $7wYyA.messages).connect_unauthorised_account_action,
                    values: values
                }))
            };
        }
        const values = context !== null && context !== void 0 && context.text ? {
            context: context === null || context === void 0 ? void 0 : context.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
                ...(0, $7wYyA.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
                ...(0, $7wYyA.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).unauthorised_account_name_no_provider),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).unauthorised_account_description_no_provider)
        };
    }, [
        context === null || context === void 0 ? void 0 : context.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ic9rK.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context === null || context === void 0 ? void 0 : context.icon,
        providerIcon: context === null || context === void 0 ? void 0 : context.providerIcon,
        providerIconLabel: context === null || context === void 0 ? void 0 : context.providerIconLabel,
        image: (context === null || context === void 0 ? void 0 : context.image) ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lhDGM.UnauthorizedSVG), null),
        testId: testId,
        text: context === null || context === void 0 ? void 0 : context.text
    });
};
const $6bd1c8dca37b4509$var$UnauthorizedViewGated = (props)=>{
    if ((0, $87QgR.default).initializeCompleted() && (0, $87QgR.default).getExperimentValue('platform_sl_embed_preauth_teaser_exp', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3DMnE.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6bd1c8dca37b4509$var$UnauthorizedView, props);
};
var $6bd1c8dca37b4509$export$2e2bcd8739ae039 = $6bd1c8dca37b4509$var$UnauthorizedViewGated;

});
parcelRegister("lhDGM", function(module, exports) {
$parcel$export(module.exports, "UnauthorizedSVG", () => $713cd7b786dad474$export$6526edaac83a8c90);

var $bSJIT = parcelRequire("bSJIT");
const $713cd7b786dad474$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("g", {
        clipPath: "url(#clip0_1375_267)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        transform: "translate(0.870117 0.509766)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
        stroke: "url(#paint0_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
        fill: "#403294"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        opacity: "0.25",
        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
        fill: "url(#paint1_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        opacity: "0.25",
        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
        fill: "url(#paint2_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
        stroke: "url(#paint3_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        opacity: "0.38",
        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
        fill: "url(#paint4_radial_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
        fill: "url(#paint5_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
        fill: "url(#paint6_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
        fill: "url(#paint7_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
        fill: "url(#paint8_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
        fill: "url(#paint9_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
        fill: "url(#paint10_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
        fill: "url(#paint11_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
        fill: "url(#paint12_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
        fill: "url(#paint13_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
        fill: "url(#paint14_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
        fill: "url(#paint15_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
        fill: "url(#paint16_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
        fill: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
        fill: "url(#paint17_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
        fill: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
        fill: "url(#paint18_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint0_linear_1375_267",
        x1: "141.994",
        y1: "181.192",
        x2: "0.870117",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#C1C7D0",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint1_linear_1375_267",
        x1: "208.292",
        y1: "264.428",
        x2: "0.870117",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint2_linear_1375_267",
        x1: "357.327",
        y1: "264.428",
        x2: "564.748",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint3_linear_1375_267",
        x1: "423.624",
        y1: "181.192",
        x2: "564.748",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.1724",
        stopColor: "#076AFF",
        stopOpacity: "0.8007"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.4145",
        stopColor: "#1976FF",
        stopOpacity: "0.5208"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.6966",
        stopColor: "#378BFF",
        stopOpacity: "0.1947"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.8651",
        stopColor: "#4C9AFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("radialGradient", {
        id: "paint4_radial_1375_267",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(285 99.0229) scale(96.5182)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.1584",
        stopColor: "#FFE587",
        stopOpacity: "0.8416"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.3589",
        stopColor: "#FFDA57",
        stopOpacity: "0.6411"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.5498",
        stopColor: "#FFD031",
        stopOpacity: "0.4502"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.7256",
        stopColor: "#FFC916",
        stopOpacity: "0.2744"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.8811",
        stopColor: "#FFC506",
        stopOpacity: "0.1189"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint5_linear_1375_267",
        x1: "346.074",
        y1: "98.8386",
        x2: "423.624",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint6_linear_1375_267",
        x1: "237.087",
        y1: "120.044",
        x2: "276.412",
        y2: "120.044",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint7_linear_1375_267",
        x1: "237.087",
        y1: "75.0106",
        x2: "276.412",
        y2: "75.0106",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint8_linear_1375_267",
        x1: "335.969",
        y1: "146.593",
        x2: "335.969",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint9_linear_1375_267",
        x1: "219.544",
        y1: "98.8386",
        x2: "141.994",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint10_linear_1375_267",
        x1: "229.65",
        y1: "146.593",
        x2: "229.65",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#F4F5F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint11_linear_1375_267",
        x1: "402.858",
        y1: "216.64",
        x2: "421.684",
        y2: "223.492",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.8134",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.8713",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint12_linear_1375_267",
        x1: "376.968",
        y1: "157.139",
        x2: "433.936",
        y2: "157.139",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint13_linear_1375_267",
        x1: "289.638",
        y1: "45.0027",
        x2: "289.638",
        y2: "0.510323",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint14_linear_1375_267",
        x1: "262.238",
        y1: "36.2259",
        x2: "272.592",
        y2: "36.2259",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint15_linear_1375_267",
        x1: "259.6",
        y1: "180.859",
        x2: "259.6",
        y2: "141.017",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint16_linear_1375_267",
        x1: "284.971",
        y1: "171.613",
        x2: "284.971",
        y2: "149.45",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint17_linear_1375_267",
        x1: "157.982",
        y1: "221.995",
        x2: "188.627",
        y2: "221.995",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "0.3435",
        stopColor: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#998DD9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint18_linear_1375_267",
        x1: "163.185",
        y1: "155.517",
        x2: "213.758",
        y2: "155.517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#8777D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("clipPath", {
        id: "clip0_1375_267"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        fill: "white",
        transform: "translate(0.870117 0.509766)"
    }))));

});

parcelRegister("3DMnE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a205cd44b592a97b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gRfjb = parcelRequire("gRfjb");

var $7oVIU = parcelRequire("7oVIU");

var $67YKA = parcelRequire("67YKA");

var $lwnsx = parcelRequire("lwnsx");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $cUXyD = parcelRequire("cUXyD");

var $kzuy3 = parcelRequire("kzuy3");

var $hG27G = parcelRequire("hG27G");

var $20jCm = parcelRequire("20jCm");

var $2qgkz = parcelRequire("2qgkz");

var $26YVQ = parcelRequire("26YVQ");

var $lrg6K = parcelRequire("lrg6K");

var $8Fgn1 = parcelRequire("8Fgn1");

var $fdjz6 = parcelRequire("fdjz6");
const $a205cd44b592a97b$var$PARENT_PRODUCT = {
    ATLAS: 'ATLAS',
    BITBUCKET: 'BITBUCKET',
    CONFLUENCE: 'CONFLUENCE',
    CSM: 'JIRA',
    JPD: 'JIRA',
    JSM: 'JIRA',
    JSW: 'JIRA',
    JWM: 'JIRA',
    TRELLO: 'TRELLO'
};
const $a205cd44b592a97b$var$PRODUCT_COMPANION = {
    ATLAS: 'ATLAS',
    BITBUCKET: 'BITBUCKET',
    CONFLUENCE: 'JIRA',
    JIRA: 'CONFLUENCE',
    TRELLO: 'TRELLO'
};
const $a205cd44b592a97b$var$UnauthorizedCarouselView = ({ context: context, frameStyle: frameStyle, inheritDimensions: inheritDimensions, isSelected: isSelected, onAuthorize: onAuthorize, onClick: onClick, testId: testId = 'embed-card-unauthorized-view', url: url })=>{
    const intl = (0, $4vLTk.default)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const { rovoOptions: rovoOptions, product: product } = (0, $cUXyD.default)();
    const canAuthorize = typeof onAuthorize === 'function';
    const providerName = context === null || context === void 0 ? void 0 : context.text;
    const providerIcon = (0, $bSJIT.useMemo)(()=>{
        const iconLabel = (context === null || context === void 0 ? void 0 : context.iconLabel) ?? (context === null || context === void 0 ? void 0 : context.text) ?? '';
        if (typeof (context === null || context === void 0 ? void 0 : context.icon) === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lwnsx.default), {
            src: context.icon,
            alt: iconLabel
        });
        if (context !== null && context !== void 0 && context.icon) return context.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
            appearance: "blue",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7oVIU))),
            label: iconLabel,
            size: "small",
            testId: "embed-card-fallback-icon"
        });
    }, [
        context
    ]);
    const items = (0, $bSJIT.useMemo)(()=>{
        if (!canAuthorize) return [
            {
                id: 'no-auth-available',
                title: intl.formatMessage((0, $7wYyA.messages).unauthorised_account_name_no_provider),
                description: intl.formatMessage((0, $7wYyA.messages).unauthorised_account_description_no_provider),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lrg6K.default), null)
            }
        ];
        const parentProduct = product ? $a205cd44b592a97b$var$PARENT_PRODUCT[product] : undefined;
        const parentProductIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Fgn1.default), {
            product: parentProduct
        });
        const parentProductAlt = parentProduct ? $a205cd44b592a97b$var$PRODUCT_COMPANION[parentProduct] : parentProduct;
        const parentProductIconAlt = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Fgn1.default), {
            product: parentProductAlt
        });
        // We only have special text for Google Drive and i18n select takes only one word (no space).
        const i18nSelectContext = (context === null || context === void 0 ? void 0 : context.text) === 'Google Drive' ? 'Google' : context === null || context === void 0 ? void 0 : context.text;
        const slides = [
            {
                id: 'smart-link-benefit',
                title: intl.formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_sl_title),
                description: intl.formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_sl_description, {
                    context: i18nSelectContext,
                    product: parentProduct
                }),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fdjz6.default), {
                    productIcon: parentProductIcon,
                    providerIcon: providerIcon
                })
            }
        ];
        // If the link has an unauthorized status and provides an onAuthorize callback,
        // it is likely a 3P (third-party) link and is supported by Rovo. In that case,
        // we show additional Rovo-specific teaser slides to encourage the user to connect their account.
        if (rovoOptions !== null && rovoOptions !== void 0 && rovoOptions.isRovoEnabled) slides.push({
            id: 'rovo-search-benefit',
            title: intl.formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_rovo_title),
            description: intl.formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_rovo_description, {
                context: providerName,
                product: parentProduct
            }),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26YVQ.default), {
                productIcon: parentProductIcon,
                productIconAlt: parentProductIconAlt,
                providerIcon: providerIcon
            }))
        });
        if (rovoOptions !== null && rovoOptions !== void 0 && rovoOptions.isRovoEnabled && rovoOptions !== null && rovoOptions !== void 0 && rovoOptions.isRovoLLMEnabled) slides.push({
            id: 'rovo-chat-benefit',
            title: intl.formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_rovochat_title),
            description: intl.formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_rovochat_description, {
                context: providerName
            }),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2qgkz.default), {
                productIcon: parentProductIcon,
                productIconAlt: parentProductIconAlt,
                providerIcon: providerIcon
            }))
        });
        return slides;
    }, [
        canAuthorize,
        context,
        intl,
        product,
        providerName,
        providerIcon,
        rovoOptions
    ]);
    const handleOnAuthorizeClick = (0, $bSJIT.useCallback)((slideId)=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            fireEvent('ui.button.clicked.carouselConnect', {
                display: 'embed',
                slideId: slideId
            });
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const handleOnNextClick = (0, $bSJIT.useCallback)((slideId)=>{
        fireEvent('ui.button.clicked.carouselNext', {
            display: 'embed',
            slideId: slideId
        });
    }, [
        fireEvent
    ]);
    const buttonLabel = context !== null && context !== void 0 && context.text ? intl.formatMessage((0, $7wYyA.messages).connect_3p_account, {
        context: context.text
    }) : intl.formatMessage((0, $7wYyA.messages).connect_link_account_card);
    const icon = (0, $bSJIT.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(context === null || context === void 0 ? void 0 : context.icon)) return context.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $20jCm.ImageIcon), {
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                label: "icon",
                color: "currentColor"
            }),
            src: typeof (context === null || context === void 0 ? void 0 : context.icon) === 'string' ? context.icon : undefined
        });
    }, [
        context === null || context === void 0 ? void 0 : context.icon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hG27G.ExpandedFrame), {
        allowScrollBar: true,
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        isSelected: isSelected,
        inheritDimensions: inheritDimensions,
        onClick: onClick,
        setOverflow: true,
        testId: testId,
        text: context === null || context === void 0 ? void 0 : context.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kzuy3.default), {
        icon: context === null || context === void 0 ? void 0 : context.icon,
        iconLabel: context === null || context === void 0 ? void 0 : context.text,
        items: items,
        onNextClick: handleOnNextClick,
        onPrimaryButtonClick: canAuthorize ? handleOnAuthorizeClick : undefined,
        primaryButtonLabel: buttonLabel,
        testId: `${testId}-carousel`
    }));
};
var $a205cd44b592a97b$export$2e2bcd8739ae039 = $a205cd44b592a97b$var$UnauthorizedCarouselView;

});
parcelRegister("kzuy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a377f497715510f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $35pge = parcelRequire("35pge");
const $0a377f497715510f$var$styles = {
    carousel: "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _kqswh2mm"
};
const $0a377f497715510f$var$fadeIn = null;
const $0a377f497715510f$var$slideWrapperMap = {
    static: "_1bsb1osq _4t3i1osq",
    animated: "_1bsb1osq _4t3i1osq _j7hq1wwu _5sagjx92 _1pglafbj _1o511hrf _bl8aglyw _2hwzhgkh"
};
/**
 * Derives layout size bucket from pixel dimensions.
 * Used instead of CSS @container queries (which are blocked by the linter)
 * to control which elements are shown at different card sizes.
 */ const $0a377f497715510f$var$getSize = (width, height)=>{
    if (width < 200 || height < 100) return 'minimal';
    if (width < 400 || height < 140) return 'compact';
    return 'full';
};
const $0a377f497715510f$var$Carousel = ({ icon: icon, iconLabel: iconLabel, initialSlideIndex: initialSlideIndex = 0, items: items, onNextClick: onNextClick, onPrimaryButtonClick: onPrimaryButtonClick, primaryButtonLabel: primaryButtonLabel, testId: testId = 'embed-card-teaser-carousel' })=>{
    const [activeIndex, setActiveIndex] = (0, $bSJIT.useState)(initialSlideIndex);
    const [size, setSize] = (0, $bSJIT.useState)('full');
    // Tracks whether the user has navigated at least once.
    // The first slide is rendered statically (no animation) to avoid any
    // CSS animation running during SSR or on the initial paint.
    const hasNavigated = (0, $bSJIT.useRef)(false);
    const containerRef = (0, $bSJIT.useRef)(null);
    // Observe the carousel container's size and update the layout bucket.
    (0, $bSJIT.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            const { width: width, height: height } = entry.contentRect;
            setSize($0a377f497715510f$var$getSize(width, height));
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    const goNext = (0, $bSJIT.useCallback)(()=>{
        hasNavigated.current = true;
        onNextClick === null || onNextClick === void 0 || onNextClick(items[activeIndex].id);
        setActiveIndex((current)=>(current + 1) % items.length);
    }, [
        items,
        activeIndex,
        onNextClick
    ]);
    const goTo = (0, $bSJIT.useCallback)((index)=>{
        if (index === activeIndex) return;
        hasNavigated.current = true;
        setActiveIndex(index);
    }, [
        activeIndex
    ]);
    const handlePrimaryButtonClick = (0, $bSJIT.useCallback)(()=>{
        onPrimaryButtonClick === null || onPrimaryButtonClick === void 0 || onPrimaryButtonClick(items[activeIndex].id);
    }, [
        onPrimaryButtonClick,
        items,
        activeIndex
    ]);
    const currentSlide = items[activeIndex];
    const isLastSlide = activeIndex === items.length - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        ref: containerRef,
        xcss: $0a377f497715510f$var$styles.carousel,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        key: activeIndex,
        xcss: $0a377f497715510f$var$slideWrapperMap[hasNavigated.current ? 'animated' : 'static'],
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35pge.default), {
        primaryButtonLabel: primaryButtonLabel,
        description: currentSlide.description,
        icon: icon,
        iconLabel: iconLabel,
        image: currentSlide.image,
        title: currentSlide.title,
        onPrimaryButtonClick: onPrimaryButtonClick ? handlePrimaryButtonClick : undefined,
        onDotClick: goTo,
        onNextClick: !isLastSlide ? goNext : undefined,
        size: size,
        slideIndex: activeIndex,
        testId: `${testId}-slide`,
        totalSlides: items.length
    })));
};
var $0a377f497715510f$export$2e2bcd8739ae039 = $0a377f497715510f$var$Carousel;

});
parcelRegister("35pge", function(module, exports) {
$parcel$export(module.exports, "default", () => $67b9cc03129827cf$export$2e2bcd8739ae039);
/* CarouselSlide.tsx generated by @compiled/babel-plugin v3.0.2 */ /* CarouselSlide.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $jDsoo = parcelRequire("jDsoo");

var $7WQx2 = parcelRequire("7WQx2");

var $7oVIU = parcelRequire("7oVIU");

var $67YKA = parcelRequire("67YKA");

var $lwnsx = parcelRequire("lwnsx");

var $9PwDt = parcelRequire("9PwDt");
var $gXqq0 = parcelRequire("gXqq0");
var $8aT4G = parcelRequire("8aT4G");

var $7wYyA = parcelRequire("7wYyA");
const $67b9cc03129827cf$var$styles = {
    columnImage: "_16jlkb7n _1o9zkb7n _i0dlghg7 _1reo15vq _18m915vq _1e0c1txw _4cvr1fhb _1bah1y6m _1tkeidpf _1ul9idpf _bfhk9pm7",
    imageContainer: "_kqswh2mm _1bsb1osq _4t3i1osq",
    imageAbsolute: "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq",
    columnContent: "_zulp1ejb _16jlkb7n _1o9zkb7n _i0dluuw1 _1reo1wug _18m91wug _1e0c1txw _2lx21bp4 _1tkeidpf _ca0q1jfw _u5f31jfw _n3td1jfw _19bv1jfw _4cvr1y6m _1bah1yb4",
    columnContentTop: "_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsb1osq",
    columnContentBody: "_zulp1ejb _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsb1osq",
    columnContentCompact: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    dot: "_2rko1rr0 _1bsbftgi _4t3iftgi _bfhki8nm _1oecfnf5 _k8m01k61 _6fl45ucs _lcxvglyw",
    dotActive: "_bfhkjmqp",
    dotPassable: "_2rko1rr0 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz _bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    icon: "_2rko12b0 _1reo15vq _18m915vq _1o9zidpf _1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconImage: "_1bsb1osq _4t3i1osq _5ral1f51",
    image: "_1bsb1osq _c71l1wdt _5ral1f51 _rsufaqso _1e0c1ule",
    rowButton: "_zulpu2gc _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o",
    rowButtonCompact: "_1bsb1osq",
    rowDot: "_zulpze3t _1e0c1txw _2lx2vrvc _4cvr1h6o",
    rowIcon: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    slide: "_1reo15vq _18m915vq _1e0c1txw _1n261q9c _1bsb1osq _4t3i1osq _4cvr1fhb _vchhusvi"
};
const $67b9cc03129827cf$var$CarouselSlide = ({ icon: icon, iconLabel: iconLabel = '', title: title, description: description, image: image, primaryButtonLabel: primaryButtonLabel, onPrimaryButtonClick: onPrimaryButtonClick, onDotClick: onDotClick, onNextClick: onNextClick, slideIndex: slideIndex, totalSlides: totalSlides, size: size, testId: testId = 'embed-card-carousel-slide' })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isCompact = size !== 'full';
    const showPrimaryButton = typeof onPrimaryButtonClick === 'function';
    const showNavigation = totalSlides > 1;
    const renderedIcon = (0, $bSJIT.useMemo)(()=>{
        if (typeof icon === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: $67b9cc03129827cf$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lwnsx.default), {
            src: icon,
            alt: iconLabel,
            className: (0, $9fU1q.default)([
                $67b9cc03129827cf$var$styles.iconImage
            ])
        }));
        if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: $67b9cc03129827cf$var$styles.icon
        }, icon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
            appearance: "blue",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7oVIU))),
            label: iconLabel,
            size: "small",
            testId: "embed-card-fallback-icon"
        });
    }, [
        icon,
        iconLabel
    ]);
    const renderedImage = image == null ? null : typeof image === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lwnsx.default), {
        src: image,
        alt: title,
        className: (0, $9fU1q.default)([
            $67b9cc03129827cf$var$styles.image
        ])
    }) : image;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.slide,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($67b9cc03129827cf$var$styles.columnContent, isCompact && $67b9cc03129827cf$var$styles.columnContentCompact)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.columnContentTop
    }, showPrimaryButton && isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($67b9cc03129827cf$var$styles.rowButton, $67b9cc03129827cf$var$styles.rowButtonCompact)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        shouldFitContainer: true,
        testId: `${testId}-connect-compact`
    }, primaryButtonLabel)), renderedIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.rowIcon
    }, renderedIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "medium",
        testId: `${testId}-title`
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.columnContentBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `${testId}-description`
    }, description)), (showPrimaryButton && !isCompact || showNavigation && onNextClick) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.rowButton
    }, showPrimaryButton && !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        testId: `${testId}-connect`
    }, primaryButtonLabel), showNavigation && onNextClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "subtle",
        onClick: onNextClick,
        testId: `${testId}-next`
    }, formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_button_next))))), showNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.rowDot,
        role: "group",
        "aria-label": formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_dot_row_label)
    }, Array.from({
        length: totalSlides
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
            key: i,
            xcss: $67b9cc03129827cf$var$styles.dotPassable,
            onClick: ()=>onDotClick === null || onDotClick === void 0 ? void 0 : onDotClick(i),
            "aria-label": formatMessage((0, $7wYyA.messages).connect_link_account_embed_carousel_dot_label, {
                index: i + 1,
                total: totalSlides
            }),
            "aria-current": i === slideIndex ? 'true' : undefined,
            testId: `${testId}-dot-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: (0, $jDsoo.cx)($67b9cc03129827cf$var$styles.dot, i === slideIndex && $67b9cc03129827cf$var$styles.dotActive)
        }))))), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.columnImage,
        testId: `${testId}-image-panel-${slideIndex}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $67b9cc03129827cf$var$styles.imageAbsolute
    }, renderedImage))));
};
var $67b9cc03129827cf$export$2e2bcd8739ae039 = $67b9cc03129827cf$var$CarouselSlide;

});


parcelRegister("2qgkz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b0628d12b23d858$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

const $3b0628d12b23d858$var$LazyRovoChatBenefitImage = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("7rN58")));
var $3b0628d12b23d858$export$2e2bcd8739ae039 = $3b0628d12b23d858$var$LazyRovoChatBenefitImage;

});
parcelRegister("7rN58", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2TrwO").then(()=>parcelRequire('fTLf2'));

});


parcelRegister("26YVQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $aeeaf0b965be5b32$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

const $aeeaf0b965be5b32$var$LazyRovoSearchBenefitImage = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("9t88w")));
var $aeeaf0b965be5b32$export$2e2bcd8739ae039 = $aeeaf0b965be5b32$var$LazyRovoSearchBenefitImage;

});
parcelRegister("9t88w", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1Wrll").then(()=>parcelRequire('1X3mx'));

});


parcelRegister("lrg6K", function(module, exports) {
$parcel$export(module.exports, "default", () => $891a903464f7abd8$export$2e2bcd8739ae039);
/* NoAuthAvailableImage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $lhDGM = parcelRequire("lhDGM");
const $891a903464f7abd8$var$styles = {
    container: "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _ca0q1ejb _n3td1ejb"
};
const $891a903464f7abd8$var$NoAuthAvailableImage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $891a903464f7abd8$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lhDGM.UnauthorizedSVG), null));
var $891a903464f7abd8$export$2e2bcd8739ae039 = $891a903464f7abd8$var$NoAuthAvailableImage;

});

parcelRegister("8Fgn1", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e8d81846b2afdd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $iajVF = parcelRequire("iajVF");

var $5OPcB = parcelRequire("5OPcB");

var $4eIWR = parcelRequire("4eIWR");

var $jSH6l = parcelRequire("jSH6l");

var $lR9hI = parcelRequire("lR9hI");

var $d8PXx = parcelRequire("d8PXx");
const $91e8d81846b2afdd$var$ProductIcon = ({ product: product, size: size = 'xsmall' })=>{
    switch(product){
        case 'ATLAS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lR9hI.ProjectsIcon), {
                size: size
            });
        case 'BITBUCKET':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5OPcB.BitbucketIcon), {
                size: size
            });
        case 'CONFLUENCE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4eIWR.ConfluenceIcon), {
                size: size
            });
        case 'JIRA':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jSH6l.JiraIcon), {
                size: size
            });
        case 'TRELLO':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d8PXx.TrelloIcon), {
                size: size
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iajVF.AtlassianIcon), {
                appearance: "brand",
                size: size
            });
    }
};
var $91e8d81846b2afdd$export$2e2bcd8739ae039 = $91e8d81846b2afdd$var$ProductIcon;

});

parcelRegister("fdjz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dad5bbc0d212096$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $bSJIT = parcelRequire("bSJIT");

var $kUjZS = parcelRequire("kUjZS");
const $0dad5bbc0d212096$var$SmartLinkBenefitImage = ({ productIcon: productIcon, providerIcon: providerIcon })=>{
    const productIconSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kUjZS.default), {
        icon: productIcon,
        x: 68,
        y: 58,
        w: 24,
        h: 24
    });
    const providerIconSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kUjZS.default), {
        icon: providerIcon,
        x: 98.8,
        y: 217.1,
        w: 20,
        h: 20
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("svg", {
        width: "100%",
        viewBox: "0 0 440 660",
        preserveAspectRatio: "xMidYMin meet",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("g", {
        clipPath: "url(#clip0_3120_9396)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("g", {
        transform: "scale(1.3) translate(0, 0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M366.41 476.854C366.44 476.804 366.44 476.714 366.5 476.644C364.75 475.764 364.55 473.604 363.2 472.314L363.15 472.264C361.78 471.824 362.15 470.454 360.45 470.444C360.45 470.444 360.89 470.224 360.9 470.224C358.14 467.484 351.32 460.754 351.32 460.754C351.17 461.364 352.41 460.304 353.66 460.484C353.66 460.484 353.75 460.254 353.84 460.434C357.03 457.324 360.62 456.134 364.7 454.654C366.74 454.104 367.05 448.334 363.56 450.724C363.52 450.684 363.43 450.654 363.39 450.584C362.17 452.004 360.14 451.484 358.6 452.224L358.54 452.254L355.98 453.504C354.59 454.074 352.94 454.524 351.21 454.964C351.26 454.914 351.31 454.864 351.36 454.814C351.36 454.814 351.54 452.044 351.49 450.674C351.49 450.674 353.24 448.474 352.66 446.964C353.65 445.194 357.17 441.324 353.97 440.224C352.92 440.224 352.1 439.314 351.74 441.004C351.68 440.994 351.6 441.014 351.52 440.984C351.33 442.734 349.26 443.974 348.69 445.634L348.67 445.704C348.81 447.124 347.71 448.524 347.7 448.524C347.18 449.824 346.5 451.244 345.78 452.724C345.48 451.924 345.15 451.214 344.82 450.704C343.62 449.404 344.13 431.644 339.69 435.564C339.9 438.914 340.96 442.404 340.1 445.384C339.68 445.614 340.32 446.804 340.84 447.774C340.8 449.004 340.55 449.664 340.48 451.424C338.28 449.834 328.68 441.784 329.27 447.204C330.3 447.754 331.05 448.384 331.59 449.664C332.09 450.214 336.5 452.694 336.64 453.314C336.35 454.174 341.56 454.864 339.45 455.504C339.76 456.184 340.18 456.834 340.67 457.464C338.39 457.704 335.66 458.374 334.23 459.244C333.98 459.674 324.88 460.254 321.58 462.384C319.61 463.494 317.87 464.044 319.92 465.714C320.66 465.114 323.44 465.974 323.38 465.184C324.06 465.464 328.66 463.704 329.17 464.004C329.42 464.404 333.04 462.284 332.61 463.284C335.12 463.994 338.18 463.414 341.36 462.604C340.1 464.604 338.86 467.454 338.7 469.224C337.62 471.494 334.77 476.514 333.86 479.594C332.56 481.834 333.01 482.014 334.65 483.164L334.68 483.194C335.02 483.424 334.64 483.194 335.93 483.244C335.8 483.124 335.61 482.604 335.36 482.694C335.53 482.344 337.49 481.844 336.67 481.374C336.64 481.304 337.92 480.324 338.05 479.264C339.19 475.484 341.92 473.574 343.94 469.264C343.89 469.714 347.29 478.184 347.13 482.404C346.88 484.484 351.92 487.584 351.19 482.944C351.25 482.924 351.3 482.844 351.39 482.834C350.58 480.924 351.65 478.954 351.23 477.014L351.21 476.934C350.3 475.754 351.35 474.774 349.91 473.814C349.91 473.814 350.4 473.864 350.41 473.874C349.77 471.124 349.37 467.764 348.77 464.754C350.92 466.704 352.81 468.804 353.59 471.114L353.69 470.964C353.69 471.034 353.84 471.084 353.71 471.244C355.52 471.624 356.14 472.384 357.45 472.894C357.45 472.894 358.85 475.424 360.48 475.514L362.96 479.024C364.03 480.834 369.8 479.794 366.45 476.894L366.41 476.854Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "44",
        y: "42",
        width: "417",
        height: "618",
        rx: "12",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2249 94)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2126 112.083)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2007 130.165)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2324 385)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2205 403)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "271.987",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2083 421)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "26.8308",
        height: "7.5752",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 342.951 94.4097)",
        fill: "#D3F1A7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "34.6884",
        height: "12.9096",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 370.104 80.0767)",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M368.765 80.1709L370.08 80.1759L369.983 102.033L368.668 102.028L368.765 80.1709Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "26.1985",
        height: "2.5257",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 373.772 85.4707)",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "62",
        height: "8",
        transform: "matrix(1 -0.000310775 -0.000336467 1 100.479 66.0459)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "31",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 211.886 238.778)",
        fill: "#94C748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "50",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 226.663 254.858)",
        fill: "#FBD779"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "40",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 217.979 270.451)",
        fill: "#C97CF4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "40",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 262.94 286.163)",
        fill: "#357DE8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("g", {
        clipPath: "url(#clip2_3120_9396)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M223.554 267.082C223.289 267.367 222.539 267.001 222.639 266.641C222.787 266.127 222.999 265.621 223.339 265.003C223.771 264.319 224.027 264.224 224.276 263.745C224.733 262.944 225.285 261.498 225.416 261.145C225.438 261.092 225.457 261.045 225.493 260.999C225.523 260.949 225.521 260.997 225.564 260.954C225.571 260.942 225.581 260.939 225.582 260.923C225.582 260.923 225.572 260.91 225.569 260.9L225.556 260.893C225.509 260.87 225.462 260.846 225.415 260.822C224.942 260.621 224.374 260.389 223.818 260.195C222.789 259.785 222.154 259.534 221.821 259.405C221.041 259.089 220.483 258.781 219.969 258.415C219.687 258.215 219.976 257.579 220.329 257.63C220.971 257.722 221.594 257.877 222.381 258.181C222.683 258.302 223.405 258.379 224.317 258.706C224.469 258.759 224.609 258.83 224.739 258.92C225.112 259.158 225.543 259.386 225.945 259.574L226.093 259.649C226.18 259.678 226.254 259.715 226.331 259.746C226.499 259.816 226.66 259.882 226.811 259.95C227.121 260.075 227.396 260.183 227.628 260.277C227.337 260.799 227.177 261.097 227.177 261.097C227.177 261.097 225.861 263.422 225.305 264.405C224.914 265.094 224.726 265.426 224.608 265.625C224.255 266.236 223.925 266.69 223.55 267.088L223.554 267.082Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M211.197 241.523C212.078 240.978 212.545 241.643 211.861 242.255C210.914 243.162 210.001 244.175 209.137 245.648C208.645 246.479 208.376 247.02 208.168 247.504C207.953 247.984 207.802 248.415 207.69 249.06C207.488 250.152 207.549 251.652 207.875 252.924C208.02 253.562 208.273 254.135 208.458 254.601C208.696 255.052 208.879 255.404 208.984 255.594C209.058 255.705 209.129 255.821 209.192 255.934C209.397 256.353 210.037 257.478 211.223 258.622C211.797 259.212 212.55 259.749 213.357 260.24C214.182 260.7 215.077 261.115 216 261.35C216.634 261.56 217.235 261.648 217.774 261.752C218.322 261.813 218.805 261.865 219.234 261.89C220.098 261.917 220.732 261.861 221.161 261.813C223.198 261.565 224.664 261.06 226.063 260.448C226.812 260.095 227.271 260.643 226.549 261.172C225.23 262.091 223.63 262.835 221.343 263.124C220.478 263.217 218.562 263.598 215.947 262.954C215.532 262.832 215.106 262.728 214.724 262.534C213.033 261.802 211.304 260.632 210.175 259.525C209.878 259.261 209.626 258.996 209.418 258.745C209.209 258.493 208.995 258.296 208.864 258.092C208.579 257.705 208.407 257.48 208.407 257.48C208.407 257.48 208.346 257.392 208.236 257.24C208.14 257.078 208.003 256.839 207.834 256.551C207.489 255.972 207.111 255.126 206.816 254.168C206.184 252.249 206.242 249.858 206.558 248.501C207.012 246.456 207.592 245.564 207.882 245.017C208.855 243.374 210.003 242.319 211.197 241.523Z",
        fill: "#292A2E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "72",
        y: "161",
        width: "347",
        height: "207",
        rx: "6",
        fill: "#8FB8F6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        x: "66.75",
        y: "155.75",
        width: "348.5",
        height: "207.5",
        rx: "3.25",
        fill: "#F9FBFD",
        stroke: "#8FB8F6",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 103.012 173.165)",
        fill: "#D0DEF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("mask", {
        id: "path-49-inside-1_3120_9396",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M103 206H379V362H103V206Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M103 206H379V362H103V206Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M103 206V205H102V206H103ZM379 206H380V205H379V206ZM103 206V207H379V206V205H103V206ZM379 206H378V362H379H380V206H379ZM103 362H104V206H103H102V362H103Z",
        fill: "#0B120E",
        fillOpacity: "0.14",
        mask: "url(#path-49-inside-1_3120_9396)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 224.002)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "237.496",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 242.005)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "237.496",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 260.005)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M61.3378 122.737C61.6171 122.177 58.1342 113.118 57.2561 115.732C56.801 116.617 57.0322 117.422 58.0247 117.666C56.2623 117.985 59.0352 119.646 58.611 120.492C57.284 120.234 60.4323 122.647 59.0166 122.206C59.6449 132.085 75.9612 151.538 63.6634 127.589C63.5817 130.007 62.6201 127.756 62.6812 126.669C64.6157 128.167 62.2943 123.699 61.5656 122.884C61.8811 124.279 60.2179 122.01 61.3344 122.741L61.3378 122.737Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M49.5857 140.943C49.2459 139.662 39.2484 134.515 38.2637 133.861C35.9524 132.802 36.384 135.758 38.2594 136.193C38.6122 136.426 41.3136 137.197 40.3497 137.823C41.4171 140.321 46.0137 140.555 46.7236 142.668C47.2511 142.314 48.1137 143.046 48.4778 142.865C48.5362 143.497 49.4685 143.827 49.5152 143.674C52.2908 146.31 54.2499 142.903 50.7524 141.538C50.8676 141.425 50.1541 140.706 49.5943 140.943L49.5857 140.943Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M39.4701 174.033C41.1809 175.147 39.6046 175.107 38.7741 174.555C39.8901 173.487 36.7954 173.565 36.0723 173.932C36.4066 173.988 36.5682 174.533 35.8805 174.456C36.2338 173.13 27.5479 172.249 31.8883 175.362C32.0358 175.367 32.0059 174.299 32.2092 174.645C32.0627 176.249 33.3227 175.211 33.6952 175.114C33.7617 175.957 34.0569 175.199 34.1847 175.555C33.8165 176.657 35.8605 174.913 35.4289 176C37.5666 177.865 41.2905 175.863 42.9467 177.541C43.8244 175.717 50.427 179.002 47.6545 175.204C44.8439 174.19 42.5606 173.57 39.4701 174.033Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M21.2561 153.478C20.8018 156.036 26.7133 155.89 28.429 157.072C30.5261 158.735 52.0689 165.506 46.1376 159.992C39.609 157.994 34.4269 155.302 26.3618 153.802C25.0538 153.469 20.9211 151.644 21.2561 153.478Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M82.7198 134.846C85.0673 136.492 82.5184 138.446 84.4665 139.99C88.1502 142.366 87.5201 123.15 84.0027 123.526C81.095 124.254 83.8998 133.561 82.7198 134.846Z",
        fill: "#101214"
    }), productIconSlot), providerIconSlot), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "paint0_linear_3120_9396",
        x1: "89.6875",
        y1: "172.49",
        x2: "89.6875",
        y2: "177.111",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "#1A237E",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "#1A237E",
        stopOpacity: "0.02"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("radialGradient", {
        id: "paint1_radial_3120_9396",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(77.4644 167.395) scale(24.8062 23.319)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("clipPath", {
        id: "clip0_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "440",
        height: "660",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("clipPath", {
        id: "clip1_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "matrix(1 -0.000310775 -0.000336467 1 68.0081 58.0562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("clipPath", {
        id: "clip2_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("rect", {
        width: "18.4543",
        height: "24.9028",
        fill: "white",
        transform: "matrix(-0.507908 0.846939 0.903773 0.454122 212.523 240.466)"
    }))));
};
var $0dad5bbc0d212096$export$2e2bcd8739ae039 = $0dad5bbc0d212096$var$SmartLinkBenefitImage;

});
parcelRegister("kUjZS", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c932dde2bba9b35$export$2e2bcd8739ae039);
/* IconSlot.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $9c932dde2bba9b35$var$iconSlotDivStyles = null;
const $9c932dde2bba9b35$var$IconSlot = ({ icon: icon, x: x, y: y, w: w, h: h })=>{
    if (!icon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("foreignObject", {
        x: x,
        y: y,
        width: w,
        height: h
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_2rko12b0 _1reo15vq _18m915vq _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, icon));
};
var $9c932dde2bba9b35$export$2e2bcd8739ae039 = $9c932dde2bba9b35$var$IconSlot;

});





parcelRegister("5hBRh", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $4b34fbb4ede0aa57$export$aff6291803939b05);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $gxIo9 = parcelRequire("gxIo9");

var $1qPbZ = parcelRequire("1qPbZ");

var $5kJPq = parcelRequire("5kJPq");

var $fqW9V = parcelRequire("fqW9V");

var $5DqMY = parcelRequire("5DqMY");

var $gy3md = parcelRequire("gy3md");

var $hdeqO = parcelRequire("hdeqO");

var $j33qf = parcelRequire("j33qf");

var $baS2a = parcelRequire("baS2a");

var $5mFSp = parcelRequire("5mFSp");

var $jZOah = parcelRequire("jZOah");

var $l8TFE = parcelRequire("l8TFE");

var $cgUng = parcelRequire("cgUng");
const $4b34fbb4ede0aa57$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "smart-card-inline-card"
    }), children);
const $4b34fbb4ede0aa57$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    var _details$meta2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $gy3md.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5kJPq.SmartLinkStatus).Resolved ? (0, $5DqMY.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $bSJIT.useEffect)(()=>{
        var _details$meta;
        switch(status){
            case (0, $5kJPq.SmartLinkStatus).Resolved:
                onResolve === null || onResolve === void 0 || onResolve({
                    url: url,
                    title: resolvedProps.title,
                    extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
                });
                break;
            case (0, $5kJPq.SmartLinkStatus).Errored:
            case (0, $5kJPq.SmartLinkStatus).Fallback:
            case (0, $5kJPq.SmartLinkStatus).Forbidden:
            case (0, $5kJPq.SmartLinkStatus).NotFound:
            case (0, $5kJPq.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4b34fbb4ede0aa57$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l8TFE.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            }));
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jZOah.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $gxIo9.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cgUng.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $gxIo9.extractSmartLinkProvider)(details);
            const cardMetadata = (details === null || details === void 0 ? void 0 : details.meta) ?? (0, $hdeqO.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $fqW9V.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: (providerForbidden === null || providerForbidden === void 0 ? void 0 : providerForbidden.text) ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5mFSp.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden === null || providerForbidden === void 0 ? void 0 : providerForbidden.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $gxIo9.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $baS2a.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j33qf.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline,
                viewType: "errored"
            });
    }
};

});
parcelRegister("baS2a", function(module, exports) {
$parcel$export(module.exports, "InlineCardErroredView", () => $e30defc537b6d64a$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hkLEY = parcelRequire("hkLEY");

var $7wYyA = parcelRequire("7wYyA");

var $10h0y = parcelRequire("10h0y");

var $gmFrz = parcelRequire("gmFrz");

var $gd4UU = parcelRequire("gd4UU");

var $jNvPl = parcelRequire("jNvPl");
const $e30defc537b6d64a$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        testId: "errored-view-default-icon"
    });
};
const $e30defc537b6d64a$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gmFrz.ActionButton), {
            onClick: handleRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).try_again));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconAndTitleLayout), {
        icon: icon || $e30defc537b6d64a$var$fallbackIcon(),
        link: hashAction ? url : undefined,
        title: url,
        onClick: hashAction ? onClick : undefined,
        rightSide: message
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10h0y.HoverCard), {
        url: url
    }, content);
    return content;
};

});

parcelRegister("5mFSp", function(module, exports) {
$parcel$export(module.exports, "InlineCardForbiddenView", () => $e51ba6f6334ef04a$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $5FomD = parcelRequire("5FomD");

var $gXqq0 = parcelRequire("gXqq0");

var $7wYyA = parcelRequire("7wYyA");

var $10h0y = parcelRequire("10h0y");

var $gmFrz = parcelRequire("gmFrz");

var $3r14S = parcelRequire("3r14S");

var $gd4UU = parcelRequire("gd4UU");

var $jNvPl = parcelRequire("jNvPl");
const $e51ba6f6334ef04a$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $e51ba6f6334ef04a$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FomD))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "forbidden-view-fallback-icon"
    });
};
const $e51ba6f6334ef04a$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(!!(requestAccessContext !== null && requestAccessContext !== void 0 && requestAccessContext.callToActionMessageKey));
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else {
            var _requestAccessContext;
            requestAccessContext === null || requestAccessContext === void 0 || (_requestAccessContext = requestAccessContext.action) === null || _requestAccessContext === void 0 || _requestAccessContext.promise();
        }
    }, [
        onAuthorise,
        requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        if (requestAccessContext !== null && requestAccessContext !== void 0 && requestAccessContext.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
                ...(0, $7wYyA.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).invalid_permissions, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, formattedMessage));
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        const accessType = requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gmFrz.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account"
            }, renderForbiddenAccessMessage());
        }
        if (onAuthorise) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
            xcss: $e51ba6f6334ef04a$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3r14S.default), {
            appearance: "moved",
            isBold: true
        }, renderForbiddenAccessMessage()));
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.accessType
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconAndTitleLayout), {
        icon: icon ? icon : $e51ba6f6334ef04a$var$fallbackForbiddenIcon(),
        link: url,
        title: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10h0y.HoverCard), {
        url: url
    }, content);
    return content;
};

});

parcelRegister("l8TFE", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvingView", () => $7557e8505fb0041e$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $hDkm2 = parcelRequire("hDkm2");

var $gd4UU = parcelRequire("gd4UU");

var $jNvPl = parcelRequire("jNvPl");

var $5nEQa = parcelRequire("5nEQa");
const $7557e8505fb0041e$var$styles = {
    spinnerWrapper: "_11c8wadc _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7557e8505fb0041e$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            as: "span",
            xcss: $7557e8505fb0041e$var$styles.spinnerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), {
            size: 14,
            interactionName: "smart-card-inline-card-spinner"
        })), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconTitleWrapper), null, url, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5nEQa.RightIconPositionWrapper), null, renderSpinner())));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconAndTitleLayout), {
        icon: renderSpinner(),
        title: resolvingPlaceholder ?? url,
        titleTextColor: titleTextColor
    }));
};

});
parcelRegister("5nEQa", function(module, exports) {
$parcel$export(module.exports, "RightIconPositionWrapper", () => $9cff6e866a53e1ce$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $9cff6e866a53e1ce$export$91b164375b8037b5 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cgUng", function(module, exports) {
$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $fefb5899a2d1d258$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jDsoo = parcelRequire("jDsoo");

var $5FomD = parcelRequire("5FomD");

var $9PwDt = parcelRequire("9PwDt");
var $gXqq0 = parcelRequire("gXqq0");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $bcElg = parcelRequire("bcElg");

var $10h0y = parcelRequire("10h0y");

var $gmFrz = parcelRequire("gmFrz");

var $gd4UU = parcelRequire("gd4UU");

var $jNvPl = parcelRequire("jNvPl");
const $fefb5899a2d1d258$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FomD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    });
};
/**
 * When persisted personalization adoption from {@link getCachedProviderPctMapAndRefresh} is strictly below this value,
 * the pill uses exploratory "previewing" copy instead of a percentage headline.
 */ const $fefb5899a2d1d258$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD = 30;
const $fefb5899a2d1d258$var$SOCIAL_PROOF_TRAIT_NAME = 'sl_3p_connected_providers_site_pct';
const $fefb5899a2d1d258$var$socialProofPillStyles = {
    strong: "_k48pwu06",
    root: "_2rko12b0 _1e0c1nu9 _4cvr1h6o _vchhusvi _p12f1osq _bfhk1dpa _syazazsu _y3gn18uv _1wybtjj4 _s7n4t94y _ca0qv77o _n3tdv77o _u5f312x7 _19bv12x7 _2hwx1b66 _irr3plhp _1di61gdz",
    label: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    wrappingLabel: "_1reoewfl _18m9ewfl _1btozryt _o5721btx _1nmz9jpi",
    button: "_bfhk1j28 _u5f3ze3t _19bvze3t _ca0qze3t _n3tdze3t",
    pressableContents: "_1e0c1bgi",
    inlineGroup: "_1e0c1nu9"
};
/**
 * Renders the social-proof pill and Connect button using persisted percentages only ({@link getCachedProviderPctMapAndRefresh}) — no
 * loading skeleton; either the cached percentage is shown or the legacy long connect label is used.
 * Only mounted when the card has an authorisation action.
 */ const $fefb5899a2d1d258$var$UnauthorisedConnectWithSocialProof = ({ context: context, extensionKey: extensionKey, testId: testId, onConnectClick: onConnectClick })=>{
    const providerPctMap = (0, $bcElg.getCachedProviderPctMapAndRefresh)($fefb5899a2d1d258$var$SOCIAL_PROOF_TRAIT_NAME);
    // Will be false if this is the first render, when we fetch traits and store to local storage,
    // or if there wasn't our trait for it.
    const isProviderPctMapLoaded = providerPctMap !== null;
    // Percent of current user team (same tenant users) who are connected to this extension.
    const connectedPct = extensionKey && isProviderPctMapLoaded ? providerPctMap[extensionKey] : undefined;
    const trimmedProviderDisplayName = (context === null || context === void 0 ? void 0 : context.trim()) ?? '';
    const hasProviderDisplayName = trimmedProviderDisplayName.length > 0;
    const isSocialProofUsageHighEnough = connectedPct !== undefined && connectedPct >= $fefb5899a2d1d258$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD;
    // Show the social proof pill once the trait data is available.
    const showSocialProofPill = isProviderPctMapLoaded;
    const bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            as: "strong",
            xcss: $fefb5899a2d1d258$var$socialProofPillStyles.strong
        }, chunks);
    // As long as pill is shown it will be one of four messages depending on percent and provider presence:
    // - 45% of your team sees Figma previews
    // - 45% of your team sees richer previews
    // - Your team sees richer Figma previews
    // - Your team sees richer previews
    const socialProofPillContent = isSocialProofUsageHighEnough ? hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).social_proof_inline_cta_tag_high_with_context,
        values: {
            connectedPct: connectedPct,
            context: trimmedProviderDisplayName,
            b: bold
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).social_proof_inline_cta_tag_high_no_context,
        values: {
            connectedPct: connectedPct,
            b: bold
        }
    }) : hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).social_proof_inline_cta_tag_low_with_context,
        values: {
            context: trimmedProviderDisplayName
        }
    }) : // Unlikely case, but possible from TS standpoint.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).social_proof_inline_cta_tag_low_no_context);
    const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $fefb5899a2d1d258$var$socialProofPillStyles.root,
        testId: `${testId}-social-proof-tag`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: (0, $jDsoo.cx)($fefb5899a2d1d258$var$socialProofPillStyles.label, $fefb5899a2d1d258$var$socialProofPillStyles.wrappingLabel)
    }, socialProofPillContent)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gmFrz.ActionButton), {
        onClick: onConnectClick,
        viewType: "unauthorised",
        testId: "button-connect-account",
        isSlimDesign: showSocialProofPill
    }, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).connect_inline_social_proof) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).connect_link_account_card_name,
        values: {
            context: context
        }
    })));
    return showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
        onClick: onConnectClick,
        style: {
            font: `inherit`
        },
        xcss: (0, $jDsoo.cx)($fefb5899a2d1d258$var$socialProofPillStyles.button, $fefb5899a2d1d258$var$socialProofPillStyles.pressableContents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $fefb5899a2d1d258$var$socialProofPillStyles.inlineGroup
    }, buttonContent)) : buttonContent;
};
const $fefb5899a2d1d258$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context, extensionKey: extensionKey })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        viewType: "unauthorised"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNvPl.IconAndTitleLayout), {
        icon: icon ? icon : $fefb5899a2d1d258$var$fallbackUnauthorizedIcon(),
        title: url,
        link: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), onAuthorise && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($fefb5899a2d1d258$var$UnauthorisedConnectWithSocialProof, {
        context: context,
        extensionKey: extensionKey,
        testId: testId,
        onConnectClick: handleConnectAccount
    }));
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10h0y.HoverCard), {
        url: url,
        id: id
    }, inlineCardUnauthenticatedView);
    return inlineCardUnauthenticatedView;
};

});
parcelRegister("bcElg", function(module, exports) {
$parcel$export(module.exports, "getCachedProviderPctMapAndRefresh", () => $56d491bfec77c99f$export$63f5703c889fdfe6);

var $ifdjD = parcelRequire("ifdjD");

var $g3xfg = parcelRequire("g3xfg");

var $fHq2q = parcelRequire("fHq2q");

var $8MFqk = parcelRequire("8MFqk");
function $56d491bfec77c99f$export$63f5703c889fdfe6(traitName) {
    const cloudId = (0, $g3xfg.getCurrentSiteCloudIdSync)();
    const providerPctMap = (0, $8MFqk.getProviderPctMapSync)(cloudId, traitName);
    (0, $ifdjD.getCurrentSiteCloudId)().then((resolvedCloudId)=>{
        (0, $fHq2q.getProviderPctMap)(resolvedCloudId, traitName);
    });
    return providerPctMap;
}

});



parcelRegister("42OOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $66c6327b0e68ee9c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $6n63z = parcelRequire("6n63z");

var $9J111 = parcelRequire("9J111");

var $3Vl0U = parcelRequire("3Vl0U");
const $66c6327b0e68ee9c$var$withCardIntersectionObserver = (Component)=>(props)=>{
        // TODO: NAVX-4682: Add feature parity to LazyIntersectionObserverCard for no lazy loading
        const { appearance: appearance, children: children, id: id, onError: onErrorCallback, ui: ui, url: url = '' } = props;
        const { onIntersecting: onIntersecting, onStatusSettled: onStatusSettled } = (0, $9J111.useSmartLinkSeenEvent)({
            appearance: appearance,
            children: children,
            id: id,
            ui: ui,
            url: url
        });
        const onError = (0, $bSJIT.useCallback)((data)=>{
            if (data !== null && data !== void 0 && data.status) onStatusSettled(data.status);
            onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback(data);
        }, [
            onStatusSettled,
            onErrorCallback
        ]);
        const ref = (0, $6n63z.default)({
            onIntersecting: onIntersecting
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3Vl0U.default), {
            appearance: props.appearance,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
            ...props,
            onError: onError
        }));
    };
var $66c6327b0e68ee9c$export$2e2bcd8739ae039 = $66c6327b0e68ee9c$var$withCardIntersectionObserver;

});

parcelRegister("l4Eiq", function(module, exports) {
$parcel$export(module.exports, "default", () => $88ea5a53ba7db104$export$2e2bcd8739ae039);

var $6bOBo = parcelRequire("6bOBo");

var $gdUUy = parcelRequire("gdUUy");

var $gy3md = parcelRequire("gy3md");

var $kZy1a = parcelRequire("kZy1a");

var $cUXyD = parcelRequire("cUXyD");

var $4SD6o = parcelRequire("4SD6o");

var $1R1LG = parcelRequire("1R1LG");
const $88ea5a53ba7db104$var$useExperimentMetaEventAttributes = ({ actionOptions: actionOptions, appearance: appearance, state: state })=>{
    var _actionOptions$rovoCh;
    const { connections: { client: { baseUrlOverride: baseUriWithNoTrailingSlash } } } = (0, $6bOBo.useSmartLinkContext)();
    const { rovoOptions: rovoOptions, product: product } = (0, $cUXyD.default)();
    const { details: details, status: status } = state;
    const extensionKey = (0, $gy3md.getExtensionKey)(details);
    const embedRovoActionsFooterExperimentMeta = appearance === 'embed' && status === 'resolved' ? (0, $kZy1a.getEmbedRovoActionsFooterExperimentMeta)({
        extensionKey: extensionKey,
        isRovoChatActionOptedIn: (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false,
        isRovoChatEnabled: (0, $1R1LG.getIsRovoChatEnabled)(rovoOptions),
        product: product
    }) : undefined;
    const blockSocialProofExperimentMeta = appearance === 'block' && status === 'unauthorized' && (0, $gdUUy.fg)('social-proof-3p-unauth-block-fg') ? (0, $4SD6o.getSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const experimentMeta = {
        ...blockSocialProofExperimentMeta,
        ...embedRovoActionsFooterExperimentMeta
    };
    if (Object.keys(experimentMeta).length > 0) return experimentMeta;
};
var $88ea5a53ba7db104$export$2e2bcd8739ae039 = $88ea5a53ba7db104$var$useExperimentMetaEventAttributes;

});
parcelRegister("kZy1a", function(module, exports) {
$parcel$export(module.exports, "getEmbedRovoActionsFooterExperimentMeta", () => $57c2b593c4eb0eaa$export$d92e090f28e31112);

var $gdUUy = parcelRequire("gdUUy");

var $4zjoa = parcelRequire("4zjoa");

var $5axXA = parcelRequire("5axXA");

var $jyaKA = parcelRequire("jyaKA");
const $57c2b593c4eb0eaa$var$isEmbedRovoActionsFooterKillSwitchEnabled = (product)=>{
    return product === 'CONFLUENCE' && (0, $gdUUy.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch');
};
const $57c2b593c4eb0eaa$var$isEmbedRovoActionsFooterExperimentEnabledNoExposure = (product)=>{
    return $57c2b593c4eb0eaa$var$isEmbedRovoActionsFooterKillSwitchEnabled(product) && (0, $4zjoa.expValEqualsNoExposure)((0, $5axXA.EMBED_ROVO_ACTIONS_FOOTER_EXPERIMENT_KEY), 'isEnabled', true);
};
const $57c2b593c4eb0eaa$export$d92e090f28e31112 = ({ extensionKey: extensionKey, isRovoChatActionOptedIn: isRovoChatActionOptedIn, isRovoChatEnabled: isRovoChatEnabled, product: product })=>{
    const isEligible = $57c2b593c4eb0eaa$var$isEmbedRovoActionsFooterKillSwitchEnabled(product) && isRovoChatEnabled && isRovoChatActionOptedIn && (0, $jyaKA.isEligibleEmbedRovoActionsFooterExtensionKey)(extensionKey);
    if (!isEligible) return undefined;
    return {
        [(0, $5axXA.EMBED_ROVO_ACTIONS_FOOTER_EXPERIMENT_KEY)]: {
            isEligible: true,
            isTreatment: $57c2b593c4eb0eaa$var$isEmbedRovoActionsFooterExperimentEnabledNoExposure(product)
        }
    };
};

});




//# sourceMappingURL=shared.c8ed93e5.js.map
